var _metadata, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRalewayBoldItalic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20170731 at Thu Feb  4 21:54:21 2016\n By Aleksey,,,\nCopyright (c) 2010 - 2012, Matt McInerney (matt@pixelspread.com), Pablo Impallari (impallari@gmail.com), Rodrigo Fuenzalida (hello@rfuenzalida.com) with Reserved Font Name \"Raleway\"\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "Raleway-BoldItalic",
    horizAdvX: 624
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Raleway",
    fontWeight: 700,
    fontStyle: "italic",
    fontStretch: "normal",
    unitsPerEm: 1000,
    panose1: "2 11 8 3 3 1 1 6 0 3",
    ascent: 800,
    descent: -200,
    xHeight: 524,
    capHeight: 709,
    bbox: "-240 -229 1340 930",
    underlineThickness: 50,
    underlinePosition: -150,
    slope: -12,
    unicodeRange: "U+000D-FB06"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f",
    unicode: "ff",
    horizAdvX: 621,
    d: "M108 394h-64l22 102h64l3 13q10 41 29 76.5t46.5 62t62 41.5t74.5 15q32 0 61.5 -8t57.5 -21q29 30 65.5 47.5t81.5 17.5q36 0 63 -10t52 -21l-48 -101q-12 7 -27.5 12.5t-35.5 5.5q-38 0 -60.5 -28t-30.5 -65l-8 -37h128l-21 -102h-128l-84 -394h-134l84 394h-119 l-83 -394h-134zM382 496q4 19 10.5 41t14.5 39q-13 8 -29 11t-30 3q-35 0 -55 -21.5t-26 -55.5l-3 -17h118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_i",
    unicode: "fi",
    horizAdvX: 552,
    d: "M108 394h-64l22 102h64l7 32q9 43 31 82t55 67.5t75 45.5t90 17q54 0 96 -18.5t78 -46.5l-74 -100q-21 23 -51.5 37t-63.5 14q-42 0 -67.5 -28t-33.5 -65l-8 -37h270l-106 -496h-134l83 394h-135l-83 -394h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_l",
    unicode: "fl",
    horizAdvX: 633,
    d: "M446 -8q-54 0 -81 25.5t-27 63.5q0 15 4 34l86 402q6 27 6 47q0 26 -12.5 44t-47.5 18q-45 0 -70 -31t-36 -81l-4 -18h81l-21 -102h-82l-83 -394h-134l83 394h-64l22 102h64l10 44q21 97 88 148.5t166 51.5q93 0 136.5 -39t43.5 -104q0 -25 -6 -53l-79 -373 q-1 -5 -1.5 -9t-0.5 -9q0 -16 7.5 -28.5t26.5 -12.5q8 0 18.5 2t19.5 4.5t15.5 4.5l6.5 2l-7 -108q-1 -1 -13 -5t-30 -8.5t-40.5 -8t-44.5 -3.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_i",
    unicode: "ffi",
    horizAdvX: 804,
    d: "M108 394h-64l22 102h64l3 13q9 40 28 75.5t46.5 62t62.5 42t75 15.5q32 0 61.5 -8t57.5 -21q32 30 76.5 47.5t98.5 17.5q49 0 93 -18t82 -47l-74 -100q-20 22 -50.5 36.5t-61.5 14.5q-44 0 -70 -28t-34 -65l-8 -37h270l-105 -496h-135l84 394h-135l-84 -394h-134l84 394 h-119l-83 -394h-134zM382 496q4 19 10.5 41t14.5 39q-13 8 -29 11t-30 3q-35 0 -54.5 -22.5t-26.5 -54.5l-3 -17h118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_l",
    unicode: "ffl",
    horizAdvX: 886,
    d: "M699 -8q-54 0 -81.5 25.5t-27.5 63.5q0 9 1.5 17t4.5 20l86 403q5 25 5 42q0 27 -13.5 45t-49.5 18q-22 0 -38.5 -9t-29.5 -25t-21.5 -36.5t-13.5 -43.5l-4 -16h81l-22 -102h-81l-83 -394h-134l83 394h-119l-83 -394h-134l83 394h-64l22 102h64l3 13q9 41 29 76.5 t47.5 62t62.5 41.5t75 15q33 0 61.5 -8t55.5 -21q70 65 183 65q93 0 136.5 -39t43.5 -104q0 -25 -6 -53l-80 -373q-1 -5 -1.5 -9t-0.5 -9q0 -16 7.5 -28.5t27.5 -12.5q8 0 18 2t19 4.5t15.5 4.5t7.5 2l-7 -108q-1 -1 -13 -5t-30 -8.5t-40.5 -8t-44.5 -3.5zM383 496 q5 20 10.5 42.5t12.5 38.5q-13 8 -27.5 10.5t-27.5 2.5q-33 0 -55.5 -23t-28.5 -53l-3 -18h119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    unicode: "\r",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "NULL",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "NULL",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 236
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 290,
    d: "M71 267l95 450h134l-95 -450h-134zM14 0l32 151h134l-32 -151h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 387,
    d: "M100 499l47 224h114l-47 -224h-114zM255 499l48 224h114l-48 -224h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 692,
    d: "M682 424h-139l-59 -137h124l-21 -100h-148l-83 -187h-107l83 187h-106l-83 -187h-108l83 187h-106l21 100h131l58 137h-115l21 94h138l85 192h107l-85 -192h106l85 192h108l-86 -192h117zM377 287l59 137h-106l-58 -137h105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 611,
    d: "M533 524q-3 7 -16 17t-32 20.5t-43.5 19t-51.5 11.5l-37 -172q32 -9 67.5 -21t65 -31.5t49 -49t19.5 -74.5q0 -65 -24 -111t-63 -76.5t-90 -46t-105 -17.5l-23 -110h-59l23 111q-66 5 -124 28.5t-101 61.5l86 119q4 -8 19.5 -21t39 -25.5t53.5 -23.5t63 -15l36 171 l-35 11q-38 12 -66.5 26t-48 32t-29.5 41t-10 54q0 58 22 104t59 79.5t86 53t103 24.5l22 101h59l-22 -101q62 -5 110.5 -27.5t81.5 -50.5zM400 202q0 27 -21 43.5t-56 30.5l-34 -160q56 2 83.5 25t27.5 61zM247 499q0 -25 17.5 -40t51.5 -27l34 161q-51 -4 -77 -29.5 t-26 -64.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 760,
    d: "M219 417q-29 0 -53 9.5t-41 26.5t-26.5 40t-9.5 50q0 36 16.5 68t43.5 56.5t62 38.5t72 14q29 0 52.5 -9.5t40.5 -26.5t26.5 -40t9.5 -50q0 -36 -16 -68t-43 -56.5t-62 -38.5t-72 -14zM233 484q15 0 30.5 8.5t27.5 23t19.5 33t7.5 38.5q0 28 -13.5 47t-35.5 19 q-15 0 -30.5 -8.5t-27.5 -23t-19.5 -33t-7.5 -38.5q0 -28 13 -47t36 -19zM500 -10q-29 0 -52.5 9.5t-40.5 26.5t-26.5 40t-9.5 50q0 36 16 68t43 56.5t62 38.5t72 14q29 0 53 -9.5t41 -26.5t26 -40t9 -50q0 -36 -16 -68t-43 -56.5t-62 -38.5t-72 -14zM514 57q16 0 31 8.5 t27 22.5t19.5 33t7.5 39q0 28 -13.5 47t-35.5 19q-15 0 -30.5 -8.5t-28 -23t-20 -33t-7.5 -38.5q0 -28 14 -47t36 -19zM39 47l337 329l319 342l49 -54l-329 -324l-327 -347z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 697,
    d: "M399 67q-48 -38 -100 -57.5t-103 -19.5q-44 0 -77.5 14t-56.5 37.5t-35 55t-12 67.5q0 40 13.5 72.5t36.5 59.5t53 49.5t64 43.5q-26 40 -37 70.5t-11 62.5q0 42 18 78.5t49 62.5t71 41t84 15q60 0 107 -32t65 -95l-93 -52q-11 38 -36.5 59t-54.5 21q-17 0 -32 -6 t-27 -16t-19 -24t-7 -30q0 -20 14 -45t48 -74l117 -170q18 35 31.5 75t21.5 86h180l-15 -96h-81q-15 -43 -35 -80.5t-43 -69.5l119 -170h-171zM231 93q59 0 118 48l-110 162q-48 -29 -71 -57.5t-23 -66.5q0 -42 25 -64t61 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 232,
    d: "M100 499l47 224h114l-47 -224h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 304,
    d: "M35 263q0 66 18.5 127t51 121.5t76 121t93.5 124.5l93 -43q-39 -51 -76.5 -106.5t-66 -112.5t-46 -114t-17.5 -110q0 -62 14 -134.5t37 -140.5l-109 -49q-15 35 -27.5 74t-21.5 80t-14 82t-5 80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 304,
    d: "M289 431q0 -66 -19.5 -129t-52.5 -123t-76 -118t-91 -114l-87 49q43 56 79.5 109t63.5 105t42 105t15 109q0 42 -5.5 85.5t-13 83t-16.5 71.5t-16 50l112 43q28 -79 46.5 -163.5t18.5 -162.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 337,
    d: "M120 520l59 71l-62 22l30 58l62 -31l12 77h71l-21 -77l75 31l5 -58l-71 -22l30 -71l-59 -34l-27 75l-60 -75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 427,
    d: "M386 409v-108h-103v-113h-120v113h-104v108h104v113h120v-113h103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 230,
    d: "M-16 -115l53 119h-42l30 140h115l-30 -140l-65 -119h-61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 402,
    d: "M38 214l26 121h289l-26 -121h-289z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 224,
    d: "M-6 0l31 144h110l-31 -144h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 692,
    d: "M745 710l-624 -710h-148l624 710h148z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 594,
    d: "M231 -10q-44 0 -79.5 17.5t-60 48.5t-38 74t-13.5 94q0 77 26.5 145t71 118.5t102 80t120.5 29.5q44 0 79.5 -17.5t60 -48.5t38 -74.5t13.5 -94.5q0 -78 -26.5 -145.5t-71 -118t-102.5 -79.5t-120 -29zM257 113q31 0 59 18.5t50 51t35 75t13 90.5q0 56 -21 91t-59 35 q-32 0 -61 -19t-50.5 -51.5t-34.5 -75t-13 -90.5q0 -56 21.5 -90.5t60.5 -34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 478,
    d: "M25 121h135l65 303q-11 -12 -32 -24.5t-45.5 -23.5t-49 -18t-43.5 -7l27 125q17 0 44 11.5t54 27.5t48.5 31.5t27.5 24.5h137l-96 -450h121l-25 -121h-393z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 545,
    d: "M-26 0q10 45 24.5 81.5t38 67.5t58 58t84.5 52q46 24 81.5 41t59 32.5t35.5 32t12 39.5q0 25 -18 42.5t-53 17.5q-44 0 -80.5 -24t-67.5 -53l-64 99q16 14 43 30.5t61 31t74 24t83 9.5q86 0 130 -38.5t44 -100.5q0 -41 -15 -72.5t-39 -56t-53.5 -43t-57.5 -33.5 q-18 -9 -39.5 -21t-42.5 -26.5t-40 -32t-32 -36.5h263l-26 -121h-463v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 538,
    d: "M155 -147q-73 0 -123.5 24.5t-78.5 71.5l95 95q17 -33 47 -51t80 -18q69 0 104.5 31.5t35.5 89.5q0 41 -29 63t-90 22h-27l21 100h30q65 0 104.5 33t39.5 82q0 32 -21 48t-56 16q-42 0 -80.5 -21t-68.5 -59l-64 94q19 23 47.5 41.5t61.5 32t69.5 21t73.5 7.5 q88 0 137.5 -40t49.5 -107q0 -34 -13 -66t-34.5 -58.5t-50.5 -44.5t-62 -24q48 -9 74 -47t26 -93q0 -54 -22 -98.5t-61.5 -77t-94.5 -50t-120 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 553,
    d: "M238 22h-273l26 119l407 430h91l-91 -429h84l-26 -120h-84l-31 -149h-134zM279 142l48 226l-202 -226h154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 533,
    d: "M154 -149q-73 0 -125 33t-70 90l94 80q18 -39 51.5 -62t75.5 -23q29 0 54.5 11t45 30.5t30.5 45.5t11 57q0 41 -22.5 66t-60.5 25q-30 0 -59 -15t-49 -41h-117l22 55t30.5 76.5t34 86t33 84.5t28.5 72t20 49h333l-26 -122h-236l-58 -159q12 13 34.5 21t53.5 8 q41 0 74 -13.5t56.5 -37.5t36 -57.5t12.5 -73.5q0 -62 -24.5 -114.5t-66.5 -90.5t-98 -59.5t-118 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 592,
    d: "M236 -10q-93 0 -143 62.5t-50 171.5q0 101 26.5 190.5t74 156t114 105.5t146.5 39q63 0 111 -29t74 -83l-94 -84q-15 38 -46 59t-72 21q-61 0 -109 -53t-71 -150q28 36 68 57t86 21q43 0 78.5 -15t60.5 -41t38.5 -61.5t13.5 -76.5q0 -59 -25.5 -111.5t-68 -92t-97.5 -63 t-115 -23.5zM261 103q27 0 54 13t48.5 35t34.5 50.5t13 59.5q0 45 -26 75.5t-68 30.5q-28 0 -55 -12.5t-48 -33.5t-34 -49t-13 -59q0 -46 26 -78t68 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 546,
    d: "M361 461h-300l26 122h512l-486 -710h-152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 583,
    d: "M224 -9q-44 0 -81.5 13.5t-64.5 38.5t-42 59t-15 75q0 39 13.5 71t34.5 57.5t46.5 44t48.5 30.5q-26 14 -41.5 43.5t-15.5 64.5q0 52 26 93.5t66 70t87.5 43.5t90.5 15q35 0 69 -10.5t61 -31.5t43.5 -51.5t16.5 -70.5q0 -29 -10 -54.5t-26.5 -47t-37.5 -38t-43 -26.5 q29 -18 50.5 -54t21.5 -84q0 -55 -25 -101t-67 -79.5t-95.5 -52t-110.5 -18.5zM251 112q24 0 48.5 9.5t43.5 26.5t31 40t12 50q0 41 -26.5 63.5t-64.5 22.5q-25 0 -49 -9.5t-43 -26t-30.5 -39.5t-11.5 -50q0 -39 26.5 -63t63.5 -24zM317 425q18 0 37.5 6.5t35.5 19.5 t26.5 31t10.5 42q0 31 -21.5 49t-53.5 18q-21 0 -40.5 -7t-34.5 -20t-24.5 -31t-9.5 -39q0 -34 23 -51.5t51 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 574,
    d: "M170 -154q-63 0 -110.5 29t-74.5 83l94 84q15 -38 46 -59t72 -21q61 0 109 53t71 150q-28 -36 -68 -57t-86 -21q-43 0 -78 15t-60 41t-38.5 61.5t-13.5 76.5q0 58 25 111t67.5 92.5t97.5 63t115 23.5q93 0 143 -62.5t50 -171.5q0 -101 -26.5 -190.5t-74 -156t-114 -105.5 t-146.5 -39zM257 194q28 0 55 12.5t48 33.5t34 49t13 59q0 46 -26 78t-68 32q-27 0 -54 -13t-48.5 -35t-34.5 -50.5t-13 -59.5q0 -45 26 -75.5t68 -30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 244,
    d: "M82 374l31 144h109l-30 -144h-110zM3 0l31 144h109l-31 -144h-109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 247,
    d: "M83 374l30 144h110l-31 -144h-109zM-7 -115l52 119h-42l30 140h116l-30 -140l-66 -119h-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 550,
    d: "M29 288l422 255v-142l-227 -142l227 -136v-150l-422 250v65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 485,
    d: "M80 144v87h313v-87h-313zM80 321v87h313v-87h-313z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 550,
    d: "M502 223l-422 -250v150l227 136l-227 142v142l422 -255v-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 471,
    d: "M101 233q10 49 32.5 89t77.5 67q30 15 57.5 29.5t49 32t34.5 39.5t13 51q0 33 -20.5 51t-49.5 18q-20 0 -38 -7.5t-34 -19t-29 -26t-23 -27.5l-75 60q38 62 99.5 95.5t127.5 33.5q31 0 60.5 -9t52 -28t36 -48.5t13.5 -70.5q0 -44 -10.5 -76.5t-29.5 -56.5t-44 -42 t-54 -34q-22 -12 -44 -23t-40.5 -24.5t-32.5 -31t-19 -42.5h-110zM54 0l29 138h110l-29 -138h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 813,
    d: "M578 44q27 0 49.5 25t39 62.5t25.5 82t9 83.5q0 52 -16.5 98t-48.5 80t-78.5 54t-106.5 20q-74 0 -141.5 -30t-119 -82t-82.5 -122t-31 -151q0 -57 16 -104t46 -81t73.5 -52.5t98.5 -18.5q39 0 75 9.5t78 28.5l6 -52q-42 -20 -85 -30t-85 -10q-63 0 -114.5 22t-88.5 61.5 t-57 95.5t-20 125q0 96 38 177.5t100 141t142.5 93t164.5 33.5q68 0 122.5 -22.5t92.5 -61.5t58 -92t20 -114q0 -48 -13 -105.5t-38.5 -107t-64 -83t-89.5 -33.5q-32 0 -53 15.5t-21 50.5v9t1 8q-37 -34 -77 -52t-82 -18q-37 0 -66.5 14t-50.5 38.5t-32 58.5t-11 73 q0 55 20.5 106t55 90t79.5 62.5t93 23.5q51 0 83 -24.5t43 -62.5l14 74h68l-67 -335q-2 -8 -3 -17t-1 -16q0 -38 32 -38zM350 64q45 0 80.5 29t53.5 73l20 127q-10 45 -36.5 69.5t-62.5 24.5q-29 0 -58 -15t-52.5 -41.5t-38 -62t-14.5 -75.5q0 -55 29 -92t79 -37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 645,
    d: "M352 710h123l103 -710h-142l-22 177h-229l-96 -177h-142zM411 274l-31 279l-152 -279h183z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 656,
    d: "M161 710h364q30 0 52.5 -12.5t37.5 -32.5t22.5 -46t7.5 -54q0 -31 -9.5 -61t-27.5 -57t-43.5 -48.5t-56.5 -34.5q45 -15 69 -51.5t24 -89.5q0 -54 -22 -95.5t-59 -70t-85 -43t-99 -14.5h-326zM361 117q19 0 38 9t33.5 24.5t23.5 36t9 43.5q0 31 -15.5 52.5t-42.5 21.5 h-196l-39 -187h189zM404 413q18 0 35.5 8t31.5 22.5t22.5 35t8.5 45.5q0 31 -15 49.5t-40 18.5h-174l-38 -179h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 658,
    d: "M296 -6q-62 0 -110 25.5t-81 67.5t-50.5 96.5t-17.5 112.5q0 49 14 99t40.5 96.5t64 87t84 70.5t100.5 47.5t114 17.5q94 0 153.5 -43t77.5 -112l-121 -73q-6 30 -20 50.5t-33.5 32.5t-42 17.5t-44.5 5.5q-56 0 -102 -27t-78 -69t-49.5 -93t-17.5 -99q0 -38 10 -72 t29 -60t46.5 -41t63.5 -15q22 0 47.5 6t50 19t47 33.5t40.5 49.5l99 -65q-24 -40 -60.5 -70.5t-79 -51.5t-88 -32t-86.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 692,
    d: "M161 710h247q69 0 119.5 -21.5t83.5 -58.5t49 -87t16 -108q0 -94 -31.5 -173.5t-88 -137.5t-133 -91t-166.5 -33h-247zM282 121q57 0 103.5 24t79.5 64.5t51 93.5t18 112q0 78 -38.5 126t-113.5 48h-110l-99 -468h109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 578,
    d: "M161 710h460l-25 -121h-324l-36 -171h279l-24 -112h-279l-39 -185h332l-26 -121h-469z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 556,
    d: "M161 710h454l-26 -121h-317l-38 -183h262l-24 -112h-262l-63 -294h-137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 697,
    d: "M494 80q-51 -44 -100.5 -64.5t-102.5 -20.5q-57 0 -103.5 22.5t-80 61.5t-52 92.5t-18.5 115.5q0 86 35 163.5t93 136.5t133 93.5t155 34.5q95 0 154.5 -42t79.5 -113l-119 -76q-14 53 -52.5 81t-92.5 28q-50 0 -94 -24.5t-78 -65t-53.5 -93t-19.5 -108.5q0 -39 10.5 -73 t30 -59t47.5 -39t63 -14q96 0 193 97l11 50h-135l22 101h249l-78 -365h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 718,
    d: "M161 710h137l-61 -287h296l61 287h137l-151 -710h-137l64 303h-296l-64 -303h-137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 285,
    d: "M161 709h137l-151 -709h-137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 479,
    d: "M94 -11q-85 0 -137 44l54 112q10 -10 39 -22t70 -12q39 0 65 14.5t44 44.5t31 74.5t26 104.5l77 360h138l-77 -360q-17 -81 -39 -147.5t-58.5 -113.5t-92.5 -73t-140 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 643,
    d: "M161 709h137l-72 -337l345 338h154l-325 -315l190 -395h-156l-139 307l-103 -95l-45 -212h-137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 561,
    d: "M161 710h137l-125 -589h339l-25 -121h-477z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 830,
    d: "M161 710h148l107 -404l280 404h147l-151 -710h-137l100 470l-241 -350h-75l-92 350l-100 -470h-137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 733,
    d: "M161 710h107l242 -466l99 465h137l-151 -709h-111l-241 455l-96 -455h-137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 729,
    d: "M299 -5q-63 0 -112 24.5t-82.5 65.5t-50.5 94t-17 111q0 81 34.5 157.5t92.5 136t133.5 95.5t157.5 36q63 0 111.5 -25t81 -66t49.5 -95t17 -111q0 -80 -34 -156.5t-91.5 -135.5t-132.5 -95t-157 -36zM326 117q55 0 100.5 27t78.5 69t51 93.5t18 101.5q0 37 -9 70.5 t-27.5 58.5t-46.5 40t-65 15q-55 0 -101 -26.5t-79 -68.5t-51 -93.5t-18 -102.5q0 -37 9 -70t28 -58.5t46.5 -40.5t65.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 601,
    d: "M161 710h286q40 0 72 -16.5t54 -44t33.5 -63t11.5 -72.5q0 -50 -21 -99.5t-57.5 -88.5t-85 -63.5t-102.5 -24.5h-155l-50 -238h-137zM368 359q21 0 40.5 11t35 30.5t24.5 45.5t9 57q0 41 -19 63.5t-46 22.5h-140l-49 -230h145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 728,
    d: "M478 42q-42 -23 -87 -35t-93 -12q-63 0 -112 24.5t-82 65.5t-50.5 94t-17.5 111q0 81 34.5 157.5t92.5 136t133.5 95.5t157.5 36q63 0 111.5 -25t81.5 -66t50 -95t17 -111q0 -88 -40 -170t-107 -142l70 -106h-131zM326 117q24 0 46.5 5.5t43.5 15.5l-81 125h130l36 -56 q35 43 54 96t19 105q0 37 -9.5 70.5t-28 59t-46 40.5t-64.5 15q-55 0 -101 -26.5t-79 -68.5t-51 -94t-18 -103q0 -37 9 -70t28 -58.5t46.5 -40.5t65.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 642,
    d: "M10 0l151 710h300q40 0 72 -16.5t54 -44t33.5 -63t11.5 -72.5q0 -39 -13 -76.5t-35.5 -70.5t-53 -59t-66.5 -41l96 -267h-156l-84 238h-123l-50 -238h-137zM382 359q20 0 39.5 11.5t34.5 31t24.5 45t9.5 53.5q0 38 -18.5 63.5t-45.5 25.5h-154l-49 -230h159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 592,
    d: "M243 -8q-75 0 -144.5 24t-119.5 68l86 119q5 -9 23.5 -23.5t46 -29t63 -24.5t74.5 -10q60 0 89.5 23.5t29.5 62.5q0 19 -11.5 33t-31.5 25t-47.5 20.5t-60.5 19.5q-75 23 -114 57.5t-39 95.5q0 62 25 110.5t66.5 82.5t96 51.5t113.5 17.5q71 0 126.5 -23.5t93.5 -55.5 l-85 -112q-4 7 -19 19t-37.5 23.5t-50.5 19.5t-58 8q-60 0 -90 -26t-30 -69q0 -17 8.5 -29.5t25.5 -22t41 -17.5t56 -17q40 -11 72.5 -25t55.5 -33.5t35.5 -46.5t12.5 -64q0 -67 -26 -115t-68 -78.5t-96.5 -44.5t-111.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 592,
    d: "M289 589h-213l25 121h563l-26 -121h-212l-125 -589h-138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 720,
    d: "M295 -5q-64 0 -108.5 18.5t-72.5 51t-40.5 76t-12.5 94.5q0 55 13 113l77 362h137l-77 -362q-5 -23 -7.5 -45.5t-2.5 -43.5q0 -30 6 -56t20.5 -45t37 -30t55.5 -11q45 0 80 20t60.5 52t42.5 73.5t26 85.5l77 362h137l-77 -362q-15 -73 -46 -137t-77 -112t-108 -76 t-140 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 646,
    d: "M86 710h145l62 -537l288 537h145l-412 -710h-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 1002,
    d: "M82 710h149l68 -552l128 227l-44 323h127l24 -235l123 235h128l-183 -323l33 -227l302 552h150l-424 -710h-115l-51 298l-178 -298h-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 619,
    d: "M247 350l-162 360h150l106 -264l218 264h149l-315 -360l156 -350h-149l-100 254l-208 -254h-150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 619,
    d: "M225 250l-144 460h150l88 -342l236 342h149l-343 -462l-52 -248h-137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 597,
    d: "M-13 104l476 485h-361l25 121h521l-22 -104l-463 -485h362l-25 -121h-535z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 302,
    d: "M1 -40l166 780h184l-22 -107h-61l-120 -566h61l-23 -107h-185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 604,
    d: "M256 710l262 -710h-148l-263 710h149z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 302,
    d: "M-29 -40l23 107h61l120 566h-61l23 107h185l-165 -780h-186z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 589,
    d: "M48 303l198 407h112l197 -407h-110l-143 294l-146 -294h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 456,
    d: "M-35 -121l25 121h347l-26 -121h-346z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 246,
    d: "M60 730h123l26 -119l-93 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    d: "M201 -10q-44 0 -78.5 16.5t-58.5 45.5t-36.5 68.5t-12.5 84.5q0 65 23.5 124.5t63 104.5t91.5 72t109 27q54 0 92 -28t52 -73l20 90h134l-78 -368q-3 -11 -3 -18q0 -21 24 -22l-24 -114q-18 -3 -31.5 -5t-23.5 -2q-35 0 -55.5 15t-20.5 45q0 12 6 38q-38 -50 -89.5 -75.5 t-103.5 -25.5zM261 104q17 0 36.5 6.5t37.5 18.5t34 28t27 35l26 125q-6 44 -35 73t-67 29q-32 0 -62 -16.5t-52.5 -44t-36 -62t-13.5 -70.5q0 -52 28 -87t77 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 612,
    d: "M282 -10q-59 0 -97 27t-53 74l-19 -91h-117l155 730h134l-64 -298q35 46 84.5 73.5t103.5 27.5q42 0 73.5 -16.5t53.5 -45.5t33 -67.5t11 -82.5q0 -68 -25 -128t-66.5 -105t-95.5 -71.5t-111 -26.5zM272 104q32 0 62 15.5t53.5 42t37.5 61t14 72.5q0 25 -6.5 47.5 t-18.5 39.5t-30 27t-41 10q-41 0 -80.5 -29.5t-65.5 -72.5l-27 -125q6 -38 33.5 -63t68.5 -25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 542,
    d: "M228 -10q-52 0 -92 17.5t-67 47.5t-40.5 70t-13.5 85q0 62 24.5 120.5t68 103.5t104 72t131.5 27q83 0 132.5 -37t65.5 -97l-138 -40q-10 29 -32 44.5t-54 15.5q-31 0 -60.5 -14.5t-52 -40.5t-36.5 -61.5t-14 -76.5q0 -54 26.5 -88t70.5 -34q32 0 63.5 18t48.5 44 l122 -40q-39 -60 -106 -98t-151 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    d: "M201 -10q-44 0 -78.5 16.5t-58.5 45.5t-36.5 68.5t-12.5 84.5q0 65 23.5 124.5t63 104.5t91.5 72t109 27q54 0 92 -28t52 -73l64 298h134l-122 -576q-3 -11 -3 -18q0 -21 24 -22l-24 -114q-18 -3 -31.5 -5t-23.5 -2q-35 0 -55.5 14t-20.5 43q0 8 1.5 17.5t4.5 23.5 q-38 -50 -89.5 -75.5t-103.5 -25.5zM261 104q17 0 36.5 6.5t37.5 18.5t34 28t27 35l26 125q-6 44 -35 73t-67 29q-32 0 -62 -16.5t-52.5 -44t-36 -62t-13.5 -70.5q0 -52 28 -87t77 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 551,
    d: "M230 -10q-50 0 -89.5 16.5t-67.5 46t-42.5 70t-14.5 88.5q0 65 25.5 123.5t70 102.5t105 70t130.5 26q85 0 135.5 -37.5t50.5 -108.5q0 -169 -302 -169h-37t-40 2v-13q0 -53 24 -86t76 -33q40 0 75.5 19t56.5 53l106 -33q-20 -30 -49 -55.5t-63.5 -43.5t-72.5 -28 t-77 -10zM327 436q-29 0 -54 -10.5t-44.5 -28.5t-34.5 -42t-24 -51q16 -1 31 -1h31q48 0 81.5 5t54 15t29.5 23.5t9 31.5q0 29 -22 43.5t-57 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 361,
    d: "M108 394h-64l22 102h64l7 32q10 49 30 88t48 66.5t62.5 42.5t72.5 15q61 0 118 -31l-47 -101q-13 8 -31 13.5t-34 5.5q-64 0 -84 -94l-8 -37h120l-22 -102h-120l-129 -606h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 611,
    d: "M162 -223q-82 0 -132.5 28.5t-79.5 80.5l88 71q20 -37 58 -58t87 -21q29 0 57.5 8.5t52 26.5t41 46t25.5 66l14 66q-34 -45 -83 -69.5t-100 -24.5q-42 0 -74 16.5t-54.5 44.5t-34 66t-11.5 82q0 65 24 124.5t64.5 104.5t94 71.5t113.5 26.5q58 0 95.5 -27.5t55.5 -73.5 l19 92h118l-107 -499q-12 -58 -42.5 -104t-74.5 -78t-98.5 -49t-115.5 -17zM259 104q39 0 76.5 26t59.5 62l26 125q-7 46 -36 74t-67 28q-33 0 -62.5 -17t-52 -44.5t-35.5 -62t-13 -69.5q0 -26 7.5 -48t21 -38.5t32.5 -26t43 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 582,
    d: "M151 730h134l-65 -303q39 51 91 78.5t109 27.5q35 0 58.5 -9.5t38 -26t20.5 -39t6 -48.5q0 -20 -2.5 -41t-7.5 -42l-69 -327h-134l62 294q6 28 6 49q0 72 -61 72q-16 0 -36 -8t-39.5 -22.5t-37 -34.5t-29.5 -44l-65 -306h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 253,
    d: "M107 524h134l-111 -524h-134zM151 730h134l-28 -133h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 258,
    d: "M-83 -196q-36 0 -66.5 11.5t-51.5 35.5l76 91q8 -11 21.5 -16.5t28.5 -5.5q24 0 45 18.5t27 47.5l115 538h134l-112 -528q-9 -42 -30 -77.5t-50.5 -61t-64.5 -39.5t-72 -14zM156 730h134l-29 -133h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 560,
    d: "M151 730h133l-72 -340q42 63 95.5 102t118.5 39q55 0 82 -30t27 -84q0 -65 -38.5 -120.5t-112.5 -91.5l98 -205h-142l-102 237q85 17 131 55t46 81q0 23 -13 34t-33 11q-26 0 -53.5 -14t-53 -39t-47.5 -58t-36 -70l-50 -237h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 309,
    d: "M121 -8q-51 0 -78 23.5t-27 67.5q0 9 1 18t3 20l130 609h133l-119 -562q-1 -5 -1.5 -10t-0.5 -10q0 -41 41 -41q11 0 25.5 4t27.5 10l-4 -102q-29 -13 -65.5 -20t-65.5 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 892,
    d: "M107 524h121l-21 -97q38 50 92.5 78t111.5 28q62 0 90 -30.5t30 -80.5q42 54 95 82.5t110 28.5q34 0 56.5 -9.5t36 -26t19 -38.5t5.5 -48q0 -16 -2 -36.5t-8 -47.5l-70 -327h-134l62 294q3 15 5 28.5t2 24.5q0 35 -14.5 51.5t-39.5 16.5q-37 0 -75.5 -31t-62.5 -79 l-64 -305h-134l62 294q6 31 6 54q0 35 -14 51t-40 16q-18 0 -37 -8t-37.5 -22.5t-34.5 -34.5t-28 -44l-65 -306h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 582,
    d: "M107 524h121l-21 -97q38 50 96 78t123 28q34 0 56.5 -9.5t36 -25.5t19 -38.5t5.5 -47.5q0 -20 -2.5 -41.5t-7.5 -43.5l-69 -327h-134l62 294q3 15 5 28.5t2 24.5q0 35 -15.5 51.5t-41.5 16.5q-18 0 -39 -8t-41 -22.5t-37.5 -34.5t-29.5 -44l-65 -306h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 586,
    d: "M227 -10q-53 0 -92.5 17.5t-66 47.5t-40 69.5t-13.5 83.5q0 62 24.5 120.5t68 104t103.5 73t131 27.5q52 0 91.5 -17.5t66.5 -47t40.5 -69.5t13.5 -85q0 -62 -24.5 -120t-68 -103.5t-103.5 -73t-131 -27.5zM251 104q31 0 60.5 15.5t52.5 41.5t37 61.5t14 75.5 q0 54 -26 87.5t-71 33.5q-31 0 -60.5 -15.5t-52.5 -42t-37 -61.5t-14 -75q0 -54 26 -87.5t71 -33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 612,
    d: "M107 524h117l-19 -90q38 46 86.5 72.5t105.5 26.5q42 0 76 -16.5t57.5 -46t36 -68.5t12.5 -84q0 -65 -23 -124t-62 -104.5t-90.5 -72.5t-107.5 -27q-57 0 -95 27.5t-52 74.5l-65 -305h-134zM276 104q32 0 61.5 16.5t52 43.5t36 61.5t13.5 70.5q0 53 -28 88t-76 35 q-18 0 -37 -6.5t-37 -18.5t-34 -28t-27 -35l-27 -123q8 -45 36 -74.5t67 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 611,
    d: "M183 -10q-40 0 -71 16.5t-52.5 45t-33 67t-11.5 83.5q0 68 25 128t66.5 105t95.5 71.5t111 26.5t95 -27.5t55 -72.5l19 91h117l-122 -576q-1 -5 -1.5 -9t-0.5 -8q0 -22 29 -23l-24 -114q-17 -3 -36.5 -4.5t-35.5 -1.5q-36 0 -59 19t-23 52q0 5 0.5 10t1.5 10l45 213 q-38 -51 -86.5 -76.5t-103.5 -25.5zM257 104q39 0 73.5 24t63.5 62l27 124q-2 22 -10.5 41t-22 33.5t-31 22.5t-36.5 8q-32 0 -62 -16.5t-53 -43.5t-37 -62t-14 -72q0 -52 27 -86.5t75 -34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 378,
    d: "M107 524h123l-24 -112q38 54 85 85.5t94 31.5q10 0 15 -0.5t9 -1.5l-25 -119q-57 -1 -107.5 -23.5t-79.5 -67.5l-67 -317h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 480,
    d: "M184 -10q-63 0 -119 21t-90 60l67 84q77 -69 159 -69q42 0 66 18t24 50q0 22 -21.5 34.5t-69.5 26.5q-40 12 -68.5 23.5t-47 25.5t-27 31.5t-8.5 40.5q0 44 19 80.5t51.5 62.5t75.5 40.5t91 14.5q56 0 101 -17t80 -55l-71 -81q-32 30 -64.5 44t-66.5 14q-35 0 -60.5 -17 t-25.5 -52q0 -21 19 -32t64 -24q84 -23 124 -51.5t40 -78.5q0 -43 -18 -78.5t-50 -61t-76.5 -40t-97.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 373,
    d: "M156 -9q-48 0 -78.5 21.5t-30.5 70.5q0 20 4 37l64 301h-65l22 103h64l36 170h134l-36 -170h105l-22 -103h-104l-55 -256q-1 -5 -1.5 -8.5t-0.5 -7.5q0 -19 10.5 -27t27.5 -8q20 0 39.5 6.5t33.5 12.5l4 -106q-29 -14 -70 -25t-81 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 595,
    d: "M145 -10q-123 0 -123 128q0 17 2.5 36.5t7.5 41.5l70 328h133l-63 -299q-3 -15 -5 -27t-2 -23q0 -71 60 -71q35 0 73.5 23.5t70.5 71.5l69 325h134l-79 -370q-1 -5 -1.5 -9.5t-0.5 -8.5q0 -21 24 -22l-24 -114q-18 -3 -31.5 -5t-24.5 -2q-35 0 -54.5 14t-19.5 43 q0 8 1 18t6 30q-45 -54 -102.5 -81t-120.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 526,
    d: "M50 524h139l32 -415q36 55 65.5 106t54 101.5t44 101t35.5 106.5h123q-36 -131 -108.5 -262t-174.5 -262h-140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 790,
    d: "M42 524h131l63 -404q9 11 21 30.5t24 40.5t23.5 40.5t18.5 30.5l-56 262h117l26 -162q6 11 16.5 33.5t21.5 47t20 47t12 34.5h109q-24 -71 -54.5 -134t-72.5 -127l26 -120q40 54 71 100t55 90.5t43.5 90.5t38.5 100h123q-45 -131 -124.5 -262t-190.5 -262h-101l-29 171 q-7 -10 -22 -34.5t-31.5 -51.5t-32 -51t-23.5 -34h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 511,
    d: "M175 261l-120 263h137l67 -164l5 -18l12 18l139 164h137l-232 -263l123 -261h-138l-70 163l-5 17l-12 -17l-140 -163h-138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 520,
    d: "M-44 -126q30 3 51.5 7t38 12.5t30.5 22t29 34.5l29 39l-87 535h137l45 -408l34 56q31 51 54 95.5t41 86.5t31 83.5t24 86.5h130q-14 -48 -29 -90t-38 -89t-56.5 -104.5t-82.5 -137.5l-80 -129q-35 -56 -67.5 -94.5t-66 -62.5t-70.5 -34.5t-81 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 471,
    d: "M-21 82l342 348h-256l20 94h400l-18 -82l-341 -348h272l-20 -94h-416z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 308,
    d: "M281 633l-43 -204q-5 -20 -18 -37.5t-31 -31.5q9 -11 15 -24t6 -29q0 -5 -0.5 -8.5t-1.5 -7.5l-45 -215h52l-23 -107h-151q-5 0 -10.5 4t-5.5 15q0 7 1 11l52 248q1 4 1.5 7.5t0.5 8.5q0 20 -10.5 34t-25.5 17l20 94q10 0 20.5 6t19 16t15 21t8.5 22l50 237 q4 19 13.5 24.5t14.5 5.5h151l-23 -107h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 327,
    d: "M112 -130v905h114v-905h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 309,
    d: "M118 633l23 107h150q5 0 11 -4t6 -17q0 -6 -1 -9l-51 -237q-1 -3 -1 -6.5v-6.5q0 -20 10 -36t27 -16l-21 -94q-20 -4 -38.5 -22.5t-24.5 -44.5l-52 -248q-4 -18 -13.5 -24t-15.5 -6h-150l22 107h53l45 215q5 20 18 37.5t30 31.5q-8 11 -14 24t-6 28q0 7 2 17l44 204h-53z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 546,
    d: "M41 228q1 9 10 30.5t27.5 44t46 40t66.5 17.5q27 0 48 -8.5t40 -18.5t37.5 -18.5t40.5 -8.5q20 0 34 7.5t22.5 16.5t12.5 17.5t4 10.5h73q0 -5 -9 -26t-28 -44t-48 -41.5t-69 -18.5q-26 0 -47.5 8t-40.5 18t-37.5 18t-39.5 8q-20 0 -33.5 -8t-21.5 -17.5t-11 -17.5t-3 -9 h-74v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00A0",
    unicode: "\xA0",
    horizAdvX: 236
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 290,
    d: "M243 445l-96 -450h-134l96 450h134zM299 712l-32 -151h-134l32 151h134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    horizAdvX: 571,
    d: "M177 -120l24 111q-41 3 -73.5 23t-55 50.5t-34 68.5t-11.5 79q0 55 20 108t57.5 97t91 74.5t120.5 40.5l24 113h60l-24 -113q66 -2 113 -36t65 -97l-139 -40q-7 26 -24.5 40t-39.5 16l-65 -308q24 5 50.5 20.5t39.5 38.5l122 -40q-21 -34 -52 -59.5t-64 -42.5t-65 -25.5 t-56 -8.5l-24 -110h-60zM165 223q0 -38 16.5 -68.5t45.5 -41.5l63 296q-26 -6 -49 -24.5t-40 -44.5t-26.5 -56.5t-9.5 -60.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    horizAdvX: 525,
    d: "M73 381h67q-6 32 -13 62.5t-7 60.5q0 44 20 82.5t53.5 67t77 45t89.5 16.5q59 0 105.5 -28t71.5 -77l-87 -82q-16 35 -48 56.5t-66 21.5q-20 0 -37.5 -8t-31 -21.5t-21.5 -32.5t-8 -41q0 -28 8 -58t15 -64h176l-22 -101h-152q-3 -21 -11 -41t-22 -41t-35 -44t-50 -50 q22 7 40 9.5t34 2.5q34 0 63.5 -8.5t61.5 -8.5q17 0 34 4t40 12l11 -100q-26 -14 -57.5 -22t-58.5 -8q-22 0 -43 4.5t-42 10t-42.5 10t-44.5 4.5q-25 0 -60 -6t-67 -16l-9 95q63 48 98 95t43 98h-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    horizAdvX: 576,
    d: "M190 495q22 14 48 22t58 8q31 0 57 -7.5t48 -21.5l69 71l55 -55l-68 -67q15 -23 23.5 -50.5t8.5 -57.5q0 -29 -8.5 -56.5t-24.5 -50.5l69 -68l-50 -50l-72 68q-22 -14 -48.5 -21.5t-58.5 -7.5q-62 0 -109 30l-73 -69l-49 50l69 69q-31 48 -31 106q0 61 30 106l-68 69 l54 55zM203 337q0 -45 26.5 -73.5t66.5 -28.5t66.5 29t26.5 74t-26.5 73.5t-66.5 28.5t-66.5 -29t-26.5 -74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    horizAdvX: 686,
    d: "M507 402h69l-18 -87h-115l-49 -67l-6 -30h149l-17 -87h-151l-27 -131h-137l27 131h-148l19 87h148l7 32l-20 65h-114l18 87h70l-98 308h149l88 -342l236 342h150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    horizAdvX: 320,
    d: "M222 264v-394h-114v394h114zM222 775v-394h-114v394h114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 515,
    d: "M421 215q16 -19 16 -63q0 -65 -26.5 -110.5t-66.5 -74t-85.5 -42t-82.5 -13.5q-38 0 -68.5 11t-53.5 27t-38.5 34t-24.5 32l103 82q22 -32 47.5 -45.5t55.5 -13.5q17 0 34.5 5.5t31 16t22 25.5t8.5 34q0 13 -5.5 21.5t-14 13t-19.5 6t-22 2.5q-81 6 -122.5 44.5 t-41.5 100.5q0 43 13.5 68.5t23.5 38.5q-8 11 -13 31.5t-5 46.5q0 44 20.5 84.5t55 71t79 48.5t91.5 18q42 0 72 -12.5t51 -31t34 -40t21 -39.5l-113 -49q-8 26 -29 39.5t-53 13.5q-36 0 -64 -22.5t-28 -60.5q0 -28 18.5 -37.5t45.5 -10.5q31 -1 62.5 -8.5t56.5 -23.5 t40.5 -42t15.5 -63q0 -19 -4.5 -36.5t-11 -32.5t-13.5 -26.5t-13 -17.5zM196 309q0 -23 12.5 -33.5t30 -14.5t35.5 -5.5t30 -7.5q12 9 20 25t8 33q0 28 -20.5 39.5t-41.5 11.5q-15 0 -28.5 3t-19.5 6q-10 -8 -18 -23.5t-8 -33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 447,
    d: "M73 604l26 119h111l-26 -119h-111zM261 604l25 119h110l-24 -119h-111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 855,
    d: "M436 -7q-81 0 -149.5 27.5t-118.5 76t-78.5 114.5t-28.5 144q0 77 28.5 143t78.5 114t118.5 75.5t149.5 27.5q82 0 152 -27.5t121 -75.5t79.5 -114t28.5 -143q0 -78 -28.5 -144t-79.5 -114.5t-121 -76t-152 -27.5zM436 43q69 0 128.5 22.5t104 64t69.5 98.5t25 126 q0 66 -24.5 122.5t-68.5 98.5t-104 66t-130 24q-69 0 -127.5 -24t-101.5 -66t-67.5 -98.5t-24.5 -122.5t24.5 -122.5t67 -98.5t101.5 -66t128 -24zM445 116q-56 0 -102.5 18.5t-80 50.5t-52 75.5t-18.5 94.5q0 45 16 88t47.5 76.5t78 53.5t108.5 20q80 0 137.5 -34.5 t84.5 -93.5l-130 -40q-16 31 -42 42.5t-50 11.5q-27 0 -47.5 -10t-35 -27t-22 -39.5t-7.5 -47.5q0 -30 10 -53.5t26 -39t36 -24t41 -8.5q28 0 54 15t40 41l130 -39q-12 -26 -32 -49.5t-48.5 -41.5t-64 -29t-77.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 425,
    d: "M160 339q-42 0 -67 26t-25 67q0 30 13 55.5t36 44.5t54 29.5t66 10.5q45 0 75 -16l4 19q1 6 1.5 11t0.5 10q0 49 -56 49q-28 0 -55 -10t-59 -30l-16 61q75 47 152 47q63 0 97 -27t34 -80q0 -11 -1.5 -21.5t-3.5 -21.5l-23 -104q-1 -4 -1 -11q0 -17 20 -18l-18 -85 q-12 -2 -23 -3t-19 -1q-54 0 -54 40q0 3 0.5 9t1.5 14q-29 -32 -64 -48.5t-70 -16.5zM204 411q13 0 27.5 4.5t27 12t22 17t11.5 19.5l8 39q-12 6 -27.5 9t-29.5 3q-34 0 -57.5 -17.5t-23.5 -44.5q0 -18 11.5 -30t30.5 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 629,
    d: "M33 288l292 189l-23 -109l-169 -109l124 -103l-23 -110l-215 177zM316 288l293 189l-23 -109l-169 -109l124 -103l-23 -110l-215 177z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    horizAdvX: 591,
    d: "M547 400l-63 -294h-113l37 174h-355l25 120h469z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00AD",
    unicode: "\xAD",
    horizAdvX: 582,
    d: "M38 214l26 121h468l-25 -121h-469z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 855,
    d: "M437 -7q-81 0 -150 27.5t-119.5 76t-78.5 114.5t-28 144q0 77 28 143t78.5 114t119.5 75.5t150 27.5t150.5 -27.5t120.5 -75.5t80 -114t29 -143q0 -78 -29 -144t-80 -114.5t-120.5 -76t-150.5 -27.5zM438 42q68 0 127 23t102.5 64t68 98.5t24.5 125.5q0 66 -24 123 t-67 99t-102 66t-129 24t-129 -24t-101.5 -66t-66 -98.5t-23.5 -121.5q0 -66 23.5 -123t66 -99.5t101.5 -66.5t129 -24zM275 576h196q30 0 56 -13t44.5 -34t29 -47t10.5 -53q0 -41 -22.5 -77t-58.5 -50l103 -166h-106l-93 148h-63v-148h-96v440zM463 366q25 0 39.5 16.5 t14.5 46.5q0 32 -17 47.5t-40 15.5h-89v-126h92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    horizAdvX: 401,
    d: "M68 632l18 83h286l-18 -83h-286z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 278,
    d: "M183 519q-37 0 -58.5 22t-21.5 57q0 24 9.5 46.5t26 40.5t39.5 28.5t49 10.5q37 0 58.5 -23t21.5 -58q0 -26 -10 -49t-26.5 -39.5t-39.5 -26t-48 -9.5zM197 584q15 0 29 13.5t14 31.5q0 14 -8 22t-19 8q-17 0 -30.5 -13.5t-13.5 -30.5q0 -14 7 -22.5t21 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    horizAdvX: 511,
    d: "M67 28v108h353v-108h-353zM421 430v-107h-117v-127h-120v127h-117v107h117v127h120v-127h117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twosuperior",
    unicode: "\xB2",
    horizAdvX: 403,
    d: "M50 389q9 41 21.5 71.5t32 53.5t47 40.5t65.5 32.5q27 10 53 20t47 21.5t34 27t13 37.5t-18 33.5t-51 11.5q-42 0 -74.5 -16t-53.5 -33l-38 58q10 10 28 22t42.5 22.5t55.5 17.5t67 7q66 0 100 -28.5t34 -77.5q0 -36 -12.5 -62t-34 -44.5t-50 -31.5t-60.5 -23 q-49 -16 -73.5 -37.5t-29.5 -44.5h198l-17 -78h-326z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threesuperior",
    unicode: "\xB3",
    horizAdvX: 392,
    d: "M204 383q-57 0 -91.5 20.5t-51.5 58.5l55 59q1 -8 7.5 -18t18.5 -19t31 -15t46 -6q19 0 38 4t34 11t24 17.5t9 24.5q0 26 -34 38t-96 12h-23l15 73h22q62 0 101 14t39 43q0 23 -22 32.5t-48 9.5q-37 0 -65.5 -13.5t-51.5 -36.5l-37 64q28 29 75 44.5t93 15.5 q66 0 104.5 -28.5t38.5 -73.5q0 -40 -30.5 -67t-81.5 -36q39 -6 59.5 -31t20.5 -60t-18 -60.5t-46.5 -42.5t-64 -25.5t-70.5 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 245,
    d: "M110 594l-87 17l76 119h124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "mu",
    unicode: "\xB5",
    horizAdvX: 634,
    d: "M117 524h134l-64 -299q-6 -29 -6 -51q0 -70 62 -70q34 0 72 23.5t70 71.5l69 325h134l-79 -370q-1 -5 -1.5 -9t-0.5 -8q0 -22 30 -23l-25 -114q-20 -3 -35 -5t-26 -2q-74 0 -74 57q0 5 1 17t6 31q-12 -18 -31 -37t-42.5 -35t-49.5 -26t-50 -10q-33 0 -50 16.5t-19 42.5 l-48 -261h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 635,
    d: "M62 396q0 71 23 129t66 99t104 63.5t137 22.5h286l-22 -100h-66l-147 -690h-114l62 288h-46l-61 -288h-114l61 288q-80 1 -124.5 52t-44.5 136zM176 410q0 -47 21.5 -73t54.5 -29l65 302q-31 -2 -57 -19t-44.5 -44t-29 -62.5t-10.5 -74.5zM477 610h-47l-64 -302h46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 224,
    d: "M44 242l32 151h110l-32 -151h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 313,
    d: "M19 -127q10 -7 32.5 -13t48.5 -6q27 0 44 9t17 30q0 15 -12 21t-32 6t-43 -4.5t-35 -7.5l83 120l49 -16l-45 -54q7 2 15 3t16 1q29 0 48.5 -13.5t19.5 -42.5q0 -43 -36 -72.5t-109 -29.5q-32 0 -56.5 6t-41.5 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onesuperior",
    unicode: "\xB9",
    horizAdvX: 288,
    d: "M303 469l-17 -79h-220l17 79h74l55 261q-6 -7 -18.5 -15.5t-26.5 -16.5t-29 -13.5t-26 -5.5l17 79q15 0 32.5 8.5t32.5 19t25.5 20t10.5 10.5h81l-75 -347h67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 428,
    d: "M221 339q-36 0 -62.5 12t-44.5 32t-27 47.5t-9 57.5q0 43 16.5 83.5t46 72t70 50.5t89.5 19q36 0 62.5 -12t44.5 -32t27 -47t9 -58q0 -43 -16.5 -83.5t-45.5 -72t-70 -50.5t-90 -19zM239 423q20 0 38.5 10t33 27.5t23.5 41t9 49.5q0 34 -16.5 55.5t-44.5 21.5 q-20 0 -38.5 -10t-33 -27.5t-23.5 -40.5t-9 -49q0 -35 16.5 -56.5t44.5 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 629,
    d: "M576 223l-289 -177l22 110l169 103l-124 109l24 109l212 -189zM292 223l-289 -177l23 110l168 103l-123 109l23 109l212 -189z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 837,
    d: "M621 93h-209l16 77l288 252h54l-54 -251h59l-17 -78h-58l-20 -93h-78zM641 171l32 153l-168 -153h136zM96 47l337 329l319 342l49 -54l-329 -324l-328 -347zM293 384l-17 -78h-221l17 78h75l55 261q-7 -7 -19.5 -15.5t-26.5 -16.5t-29 -13.5t-26 -5.5l17 80 q15 0 32.5 8.5t33 19t26 19.5t10.5 10h80l-74 -347h67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 869,
    d: "M440 0q8 41 20.5 71.5t31 53.5t45.5 40.5t64 32.5q25 10 50.5 19.5t45.5 21t32.5 27t12.5 38.5q0 45 -67 45q-40 0 -71 -16.5t-51 -33.5l-37 58q9 10 26.5 22t41.5 22.5t54 17.5t64 7q63 0 96 -28t33 -77q0 -35 -11.5 -61t-32 -44.5t-48 -32t-59.5 -23.5 q-48 -16 -71 -37.5t-28 -44.5h202l-16 -78h-327zM62 47l337 329l319 342l49 -54l-329 -324l-328 -347zM294 384l-17 -78h-221l17 78h75l55 261q-7 -7 -19.5 -15.5t-26.5 -16.5t-29 -13.5t-26 -5.5l17 80q15 0 32.5 8.5t33 19t26 19.5t10.5 10h80l-74 -347h67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 850,
    d: "M192 298q-60 0 -97 20.5t-43 58.5l55 59q1 -7 7 -16.5t18 -18.5t30.5 -15.5t44.5 -6.5q21 0 40.5 3.5t34.5 11t24 18t9 24.5q0 26 -34.5 38t-95.5 12h-23l15 73h22q63 0 101.5 13.5t38.5 44.5q0 20 -22 30t-47 10q-38 0 -66.5 -13.5t-51.5 -35.5l-37 64q28 29 75 44 t95 15q63 0 102 -28.5t39 -71.5q0 -42 -30 -68.5t-82 -36.5q38 -6 59 -31t21 -58q0 -35 -18 -61.5t-46.5 -43.5t-64.5 -25.5t-73 -8.5zM631 93h-209l16 77l288 252h54l-54 -251h59l-17 -78h-58l-20 -93h-78zM651 171l32 153l-168 -153h136zM130 47l337 329l319 342l49 -54 l-329 -324l-328 -347z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 466,
    d: "M347 273q-10 -49 -32.5 -89t-77.5 -67q-30 -15 -57.5 -29.5t-49 -32t-34.5 -39.5t-13 -51q0 -33 20.5 -51t49.5 -18q20 0 38 7.5t34 19t29 25.5t23 28l75 -60q-38 -62 -99.5 -95.5t-127.5 -33.5q-31 0 -60.5 9t-52 28t-36 48.5t-13.5 70.5q0 44 10.5 76.5t29.5 56.5 t44 42t54 34q22 12 44 23t40.5 24.5t32.5 30.5t19 43h110zM394 506l-29 -138h-110l29 138h110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 645,
    d: "M352 710h123l103 -710h-142l-22 177h-229l-96 -177h-142zM411 274l-31 279l-152 -279h183zM323 917h123l26 -119l-93 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 645,
    d: "M352 710h123l103 -710h-142l-22 177h-229l-96 -177h-142zM411 274l-31 279l-152 -279h183zM445 780l-87 17l76 119h124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 645,
    d: "M352 710h123l103 -710h-142l-22 177h-229l-96 -177h-142zM411 274l-31 279l-152 -279h183zM286 815l123 101h97l80 -101l-77 -32l-67 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 645,
    d: "M352 710h123l103 -710h-142l-22 177h-229l-96 -177h-142zM411 274l-31 279l-152 -279h183zM488 788q-21 0 -36 7t-27.5 15.5t-24.5 15.5t-28 7t-26.5 -7t-16.5 -16t-8.5 -16.5t-2.5 -8.5h-74q2 9 12 30.5t28 43t43.5 38t57.5 16.5q22 0 36 -7.5t26 -16t24 -16t29 -7.5 t28.5 7t18.5 16t10.5 17t3.5 10h73q-2 -7 -12 -28t-28.5 -43t-45 -39.5t-60.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 645,
    d: "M352 710h123l103 -710h-142l-22 177h-229l-96 -177h-142zM411 274l-31 279l-152 -279h183zM272 791l26 119h111l-26 -119h-111zM460 791l25 119h110l-24 -119h-111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 645,
    d: "M352 710h123l103 -710h-142l-22 177h-229l-96 -177h-142zM411 274l-31 279l-152 -279h183zM340 824q0 44 32 68t81 24q38 0 59 -16.5t21 -45.5q0 -43 -31.5 -67.5t-81.5 -24.5q-37 0 -58.5 16.5t-21.5 45.5zM444 875q-19 0 -32.5 -12t-13.5 -30q0 -13 8.5 -21.5 t22.5 -8.5q17 0 32 12t15 30q0 14 -9 22t-23 8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 929,
    d: "M490 710h484l-26 -121h-311l-35 -167h259l-26 -121h-259l-38 -180h318l-25 -121h-456l38 177h-213l-133 -177h-147zM428 297l55 258l-198 -258h143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 656,
    d: "M185 -127q10 -7 32.5 -13t48.5 -6q27 0 44 9t17 30q0 15 -12 21t-32 6t-43 -4.5t-35 -7.5l60 88q-55 6 -98 33t-72 68t-44.5 92.5t-15.5 106.5q0 49 14 99t40.5 96.5t64 87t84 70.5t100.5 47.5t114 17.5q94 0 153.5 -43t77.5 -112l-121 -73q-6 30 -20 50.5t-33.5 32.5 t-42 17.5t-44.5 5.5q-56 0 -102 -27t-78 -69t-49.5 -93t-17.5 -99q0 -38 10 -72t29 -60t46.5 -41t63.5 -15q22 0 47.5 6t50 19t47 33.5t40.5 49.5l99 -65q-22 -36 -54.5 -65t-71 -50t-79.5 -33t-80 -15l-31 -38q7 2 15 3t16 1q29 0 48.5 -13.5t19.5 -42.5q0 -43 -36 -72.5 t-109 -29.5q-32 0 -56.5 6t-41.5 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    horizAdvX: 578,
    d: "M161 710h460l-25 -121h-324l-36 -171h279l-24 -112h-279l-39 -185h332l-26 -121h-469zM325 917h123l26 -119l-93 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    horizAdvX: 578,
    d: "M431 780l-87 17l76 119h124zM161 710h460l-25 -121h-324l-36 -171h279l-24 -112h-279l-39 -185h332l-26 -121h-469z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    horizAdvX: 578,
    d: "M264 815l123 101h97l80 -101l-77 -32l-67 63l-94 -63zM161 710h460l-25 -121h-324l-36 -171h279l-24 -112h-279l-39 -185h332l-26 -121h-469z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    horizAdvX: 578,
    d: "M258 791l26 119h111l-26 -119h-111zM446 791l25 119h110l-24 -119h-111zM161 710h460l-25 -121h-324l-36 -171h279l-24 -112h-279l-39 -185h332l-26 -121h-469z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 285,
    d: "M161 709h137l-151 -709h-137zM160 917h123l26 -119l-93 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 285,
    d: "M161 709h137l-151 -709h-137zM257 780l-87 17l76 119h124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 285,
    d: "M161 709h137l-151 -709h-137zM102 815l123 101h97l80 -101l-77 -32l-67 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 285,
    d: "M161 709h137l-151 -709h-137zM97 791l26 119h111l-26 -119h-111zM285 791l25 119h110l-24 -119h-111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 698,
    d: "M57 407h44l65 303h247q69 0 119.5 -21.5t83.5 -58.5t49 -87t16 -108q0 -94 -31.5 -173.5t-88 -137.5t-133 -91t-166.5 -33h-247l65 307h-44zM288 121q57 0 103.5 24t79.5 64.5t51 93.5t18 112q0 39 -10 71t-29 55t-48 35.5t-66 12.5h-109l-39 -182h130l-22 -100h-130 l-39 -186h110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 733,
    d: "M161 710h107l242 -466l99 465h137l-151 -709h-111l-241 455l-96 -455h-137zM531 788q-21 0 -36 7t-27.5 15.5t-24.5 15.5t-28 7t-26.5 -7t-16.5 -16t-8.5 -16.5t-2.5 -8.5h-74q2 9 12 30.5t28 43t43.5 38t57.5 16.5q22 0 36 -7.5t26 -16t24 -16t29 -7.5t28.5 7t18.5 16 t10.5 17t3.5 10h73q-2 -7 -12 -28t-28.5 -43t-45 -39.5t-60.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 729,
    d: "M299 -5q-63 0 -112 24.5t-82.5 65.5t-50.5 94t-17 111q0 81 34.5 157.5t92.5 136t133.5 95.5t157.5 36q63 0 111.5 -25t81 -66t49.5 -95t17 -111q0 -80 -34 -156.5t-91.5 -135.5t-132.5 -95t-157 -36zM326 117q55 0 100.5 27t78.5 69t51 93.5t18 101.5q0 37 -9 70.5 t-27.5 58.5t-46.5 40t-65 15q-55 0 -101 -26.5t-79 -68.5t-51 -93.5t-18 -102.5q0 -37 9 -70t28 -58.5t46.5 -40.5t65.5 -15zM394 917h123l26 -119l-93 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 729,
    d: "M494 780l-87 17l76 119h124zM299 -5q-63 0 -112 24.5t-82.5 65.5t-50.5 94t-17 111q0 81 34.5 157.5t92.5 136t133.5 95.5t157.5 36q63 0 111.5 -25t81 -66t49.5 -95t17 -111q0 -80 -34 -156.5t-91.5 -135.5t-132.5 -95t-157 -36zM326 117q55 0 100.5 27t78.5 69t51 93.5 t18 101.5q0 37 -9 70.5t-27.5 58.5t-46.5 40t-65 15q-55 0 -101 -26.5t-79 -68.5t-51 -93.5t-18 -102.5q0 -37 9 -70t28 -58.5t46.5 -40.5t65.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 729,
    d: "M329 815l123 101h97l80 -101l-77 -32l-67 63l-94 -63zM299 -5q-63 0 -112 24.5t-82.5 65.5t-50.5 94t-17 111q0 81 34.5 157.5t92.5 136t133.5 95.5t157.5 36q63 0 111.5 -25t81 -66t49.5 -95t17 -111q0 -80 -34 -156.5t-91.5 -135.5t-132.5 -95t-157 -36zM326 117 q55 0 100.5 27t78.5 69t51 93.5t18 101.5q0 37 -9 70.5t-27.5 58.5t-46.5 40t-65 15q-55 0 -101 -26.5t-79 -68.5t-51 -93.5t-18 -102.5q0 -37 9 -70t28 -58.5t46.5 -40.5t65.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 729,
    d: "M299 -5q-63 0 -112 24.5t-82.5 65.5t-50.5 94t-17 111q0 81 34.5 157.5t92.5 136t133.5 95.5t157.5 36q63 0 111.5 -25t81 -66t49.5 -95t17 -111q0 -80 -34 -156.5t-91.5 -135.5t-132.5 -95t-157 -36zM326 117q55 0 100.5 27t78.5 69t51 93.5t18 101.5q0 37 -9 70.5 t-27.5 58.5t-46.5 40t-65 15q-55 0 -101 -26.5t-79 -68.5t-51 -93.5t-18 -102.5q0 -37 9 -70t28 -58.5t46.5 -40.5t65.5 -15zM534 788q-21 0 -36 7t-27.5 15.5t-24.5 15.5t-28 7t-26.5 -7t-16.5 -16t-8.5 -16.5t-2.5 -8.5h-74q2 9 12 30.5t28 43t43.5 38t57.5 16.5 q22 0 36 -7.5t26 -16t24 -16t29 -7.5t28.5 7t18.5 16t10.5 17t3.5 10h73q-2 -7 -12 -28t-28.5 -43t-45 -39.5t-60.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 729,
    d: "M321 791l26 119h111l-26 -119h-111zM509 791l25 119h110l-24 -119h-111zM299 -5q-63 0 -112 24.5t-82.5 65.5t-50.5 94t-17 111q0 81 34.5 157.5t92.5 136t133.5 95.5t157.5 36q63 0 111.5 -25t81 -66t49.5 -95t17 -111q0 -80 -34 -156.5t-91.5 -135.5t-132.5 -95 t-157 -36zM326 117q55 0 100.5 27t78.5 69t51 93.5t18 101.5q0 37 -9 70.5t-27.5 58.5t-46.5 40t-65 15q-55 0 -101 -26.5t-79 -68.5t-51 -93.5t-18 -102.5q0 -37 9 -70t28 -58.5t46.5 -40.5t65.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 487,
    d: "M423 172l-85 -83l-103 103l-103 -103l-83 84l102 102l-98 99l85 83l98 -98l98 99l83 -84l-98 -99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 729,
    d: "M763 710l-98 -111q24 -39 36.5 -85.5t12.5 -95.5q0 -80 -34 -156.5t-91.5 -135.5t-132.5 -95t-157 -36q-39 0 -72 9.5t-61 26.5l-27 -31h-148l96 109q-25 38 -37.5 84.5t-12.5 96.5q0 81 34.5 157.5t92.5 136t133.5 95.5t157.5 36q38 0 71.5 -10t60.5 -27l28 32h148z M177 301q0 -20 2.5 -40t8.5 -37l308 350q-15 8 -32.5 13t-37.5 5q-55 0 -101 -26.5t-79 -68.5t-51 -93.5t-18 -102.5zM326 117q55 0 100.5 27t78.5 69t51 93.5t18 101.5q0 39 -11 75l-307 -349q31 -17 70 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 719,
    d: "M295 -5q-64 0 -108.5 18.5t-72.5 51t-40.5 76t-12.5 94.5q0 55 13 113l77 362h137l-77 -362q-5 -23 -7.5 -45.5t-2.5 -43.5q0 -30 6 -56t20.5 -45t37 -30t55.5 -11q45 0 80 20t60.5 52t42.5 73.5t26 85.5l77 362h137l-77 -362q-15 -73 -46 -137t-77 -112t-108 -76 t-140 -28zM378 917h123l26 -119l-93 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 719,
    d: "M481 780l-87 17l76 119h124zM295 -5q-64 0 -108.5 18.5t-72.5 51t-40.5 76t-12.5 94.5q0 55 13 113l77 362h137l-77 -362q-5 -23 -7.5 -45.5t-2.5 -43.5q0 -30 6 -56t20.5 -45t37 -30t55.5 -11q45 0 80 20t60.5 52t42.5 73.5t26 85.5l77 362h137l-77 -362 q-15 -73 -46 -137t-77 -112t-108 -76t-140 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 719,
    d: "M315 815l123 101h97l80 -101l-77 -32l-67 63l-94 -63zM295 -5q-64 0 -108.5 18.5t-72.5 51t-40.5 76t-12.5 94.5q0 55 13 113l77 362h137l-77 -362q-5 -23 -7.5 -45.5t-2.5 -43.5q0 -30 6 -56t20.5 -45t37 -30t55.5 -11q45 0 80 20t60.5 52t42.5 73.5t26 85.5l77 362h137 l-77 -362q-15 -73 -46 -137t-77 -112t-108 -76t-140 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 719,
    d: "M309 791l26 119h111l-26 -119h-111zM497 791l25 119h110l-24 -119h-111zM295 -5q-64 0 -108.5 18.5t-72.5 51t-40.5 76t-12.5 94.5q0 55 13 113l77 362h137l-77 -362q-5 -23 -7.5 -45.5t-2.5 -43.5q0 -30 6 -56t20.5 -45t37 -30t55.5 -11q45 0 80 20t60.5 52t42.5 73.5 t26 85.5l77 362h137l-77 -362q-15 -73 -46 -137t-77 -112t-108 -76t-140 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 619,
    d: "M225 250l-144 460h150l88 -342l236 342h149l-343 -462l-52 -248h-137zM423 780l-87 17l76 119h124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 583,
    d: "M161 710h137l-27 -128h132q41 0 73 -16.5t54 -44t33.5 -63t11.5 -72.5q0 -50 -21 -99.5t-57.5 -88.5t-85 -63.5t-102.5 -24.5h-139l-23 -110h-137zM328 231q21 0 40.5 12t34.5 31.5t24 45t9 52.5q0 39 -18.5 64t-46.5 25h-126l-49 -230h132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 538,
    d: "M200 117q32 0 60.5 8.5t49.5 24.5t33 40t12 57q0 42 -24.5 64t-58.5 22h-20l25 120h19q20 0 36 7.5t27.5 20t17.5 29t6 33.5q0 29 -17 43t-41 14q-40 0 -63.5 -29t-32.5 -72l-106 -499h-127l110 522q9 42 33 77.5t58 61t76 39.5t87 14q70 0 113.5 -36t43.5 -98 q0 -30 -10.5 -58.5t-27 -52.5t-37.5 -41.5t-42 -25.5q46 -14 70.5 -54.5t24.5 -94.5q0 -69 -27.5 -117.5t-73 -79.5t-103 -46t-117.5 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    d: "M201 -10q-44 0 -78.5 16.5t-58.5 45.5t-36.5 68.5t-12.5 84.5q0 65 23.5 124.5t63 104.5t91.5 72t109 27q54 0 92 -28t52 -73l20 90h134l-78 -368q-3 -11 -3 -18q0 -21 24 -22l-24 -114q-18 -3 -31.5 -5t-23.5 -2q-35 0 -55.5 15t-20.5 45q0 12 6 38q-38 -50 -89.5 -75.5 t-103.5 -25.5zM261 104q17 0 36.5 6.5t37.5 18.5t34 28t27 35l26 125q-6 44 -35 73t-67 29q-32 0 -62 -16.5t-52.5 -44t-36 -62t-13.5 -70.5q0 -52 28 -87t77 -35zM237 730h123l26 -119l-93 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    d: "M201 -10q-44 0 -78.5 16.5t-58.5 45.5t-36.5 68.5t-12.5 84.5q0 65 23.5 124.5t63 104.5t91.5 72t109 27q54 0 92 -28t52 -73l20 90h134l-78 -368q-3 -11 -3 -18q0 -21 24 -22l-24 -114q-18 -3 -31.5 -5t-23.5 -2q-35 0 -55.5 15t-20.5 45q0 12 6 38q-38 -50 -89.5 -75.5 t-103.5 -25.5zM261 104q17 0 36.5 6.5t37.5 18.5t34 28t27 35l26 125q-6 44 -35 73t-67 29q-32 0 -62 -16.5t-52.5 -44t-36 -62t-13.5 -70.5q0 -52 28 -87t77 -35zM363 594l-87 17l76 119h124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    d: "M201 -10q-44 0 -78.5 16.5t-58.5 45.5t-36.5 68.5t-12.5 84.5q0 65 23.5 124.5t63 104.5t91.5 72t109 27q54 0 92 -28t52 -73l20 90h134l-78 -368q-3 -11 -3 -18q0 -21 24 -22l-24 -114q-18 -3 -31.5 -5t-23.5 -2q-35 0 -55.5 15t-20.5 45q0 12 6 38q-38 -50 -89.5 -75.5 t-103.5 -25.5zM261 104q17 0 36.5 6.5t37.5 18.5t34 28t27 35l26 125q-6 44 -35 73t-67 29q-32 0 -62 -16.5t-52.5 -44t-36 -62t-13.5 -70.5q0 -52 28 -87t77 -35zM191 629l123 101h97l80 -101l-77 -32l-67 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    d: "M201 -10q-44 0 -78.5 16.5t-58.5 45.5t-36.5 68.5t-12.5 84.5q0 65 23.5 124.5t63 104.5t91.5 72t109 27q54 0 92 -28t52 -73l20 90h134l-78 -368q-3 -11 -3 -18q0 -21 24 -22l-24 -114q-18 -3 -31.5 -5t-23.5 -2q-35 0 -55.5 15t-20.5 45q0 12 6 38q-38 -50 -89.5 -75.5 t-103.5 -25.5zM261 104q17 0 36.5 6.5t37.5 18.5t34 28t27 35l26 125q-6 44 -35 73t-67 29q-32 0 -62 -16.5t-52.5 -44t-36 -62t-13.5 -70.5q0 -52 28 -87t77 -35zM394 602q-21 0 -36 7t-27.5 15.5t-24.5 15.5t-28 7t-26.5 -7t-16.5 -16t-8.5 -16.5t-2.5 -8.5h-74 q2 9 12 30.5t28 43t43.5 38t57.5 16.5q22 0 36 -7.5t26 -16t24 -16t29 -7.5t28.5 7t18.5 16t10.5 17t3.5 10h73q-2 -7 -12 -28t-28.5 -43t-45 -39.5t-60.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    d: "M201 -10q-44 0 -78.5 16.5t-58.5 45.5t-36.5 68.5t-12.5 84.5q0 65 23.5 124.5t63 104.5t91.5 72t109 27q54 0 92 -28t52 -73l20 90h134l-78 -368q-3 -11 -3 -18q0 -21 24 -22l-24 -114q-18 -3 -31.5 -5t-23.5 -2q-35 0 -55.5 15t-20.5 45q0 12 6 38q-38 -50 -89.5 -75.5 t-103.5 -25.5zM261 104q17 0 36.5 6.5t37.5 18.5t34 28t27 35l26 125q-6 44 -35 73t-67 29q-32 0 -62 -16.5t-52.5 -44t-36 -62t-13.5 -70.5q0 -52 28 -87t77 -35zM187 604l26 119h111l-26 -119h-111zM375 604l25 119h110l-24 -119h-111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    d: "M201 -10q-44 0 -78.5 16.5t-58.5 45.5t-36.5 68.5t-12.5 84.5q0 65 23.5 124.5t63 104.5t91.5 72t109 27q54 0 92 -28t52 -73l20 90h134l-78 -368q-3 -11 -3 -18q0 -21 24 -22l-24 -114q-18 -3 -31.5 -5t-23.5 -2q-35 0 -55.5 15t-20.5 45q0 12 6 38q-38 -50 -89.5 -75.5 t-103.5 -25.5zM261 104q17 0 36.5 6.5t37.5 18.5t34 28t27 35l26 125q-6 44 -35 73t-67 29q-32 0 -62 -16.5t-52.5 -44t-36 -62t-13.5 -70.5q0 -52 28 -87t77 -35zM247 638q0 44 32 68t81 24q38 0 59 -16.5t21 -45.5q0 -43 -31.5 -67.5t-81.5 -24.5q-37 0 -58.5 16.5 t-21.5 45.5zM351 689q-19 0 -32.5 -12t-13.5 -30q0 -13 8.5 -21.5t22.5 -8.5q17 0 32 12t15 30q0 14 -9 22t-23 8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 894,
    d: "M132 -10q-66 0 -104 38.5t-38 98.5q0 43 20 79t54 62.5t80 41.5t98 15q31 0 59 -5t48 -15q5 19 11.5 34t6.5 32q0 31 -22.5 50t-67.5 19q-39 0 -80 -15t-88 -44l-22 85q112 67 224 67q58 0 97.5 -19.5t59.5 -54.5q39 34 88 54t105 20q52 0 91.5 -17t66 -47t40 -70 t13.5 -85q0 -38 -7 -60.5t-12 -34.5h-384q-1 -6 -1 -11.5v-10.5q0 -29 8.5 -49.5t22.5 -34t33 -19.5t39 -6q37 0 74 19.5t56 51.5l107 -32q-20 -30 -48 -55t-61.5 -43.5t-72 -28.5t-80.5 -10q-72 0 -120.5 29.5t-71.5 78.5q-23 -29 -52 -49.5t-59 -33.5t-58.5 -19t-52.5 -6z M192 88q18 0 39 5.5t40.5 15t35.5 22t24 26.5q-1 5 -1.5 11.5t-0.5 13.5q0 23 5 51q-19 8 -42 12.5t-44 4.5q-26 0 -49.5 -7.5t-40.5 -20t-27 -30.5t-10 -39q0 -28 18 -46.5t53 -18.5zM735 302q1 7 1 12.5v12.5q0 50 -26 79.5t-73 29.5q-52 0 -94 -37t-59 -97h251z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 542,
    d: "M119 -127q10 -7 32.5 -13t48.5 -6q27 0 44 9t17 30q0 15 -12 21t-32 6t-43 -4.5t-35 -7.5l58 84q-45 5 -79 24t-57 48t-34.5 66.5t-11.5 79.5q0 62 24.5 120.5t68 103.5t104 72t131.5 27q83 0 132.5 -37t65.5 -97l-138 -40q-10 29 -32 44.5t-54 15.5q-31 0 -60.5 -14.5 t-52 -40.5t-36.5 -61.5t-14 -76.5q0 -54 26.5 -88t70.5 -34q32 0 63.5 18t48.5 44l122 -40q-36 -55 -96.5 -92t-135.5 -43l-27 -33q7 2 15 3t16 1q29 0 48.5 -13.5t19.5 -42.5q0 -43 -36 -72.5t-109 -29.5q-32 0 -56.5 6t-41.5 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 551,
    d: "M230 -10q-50 0 -89.5 16.5t-67.5 46t-42.5 70t-14.5 88.5q0 65 25.5 123.5t70 102.5t105 70t130.5 26q85 0 135.5 -37.5t50.5 -108.5q0 -169 -302 -169h-37t-40 2v-13q0 -53 24 -86t76 -33q40 0 75.5 19t56.5 53l106 -33q-20 -30 -49 -55.5t-63.5 -43.5t-72.5 -28 t-77 -10zM327 436q-29 0 -54 -10.5t-44.5 -28.5t-34.5 -42t-24 -51q16 -1 31 -1h31q48 0 81.5 5t54 15t29.5 23.5t9 31.5q0 29 -22 43.5t-57 14.5zM270 730h123l26 -119l-93 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 551,
    d: "M370 594l-87 17l76 119h124zM230 -10q-50 0 -89.5 16.5t-67.5 46t-42.5 70t-14.5 88.5q0 65 25.5 123.5t70 102.5t105 70t130.5 26q85 0 135.5 -37.5t50.5 -108.5q0 -169 -302 -169h-37t-40 2v-13q0 -53 24 -86t76 -33q40 0 75.5 19t56.5 53l106 -33q-20 -30 -49 -55.5 t-63.5 -43.5t-72.5 -28t-77 -10zM327 436q-29 0 -54 -10.5t-44.5 -28.5t-34.5 -42t-24 -51q16 -1 31 -1h31q48 0 81.5 5t54 15t29.5 23.5t9 31.5q0 29 -22 43.5t-57 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 551,
    d: "M218 629l123 101h97l80 -101l-77 -32l-67 63l-94 -63zM230 -10q-50 0 -89.5 16.5t-67.5 46t-42.5 70t-14.5 88.5q0 65 25.5 123.5t70 102.5t105 70t130.5 26q85 0 135.5 -37.5t50.5 -108.5q0 -169 -302 -169h-37t-40 2v-13q0 -53 24 -86t76 -33q40 0 75.5 19t56.5 53 l106 -33q-20 -30 -49 -55.5t-63.5 -43.5t-72.5 -28t-77 -10zM327 436q-29 0 -54 -10.5t-44.5 -28.5t-34.5 -42t-24 -51q16 -1 31 -1h31q48 0 81.5 5t54 15t29.5 23.5t9 31.5q0 29 -22 43.5t-57 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 551,
    d: "M208 604l26 119h111l-26 -119h-111zM396 604l25 119h110l-24 -119h-111zM230 -10q-50 0 -89.5 16.5t-67.5 46t-42.5 70t-14.5 88.5q0 65 25.5 123.5t70 102.5t105 70t130.5 26q85 0 135.5 -37.5t50.5 -108.5q0 -169 -302 -169h-37t-40 2v-13q0 -53 24 -86t76 -33 q40 0 75.5 19t56.5 53l106 -33q-20 -30 -49 -55.5t-63.5 -43.5t-72.5 -28t-77 -10zM327 436q-29 0 -54 -10.5t-44.5 -28.5t-34.5 -42t-24 -51q16 -1 31 -1h31q48 0 81.5 5t54 15t29.5 23.5t9 31.5q0 29 -22 43.5t-57 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 253,
    d: "M107 524h134l-111 -524h-134zM98 730h123l26 -119l-93 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 253,
    d: "M211 594l-87 17l76 119h124zM107 524h134l-111 -524h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 253,
    d: "M51 629l123 101h97l80 -101l-77 -32l-67 63l-94 -63zM107 524h134l-111 -524h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 253,
    d: "M40 604l26 119h111l-26 -119h-111zM228 604l25 119h110l-24 -119h-111zM107 524h134l-111 -524h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 592,
    d: "M582 660l-80 -41q32 -55 47.5 -118.5t15.5 -125.5q0 -88 -27 -159t-73.5 -121.5t-108 -77.5t-131.5 -27q-48 0 -87.5 15t-67.5 42t-43 64t-15 80q0 57 24 108t64 89.5t91.5 61t105.5 22.5q48 0 85.5 -21.5t56.5 -56.5q-2 48 -13 91.5t-35 85.5l-93 -49l-27 52l86 46 q-23 28 -55 55.5t-74 54.5h170q20 -13 37.5 -29t32.5 -34l87 46zM151 208q0 -45 27 -74.5t73 -29.5q31 0 60 13t50.5 34.5t34.5 50t13 60.5q0 45 -27 73.5t-74 28.5q-31 0 -59.5 -12.5t-50 -33.5t-34.5 -49.5t-13 -60.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    horizAdvX: 582,
    d: "M107 524h121l-21 -97q38 50 96 78t123 28q34 0 56.5 -9.5t36 -25.5t19 -38.5t5.5 -47.5q0 -20 -2.5 -41.5t-7.5 -43.5l-69 -327h-134l62 294q3 15 5 28.5t2 24.5q0 35 -15.5 51.5t-41.5 16.5q-18 0 -39 -8t-41 -22.5t-37.5 -34.5t-29.5 -44l-65 -306h-134zM405 602 q-21 0 -36 7t-27.5 15.5t-24.5 15.5t-28 7t-26.5 -7t-16.5 -16t-8.5 -16.5t-2.5 -8.5h-74q2 9 12 30.5t28 43t43.5 38t57.5 16.5q22 0 36 -7.5t26 -16t24 -16t29 -7.5t28.5 7t18.5 16t10.5 17t3.5 10h73q-2 -7 -12 -28t-28.5 -43t-45 -39.5t-60.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 586,
    d: "M227 -10q-53 0 -92.5 17.5t-66 47.5t-40 69.5t-13.5 83.5q0 62 24.5 120.5t68 104t103.5 73t131 27.5q52 0 91.5 -17.5t66.5 -47t40.5 -69.5t13.5 -85q0 -62 -24.5 -120t-68 -103.5t-103.5 -73t-131 -27.5zM251 104q31 0 60.5 15.5t52.5 41.5t37 61.5t14 75.5 q0 54 -26 87.5t-71 33.5q-31 0 -60.5 -15.5t-52.5 -42t-37 -61.5t-14 -75q0 -54 26 -87.5t71 -33.5zM274 730h123l26 -119l-93 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 586,
    d: "M378 594l-87 17l76 119h124zM227 -10q-53 0 -92.5 17.5t-66 47.5t-40 69.5t-13.5 83.5q0 62 24.5 120.5t68 104t103.5 73t131 27.5q52 0 91.5 -17.5t66.5 -47t40.5 -69.5t13.5 -85q0 -62 -24.5 -120t-68 -103.5t-103.5 -73t-131 -27.5zM251 104q31 0 60.5 15.5t52.5 41.5 t37 61.5t14 75.5q0 54 -26 87.5t-71 33.5q-31 0 -60.5 -15.5t-52.5 -42t-37 -61.5t-14 -75q0 -54 26 -87.5t71 -33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 586,
    d: "M216 629l123 101h97l80 -101l-77 -32l-67 63l-94 -63zM227 -10q-53 0 -92.5 17.5t-66 47.5t-40 69.5t-13.5 83.5q0 62 24.5 120.5t68 104t103.5 73t131 27.5q52 0 91.5 -17.5t66.5 -47t40.5 -69.5t13.5 -85q0 -62 -24.5 -120t-68 -103.5t-103.5 -73t-131 -27.5zM251 104 q31 0 60.5 15.5t52.5 41.5t37 61.5t14 75.5q0 54 -26 87.5t-71 33.5q-31 0 -60.5 -15.5t-52.5 -42t-37 -61.5t-14 -75q0 -54 26 -87.5t71 -33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 586,
    d: "M227 -10q-53 0 -92.5 17.5t-66 47.5t-40 69.5t-13.5 83.5q0 62 24.5 120.5t68 104t103.5 73t131 27.5q52 0 91.5 -17.5t66.5 -47t40.5 -69.5t13.5 -85q0 -62 -24.5 -120t-68 -103.5t-103.5 -73t-131 -27.5zM251 104q31 0 60.5 15.5t52.5 41.5t37 61.5t14 75.5 q0 54 -26 87.5t-71 33.5q-31 0 -60.5 -15.5t-52.5 -42t-37 -61.5t-14 -75q0 -54 26 -87.5t71 -33.5zM417 602q-21 0 -36 7t-27.5 15.5t-24.5 15.5t-28 7t-26.5 -7t-16.5 -16t-8.5 -16.5t-2.5 -8.5h-74q2 9 12 30.5t28 43t43.5 38t57.5 16.5q22 0 36 -7.5t26 -16t24 -16 t29 -7.5t28.5 7t18.5 16t10.5 17t3.5 10h73q-2 -7 -12 -28t-28.5 -43t-45 -39.5t-60.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 586,
    d: "M211 604l26 119h111l-26 -119h-111zM399 604l25 119h110l-24 -119h-111zM227 -10q-53 0 -92.5 17.5t-66 47.5t-40 69.5t-13.5 83.5q0 62 24.5 120.5t68 104t103.5 73t131 27.5q52 0 91.5 -17.5t66.5 -47t40.5 -69.5t13.5 -85q0 -62 -24.5 -120t-68 -103.5t-103.5 -73 t-131 -27.5zM251 104q31 0 60.5 15.5t52.5 41.5t37 61.5t14 75.5q0 54 -26 87.5t-71 33.5q-31 0 -60.5 -15.5t-52.5 -42t-37 -61.5t-14 -75q0 -54 26 -87.5t71 -33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    horizAdvX: 520,
    d: "M203 419v128h113v-128h-113zM203 48v129h113v-129h-113zM57 244v107h404v-107h-404z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 586,
    d: "M58 67q-22 29 -32.5 65t-10.5 76q0 62 24.5 120.5t68 104t104 73t131.5 27.5q39 0 71 -10t57 -28l34 33h76l-73 -69q46 -60 46 -145q0 -62 -24.5 -120t-68 -103.5t-103.5 -73t-131 -27.5q-41 0 -74 10.5t-58 30.5l-37 -35h-74zM251 104q31 0 60.5 15.5t52.5 41.5t37 61.5 t14 75.5q0 32 -11 60l-215 -230q24 -24 62 -24zM154 225q0 -34 10 -58l213 230q-25 22 -59 22q-31 0 -60.5 -15.5t-52.5 -42t-37 -61.5t-14 -75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    horizAdvX: 595,
    d: "M145 -10q-123 0 -123 128q0 17 2.5 36.5t7.5 41.5l70 328h133l-63 -299q-3 -15 -5 -27t-2 -23q0 -71 60 -71q35 0 73.5 23.5t70.5 71.5l69 325h134l-79 -370q-1 -5 -1.5 -9.5t-0.5 -8.5q0 -21 24 -22l-24 -114q-18 -3 -31.5 -5t-24.5 -2q-35 0 -54.5 14t-19.5 43 q0 8 1 18t6 30q-45 -54 -102.5 -81t-120.5 -27zM262 730h123l26 -119l-93 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    horizAdvX: 595,
    d: "M361 594l-87 17l76 119h124zM145 -10q-123 0 -123 128q0 17 2.5 36.5t7.5 41.5l70 328h133l-63 -299q-3 -15 -5 -27t-2 -23q0 -71 60 -71q35 0 73.5 23.5t70.5 71.5l69 325h134l-79 -370q-1 -5 -1.5 -9.5t-0.5 -8.5q0 -21 24 -22l-24 -114q-18 -3 -31.5 -5t-24.5 -2 q-35 0 -54.5 14t-19.5 43q0 8 1 18t6 30q-45 -54 -102.5 -81t-120.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 595,
    d: "M213 629l123 101h97l80 -101l-77 -32l-67 63l-94 -63zM145 -10q-123 0 -123 128q0 17 2.5 36.5t7.5 41.5l70 328h133l-63 -299q-3 -15 -5 -27t-2 -23q0 -71 60 -71q35 0 73.5 23.5t70.5 71.5l69 325h134l-79 -370q-1 -5 -1.5 -9.5t-0.5 -8.5q0 -21 24 -22l-24 -114 q-18 -3 -31.5 -5t-24.5 -2q-35 0 -54.5 14t-19.5 43q0 8 1 18t6 30q-45 -54 -102.5 -81t-120.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    horizAdvX: 595,
    d: "M199 604l26 119h111l-26 -119h-111zM387 604l25 119h110l-24 -119h-111zM145 -10q-123 0 -123 128q0 17 2.5 36.5t7.5 41.5l70 328h133l-63 -299q-3 -15 -5 -27t-2 -23q0 -71 60 -71q35 0 73.5 23.5t70.5 71.5l69 325h134l-79 -370q-1 -5 -1.5 -9.5t-0.5 -8.5 q0 -21 24 -22l-24 -114q-18 -3 -31.5 -5t-24.5 -2q-35 0 -54.5 14t-19.5 43q0 8 1 18t6 30q-45 -54 -102.5 -81t-120.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 520,
    d: "M-44 -126q30 3 51.5 7t38 12.5t30.5 22t29 34.5l29 39l-87 535h137l45 -408l34 56q31 51 54 95.5t41 86.5t31 83.5t24 86.5h130q-14 -48 -29 -90t-38 -89t-56.5 -104.5t-82.5 -137.5l-80 -129q-35 -56 -67.5 -94.5t-66 -62.5t-70.5 -34.5t-81 -11.5zM330 594l-87 17 l76 119h124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    horizAdvX: 577,
    d: "M146 710h137q-7 -32 -14.5 -71t-15.5 -74q-9 -40 -17 -82q19 23 48 39.5t71 16.5q48 0 84 -18.5t60 -49t36 -69.5t12 -80q0 -58 -23 -119.5t-64 -111.5t-98 -82.5t-125 -32.5q-48 0 -69.5 16t-29.5 35q-10 -45 -19 -89q-8 -38 -16.5 -79t-15.5 -72h-137zM258 97 q33 0 61 17t48 45t31 64t11 74q0 52 -22 86.5t-65 34.5q-35 0 -64.5 -23.5t-53.5 -58.5l-34 -160q-1 -3 -1.5 -5t-0.5 -6q0 -12 6 -24t18 -21.5t28.5 -16t37.5 -6.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 520,
    d: "M-44 -126q30 3 51.5 7t38 12.5t30.5 22t29 34.5l29 39l-87 535h137l45 -408l34 56q31 51 54 95.5t41 86.5t31 83.5t24 86.5h130q-14 -48 -29 -90t-38 -89t-56.5 -104.5t-82.5 -137.5l-80 -129q-35 -56 -67.5 -94.5t-66 -62.5t-70.5 -34.5t-81 -11.5zM164 604l26 119h111 l-26 -119h-111zM352 604l25 119h110l-24 -119h-111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Amacron",
    unicode: "\u0100",
    horizAdvX: 645,
    d: "M352 710h123l103 -710h-142l-22 177h-229l-96 -177h-142zM411 274l-31 279l-152 -279h183zM289 818l18 83h286l-18 -83h-286z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron",
    unicode: "\u0101",
    d: "M201 -10q-44 0 -78.5 16.5t-58.5 45.5t-36.5 68.5t-12.5 84.5q0 65 23.5 124.5t63 104.5t91.5 72t109 27q54 0 92 -28t52 -73l20 90h134l-78 -368q-3 -11 -3 -18q0 -21 24 -22l-24 -114q-18 -3 -31.5 -5t-23.5 -2q-35 0 -55.5 15t-20.5 45q0 12 6 38q-38 -50 -89.5 -75.5 t-103.5 -25.5zM261 104q17 0 36.5 6.5t37.5 18.5t34 28t27 35l26 125q-6 44 -35 73t-67 29q-32 0 -62 -16.5t-52.5 -44t-36 -62t-13.5 -70.5q0 -52 28 -87t77 -35zM204 632l18 83h286l-18 -83h-286z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Abreve",
    unicode: "\u0102",
    horizAdvX: 645,
    d: "M352 710h123l103 -710h-142l-22 177h-229l-96 -177h-142zM411 274l-31 279l-152 -279h183zM431 842q21 0 41.5 21t30.5 53h72q-6 -29 -21 -53.5t-35.5 -42.5t-46 -28t-53.5 -10q-49 0 -76.5 28t-27.5 73q0 18 4 33h72q-3 -11 -3 -20q0 -23 12 -38.5t31 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve",
    unicode: "\u0103",
    d: "M201 -10q-44 0 -78.5 16.5t-58.5 45.5t-36.5 68.5t-12.5 84.5q0 65 23.5 124.5t63 104.5t91.5 72t109 27q54 0 92 -28t52 -73l20 90h134l-78 -368q-3 -11 -3 -18q0 -21 24 -22l-24 -114q-18 -3 -31.5 -5t-23.5 -2q-35 0 -55.5 15t-20.5 45q0 12 6 38q-38 -50 -89.5 -75.5 t-103.5 -25.5zM261 104q17 0 36.5 6.5t37.5 18.5t34 28t27 35l26 125q-6 44 -35 73t-67 29q-32 0 -62 -16.5t-52.5 -44t-36 -62t-13.5 -70.5q0 -52 28 -87t77 -35zM339 656q21 0 41.5 21t30.5 53h72q-6 -29 -21 -53.5t-35.5 -42.5t-46 -28t-53.5 -10q-49 0 -76.5 28 t-27.5 73q0 18 4 33h72q-3 -11 -3 -20q0 -23 12 -38.5t31 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\u0104",
    horizAdvX: 645,
    d: "M496 -196q-50 8 -73.5 28.5t-23.5 47.5q0 62 103 120h-66l-22 177h-229l-96 -177h-142l405 710h123l103 -710q-92 -53 -92 -91q0 -32 52 -35zM411 274l-31 279l-152 -279h183z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\u0105",
    d: "M437 -196q-50 8 -73.5 28.5t-23.5 47.5q0 59 96 116q-48 11 -48 57q0 12 6 38q-38 -50 -89.5 -75.5t-103.5 -25.5q-44 0 -78.5 16.5t-58.5 45.5t-36.5 68.5t-12.5 84.5q0 65 23.5 124.5t63 104.5t91.5 72t109 27q54 0 92 -28t52 -73l20 90h134l-78 -368q-3 -11 -3 -18 q0 -21 24 -22l-24 -114q-92 -53 -92 -91q0 -32 52 -35zM261 104q17 0 36.5 6.5t37.5 18.5t34 28t27 35l26 125q-6 44 -35 73t-67 29q-32 0 -62 -16.5t-52.5 -44t-36 -62t-13.5 -70.5q0 -52 28 -87t77 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\u0106",
    horizAdvX: 658,
    d: "M498 780l-87 17l76 119h124zM296 -6q-62 0 -110 25.5t-81 67.5t-50.5 96.5t-17.5 112.5q0 49 14 99t40.5 96.5t64 87t84 70.5t100.5 47.5t114 17.5q94 0 153.5 -43t77.5 -112l-121 -73q-6 30 -20 50.5t-33.5 32.5t-42 17.5t-44.5 5.5q-56 0 -102 -27t-78 -69t-49.5 -93 t-17.5 -99q0 -38 10 -72t29 -60t46.5 -41t63.5 -15q22 0 47.5 6t50 19t47 33.5t40.5 49.5l99 -65q-24 -40 -60.5 -70.5t-79 -51.5t-88 -32t-86.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\u0107",
    horizAdvX: 542,
    d: "M369 594l-87 17l76 119h124zM228 -10q-52 0 -92 17.5t-67 47.5t-40.5 70t-13.5 85q0 62 24.5 120.5t68 103.5t104 72t131.5 27q83 0 132.5 -37t65.5 -97l-138 -40q-10 29 -32 44.5t-54 15.5q-31 0 -60.5 -14.5t-52 -40.5t-36.5 -61.5t-14 -76.5q0 -54 26.5 -88t70.5 -34 q32 0 63.5 18t48.5 44l122 -40q-39 -60 -106 -98t-151 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccircumflex",
    unicode: "\u0108",
    horizAdvX: 658,
    d: "M331 815l123 101h97l80 -101l-77 -32l-67 63l-94 -63zM296 -6q-62 0 -110 25.5t-81 67.5t-50.5 96.5t-17.5 112.5q0 49 14 99t40.5 96.5t64 87t84 70.5t100.5 47.5t114 17.5q94 0 153.5 -43t77.5 -112l-121 -73q-6 30 -20 50.5t-33.5 32.5t-42 17.5t-44.5 5.5 q-56 0 -102 -27t-78 -69t-49.5 -93t-17.5 -99q0 -38 10 -72t29 -60t46.5 -41t63.5 -15q22 0 47.5 6t50 19t47 33.5t40.5 49.5l99 -65q-24 -40 -60.5 -70.5t-79 -51.5t-88 -32t-86.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccircumflex",
    unicode: "\u0109",
    horizAdvX: 542,
    d: "M215 629l123 101h97l80 -101l-77 -32l-67 63l-94 -63zM228 -10q-52 0 -92 17.5t-67 47.5t-40.5 70t-13.5 85q0 62 24.5 120.5t68 103.5t104 72t131.5 27q83 0 132.5 -37t65.5 -97l-138 -40q-10 29 -32 44.5t-54 15.5q-31 0 -60.5 -14.5t-52 -40.5t-36.5 -61.5t-14 -76.5 q0 -54 26.5 -88t70.5 -34q32 0 63.5 18t48.5 44l122 -40q-39 -60 -106 -98t-151 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cdotaccent",
    unicode: "\u010A",
    horizAdvX: 658,
    d: "M296 -6q-62 0 -110 25.5t-81 67.5t-50.5 96.5t-17.5 112.5q0 49 14 99t40.5 96.5t64 87t84 70.5t100.5 47.5t114 17.5q94 0 153.5 -43t77.5 -112l-121 -73q-6 30 -20 50.5t-33.5 32.5t-42 17.5t-44.5 5.5q-56 0 -102 -27t-78 -69t-49.5 -93t-17.5 -99q0 -38 10 -72 t29 -60t46.5 -41t63.5 -15q22 0 47.5 6t50 19t47 33.5t40.5 49.5l99 -65q-24 -40 -60.5 -70.5t-79 -51.5t-88 -32t-86.5 -11zM416 790l27 126h120l-26 -126h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cdotaccent",
    unicode: "\u010B",
    horizAdvX: 542,
    d: "M228 -10q-52 0 -92 17.5t-67 47.5t-40.5 70t-13.5 85q0 62 24.5 120.5t68 103.5t104 72t131.5 27q83 0 132.5 -37t65.5 -97l-138 -40q-10 29 -32 44.5t-54 15.5q-31 0 -60.5 -14.5t-52 -40.5t-36.5 -61.5t-14 -76.5q0 -54 26.5 -88t70.5 -34q32 0 63.5 18t48.5 44 l122 -40q-39 -60 -106 -98t-151 -38zM297 604l27 126h120l-26 -126h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccaron",
    unicode: "\u010C",
    horizAdvX: 658,
    d: "M341 884l77 32l67 -63l94 63l63 -32l-124 -101h-97zM296 -6q-62 0 -110 25.5t-81 67.5t-50.5 96.5t-17.5 112.5q0 49 14 99t40.5 96.5t64 87t84 70.5t100.5 47.5t114 17.5q94 0 153.5 -43t77.5 -112l-121 -73q-6 30 -20 50.5t-33.5 32.5t-42 17.5t-44.5 5.5 q-56 0 -102 -27t-78 -69t-49.5 -93t-17.5 -99q0 -38 10 -72t29 -60t46.5 -41t63.5 -15q22 0 47.5 6t50 19t47 33.5t40.5 49.5l99 -65q-24 -40 -60.5 -70.5t-79 -51.5t-88 -32t-86.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccaron",
    unicode: "\u010D",
    horizAdvX: 542,
    d: "M223 698l77 32l67 -63l94 63l63 -32l-124 -101h-97zM228 -10q-52 0 -92 17.5t-67 47.5t-40.5 70t-13.5 85q0 62 24.5 120.5t68 103.5t104 72t131.5 27q83 0 132.5 -37t65.5 -97l-138 -40q-10 29 -32 44.5t-54 15.5q-31 0 -60.5 -14.5t-52 -40.5t-36.5 -61.5t-14 -76.5 q0 -54 26.5 -88t70.5 -34q32 0 63.5 18t48.5 44l122 -40q-39 -60 -106 -98t-151 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcaron",
    unicode: "\u010E",
    horizAdvX: 692,
    d: "M283 884l77 32l67 -63l94 63l63 -32l-124 -101h-97zM161 710h247q69 0 119.5 -21.5t83.5 -58.5t49 -87t16 -108q0 -94 -31.5 -173.5t-88 -137.5t-133 -91t-166.5 -33h-247zM282 121q57 0 103.5 24t79.5 64.5t51 93.5t18 112q0 78 -38.5 126t-113.5 48h-110l-99 -468h109z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcaron",
    unicode: "\u010F",
    d: "M661 611l77 119h123l-119 -145zM201 -10q-44 0 -78.5 16.5t-58.5 45.5t-36.5 68.5t-12.5 84.5q0 65 23.5 124.5t63 104.5t91.5 72t109 27q54 0 92 -28t52 -73l64 298h134l-122 -576q-3 -11 -3 -18q0 -21 24 -22l-24 -114q-18 -3 -31.5 -5t-23.5 -2q-35 0 -55.5 14 t-20.5 43q0 8 1.5 17.5t4.5 23.5q-38 -50 -89.5 -75.5t-103.5 -25.5zM261 104q17 0 36.5 6.5t37.5 18.5t34 28t27 35l26 125q-6 44 -35 73t-67 29q-32 0 -62 -16.5t-52.5 -44t-36 -62t-13.5 -70.5q0 -52 28 -87t77 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcroat",
    unicode: "\u0110",
    horizAdvX: 698,
    d: "M57 407h44l65 303h247q69 0 119.5 -21.5t83.5 -58.5t49 -87t16 -108q0 -94 -31.5 -173.5t-88 -137.5t-133 -91t-166.5 -33h-247l65 307h-44zM288 121q57 0 103.5 24t79.5 64.5t51 93.5t18 112q0 39 -10 71t-29 55t-48 35.5t-66 12.5h-109l-39 -182h130l-22 -100h-130 l-39 -186h110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcroat",
    unicode: "\u0111",
    d: "M415 671h82l13 59h134l-13 -59h71l-17 -80h-71l-92 -437q-3 -11 -3 -18q0 -21 24 -22l-24 -114q-18 -3 -31.5 -5t-23.5 -2q-38 0 -56.5 15.5t-18.5 42.5q0 4 1 15.5t4 24.5q-38 -50 -89.5 -75.5t-103.5 -25.5q-44 0 -78.5 16.5t-58.5 45.5t-36.5 68.5t-12.5 84.5 q0 65 23.5 124.5t63 104.5t91.5 72t109 27q54 0 92 -28t52 -73l34 159h-82zM261 104q17 0 36.5 6.5t37.5 18.5t34 28t27 35l26 125q-6 44 -35 73t-67 29q-32 0 -62 -16.5t-52.5 -44t-36 -62t-13.5 -70.5q0 -52 28 -87t77 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Emacron",
    unicode: "\u0112",
    horizAdvX: 578,
    d: "M161 710h460l-25 -121h-324l-36 -171h279l-24 -112h-279l-39 -185h332l-26 -121h-469zM269 818l18 83h286l-18 -83h-286z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emacron",
    unicode: "\u0113",
    horizAdvX: 551,
    d: "M230 -10q-50 0 -89.5 16.5t-67.5 46t-42.5 70t-14.5 88.5q0 65 25.5 123.5t70 102.5t105 70t130.5 26q85 0 135.5 -37.5t50.5 -108.5q0 -169 -302 -169h-37t-40 2v-13q0 -53 24 -86t76 -33q40 0 75.5 19t56.5 53l106 -33q-20 -30 -49 -55.5t-63.5 -43.5t-72.5 -28 t-77 -10zM327 436q-29 0 -54 -10.5t-44.5 -28.5t-34.5 -42t-24 -51q16 -1 31 -1h31q48 0 81.5 5t54 15t29.5 23.5t9 31.5q0 29 -22 43.5t-57 14.5zM217 632l18 83h286l-18 -83h-286z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ebreve",
    unicode: "\u0114",
    horizAdvX: 578,
    d: "M161 710h460l-25 -121h-324l-36 -171h279l-24 -112h-279l-39 -185h332l-26 -121h-469zM409 842q21 0 41.5 21t30.5 53h72q-6 -29 -21 -53.5t-35.5 -42.5t-46 -28t-53.5 -10q-49 0 -76.5 28t-27.5 73q0 18 4 33h72q-3 -11 -3 -20q0 -23 12 -38.5t31 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ebreve",
    unicode: "\u0115",
    horizAdvX: 551,
    d: "M230 -10q-50 0 -89.5 16.5t-67.5 46t-42.5 70t-14.5 88.5q0 65 25.5 123.5t70 102.5t105 70t130.5 26q85 0 135.5 -37.5t50.5 -108.5q0 -169 -302 -169h-37t-40 2v-13q0 -53 24 -86t76 -33q40 0 75.5 19t56.5 53l106 -33q-20 -30 -49 -55.5t-63.5 -43.5t-72.5 -28 t-77 -10zM327 436q-29 0 -54 -10.5t-44.5 -28.5t-34.5 -42t-24 -51q16 -1 31 -1h31q48 0 81.5 5t54 15t29.5 23.5t9 31.5q0 29 -22 43.5t-57 14.5zM361 656q21 0 41.5 21t30.5 53h72q-6 -29 -21 -53.5t-35.5 -42.5t-46 -28t-53.5 -10q-49 0 -76.5 28t-27.5 73q0 18 4 33h72 q-3 -11 -3 -20q0 -23 12 -38.5t31 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotaccent",
    unicode: "\u0116",
    horizAdvX: 578,
    d: "M161 710h460l-25 -121h-324l-36 -171h279l-24 -112h-279l-39 -185h332l-26 -121h-469zM346 790l27 126h120l-26 -126h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotaccent",
    unicode: "\u0117",
    horizAdvX: 551,
    d: "M230 -10q-50 0 -89.5 16.5t-67.5 46t-42.5 70t-14.5 88.5q0 65 25.5 123.5t70 102.5t105 70t130.5 26q85 0 135.5 -37.5t50.5 -108.5q0 -169 -302 -169h-37t-40 2v-13q0 -53 24 -86t76 -33q40 0 75.5 19t56.5 53l106 -33q-20 -30 -49 -55.5t-63.5 -43.5t-72.5 -28 t-77 -10zM327 436q-29 0 -54 -10.5t-44.5 -28.5t-34.5 -42t-24 -51q16 -1 31 -1h31q48 0 81.5 5t54 15t29.5 23.5t9 31.5q0 29 -22 43.5t-57 14.5zM298 604l27 126h120l-26 -126h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\u0118",
    horizAdvX: 578,
    d: "M161 710h460l-25 -121h-324l-36 -171h279l-24 -112h-279l-39 -185h332l-26 -121h-189q-92 -53 -92 -91q0 -32 52 -35l-42 -70q-50 8 -73.5 28.5t-23.5 47.5q0 62 103 120h-204z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\u0119",
    horizAdvX: 551,
    d: "M203 -201q-50 8 -73.5 28.5t-23.5 47.5q0 60 97 117q-44 4 -78.5 22t-58.5 47t-37 67t-13 83q0 65 25.5 123.5t70 102.5t105 70t130.5 26q85 0 135.5 -37.5t50.5 -108.5q0 -169 -302 -169h-37t-40 2v-13q0 -53 24 -86t76 -33q40 0 75.5 19t56.5 53l106 -33 q-34 -51 -89 -86t-118 -46q-92 -53 -92 -91q0 -32 52 -35zM327 436q-29 0 -54 -10.5t-44.5 -28.5t-34.5 -42t-24 -51q16 -1 31 -1h31q48 0 81.5 5t54 15t29.5 23.5t9 31.5q0 29 -22 43.5t-57 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecaron",
    unicode: "\u011A",
    horizAdvX: 578,
    d: "M271 884l77 32l67 -63l94 63l63 -32l-124 -101h-97zM161 710h460l-25 -121h-324l-36 -171h279l-24 -112h-279l-39 -185h332l-26 -121h-469z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecaron",
    unicode: "\u011B",
    horizAdvX: 551,
    d: "M224 698l77 32l67 -63l94 63l63 -32l-124 -101h-97zM230 -10q-50 0 -89.5 16.5t-67.5 46t-42.5 70t-14.5 88.5q0 65 25.5 123.5t70 102.5t105 70t130.5 26q85 0 135.5 -37.5t50.5 -108.5q0 -169 -302 -169h-37t-40 2v-13q0 -53 24 -86t76 -33q40 0 75.5 19t56.5 53 l106 -33q-20 -30 -49 -55.5t-63.5 -43.5t-72.5 -28t-77 -10zM327 436q-29 0 -54 -10.5t-44.5 -28.5t-34.5 -42t-24 -51q16 -1 31 -1h31q48 0 81.5 5t54 15t29.5 23.5t9 31.5q0 29 -22 43.5t-57 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcircumflex",
    unicode: "\u011C",
    horizAdvX: 697,
    d: "M325 815l123 101h97l80 -101l-77 -32l-67 63l-94 -63zM494 80q-51 -44 -100.5 -64.5t-102.5 -20.5q-57 0 -103.5 22.5t-80 61.5t-52 92.5t-18.5 115.5q0 86 35 163.5t93 136.5t133 93.5t155 34.5q95 0 154.5 -42t79.5 -113l-119 -76q-14 53 -52.5 81t-92.5 28 q-50 0 -94 -24.5t-78 -65t-53.5 -93t-19.5 -108.5q0 -39 10.5 -73t30 -59t47.5 -39t63 -14q96 0 193 97l11 50h-135l22 101h249l-78 -365h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcircumflex",
    unicode: "\u011D",
    horizAdvX: 611,
    d: "M205 629l123 101h97l80 -101l-77 -32l-67 63l-94 -63zM162 -223q-82 0 -132.5 28.5t-79.5 80.5l88 71q20 -37 58 -58t87 -21q29 0 57.5 8.5t52 26.5t41 46t25.5 66l14 66q-34 -45 -83 -69.5t-100 -24.5q-42 0 -74 16.5t-54.5 44.5t-34 66t-11.5 82q0 65 24 124.5 t64.5 104.5t94 71.5t113.5 26.5q58 0 95.5 -27.5t55.5 -73.5l19 92h118l-107 -499q-12 -58 -42.5 -104t-74.5 -78t-98.5 -49t-115.5 -17zM259 104q39 0 76.5 26t59.5 62l26 125q-7 46 -36 74t-67 28q-33 0 -62.5 -17t-52 -44.5t-35.5 -62t-13 -69.5q0 -26 7.5 -48t21 -38.5 t32.5 -26t43 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gbreve",
    unicode: "\u011E",
    horizAdvX: 697,
    d: "M494 80q-51 -44 -100.5 -64.5t-102.5 -20.5q-57 0 -103.5 22.5t-80 61.5t-52 92.5t-18.5 115.5q0 86 35 163.5t93 136.5t133 93.5t155 34.5q95 0 154.5 -42t79.5 -113l-119 -76q-14 53 -52.5 81t-92.5 28q-50 0 -94 -24.5t-78 -65t-53.5 -93t-19.5 -108.5q0 -39 10.5 -73 t30 -59t47.5 -39t63 -14q96 0 193 97l11 50h-135l22 101h249l-78 -365h-114zM473 842q21 0 41.5 21t30.5 53h72q-6 -29 -21 -53.5t-35.5 -42.5t-46 -28t-53.5 -10q-49 0 -76.5 28t-27.5 73q0 18 4 33h72q-3 -11 -3 -20q0 -23 12 -38.5t31 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve",
    unicode: "\u011F",
    horizAdvX: 611,
    d: "M162 -223q-82 0 -132.5 28.5t-79.5 80.5l88 71q20 -37 58 -58t87 -21q29 0 57.5 8.5t52 26.5t41 46t25.5 66l14 66q-34 -45 -83 -69.5t-100 -24.5q-42 0 -74 16.5t-54.5 44.5t-34 66t-11.5 82q0 65 24 124.5t64.5 104.5t94 71.5t113.5 26.5q58 0 95.5 -27.5t55.5 -73.5 l19 92h118l-107 -499q-12 -58 -42.5 -104t-74.5 -78t-98.5 -49t-115.5 -17zM259 104q39 0 76.5 26t59.5 62l26 125q-7 46 -36 74t-67 28q-33 0 -62.5 -17t-52 -44.5t-35.5 -62t-13 -69.5q0 -26 7.5 -48t21 -38.5t32.5 -26t43 -9.5zM352 656q21 0 41.5 21t30.5 53h72 q-6 -29 -21 -53.5t-35.5 -42.5t-46 -28t-53.5 -10q-49 0 -76.5 28t-27.5 73q0 18 4 33h72q-3 -11 -3 -20q0 -23 12 -38.5t31 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gdotaccent",
    unicode: "\u0120",
    horizAdvX: 697,
    d: "M494 80q-51 -44 -100.5 -64.5t-102.5 -20.5q-57 0 -103.5 22.5t-80 61.5t-52 92.5t-18.5 115.5q0 86 35 163.5t93 136.5t133 93.5t155 34.5q95 0 154.5 -42t79.5 -113l-119 -76q-14 53 -52.5 81t-92.5 28q-50 0 -94 -24.5t-78 -65t-53.5 -93t-19.5 -108.5q0 -39 10.5 -73 t30 -59t47.5 -39t63 -14q96 0 193 97l11 50h-135l22 101h249l-78 -365h-114zM411 790l27 126h120l-26 -126h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent",
    unicode: "\u0121",
    horizAdvX: 611,
    d: "M162 -223q-82 0 -132.5 28.5t-79.5 80.5l88 71q20 -37 58 -58t87 -21q29 0 57.5 8.5t52 26.5t41 46t25.5 66l14 66q-34 -45 -83 -69.5t-100 -24.5q-42 0 -74 16.5t-54.5 44.5t-34 66t-11.5 82q0 65 24 124.5t64.5 104.5t94 71.5t113.5 26.5q58 0 95.5 -27.5t55.5 -73.5 l19 92h118l-107 -499q-12 -58 -42.5 -104t-74.5 -78t-98.5 -49t-115.5 -17zM259 104q39 0 76.5 26t59.5 62l26 125q-7 46 -36 74t-67 28q-33 0 -62.5 -17t-52 -44.5t-35.5 -62t-13 -69.5q0 -26 7.5 -48t21 -38.5t32.5 -26t43 -9.5zM286 604l27 126h120l-26 -126h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcommaaccent",
    unicode: "\u0122",
    horizAdvX: 697,
    d: "M211 -213l43 72h-40l21 94h112l-19 -94l-56 -72h-61zM494 80q-51 -44 -100.5 -64.5t-102.5 -20.5q-57 0 -103.5 22.5t-80 61.5t-52 92.5t-18.5 115.5q0 86 35 163.5t93 136.5t133 93.5t155 34.5q95 0 154.5 -42t79.5 -113l-119 -76q-14 53 -52.5 81t-92.5 28 q-50 0 -94 -24.5t-78 -65t-53.5 -93t-19.5 -108.5q0 -39 10.5 -73t30 -59t47.5 -39t63 -14q96 0 193 97l11 50h-135l22 101h249l-78 -365h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcommaaccent",
    unicode: "\u0123",
    horizAdvX: 611,
    d: "M422 745l-43 -72h40l-21 -94h-112l19 94l56 72h61zM162 -223q-82 0 -132.5 28.5t-79.5 80.5l88 71q20 -37 58 -58t87 -21q29 0 57.5 8.5t52 26.5t41 46t25.5 66l14 66q-34 -45 -83 -69.5t-100 -24.5q-42 0 -74 16.5t-54.5 44.5t-34 66t-11.5 82q0 65 24 124.5t64.5 104.5 t94 71.5t113.5 26.5q58 0 95.5 -27.5t55.5 -73.5l19 92h118l-107 -499q-12 -58 -42.5 -104t-74.5 -78t-98.5 -49t-115.5 -17zM259 104q39 0 76.5 26t59.5 62l26 125q-7 46 -36 74t-67 28q-33 0 -62.5 -17t-52 -44.5t-35.5 -62t-13 -69.5q0 -26 7.5 -48t21 -38.5t32.5 -26 t43 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hcircumflex",
    unicode: "\u0124",
    horizAdvX: 718,
    d: "M317 815l123 101h97l80 -101l-77 -32l-67 63l-94 -63zM161 710h137l-61 -287h296l61 287h137l-151 -710h-137l64 303h-296l-64 -303h-137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hcircumflex",
    unicode: "\u0125",
    horizAdvX: 582,
    d: "M296 629l114 100h90l74 -100l-71 -32l-62 63l-88 -63zM151 730h134l-65 -303q39 51 91 78.5t109 27.5q35 0 58.5 -9.5t38 -26t20.5 -39t6 -48.5q0 -20 -2.5 -41t-7.5 -42l-69 -327h-134l62 294q6 28 6 49q0 72 -61 72q-16 0 -36 -8t-39.5 -22.5t-37 -34.5t-29.5 -44 l-65 -306h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hbar",
    unicode: "\u0126",
    horizAdvX: 726,
    d: "M96 609h47l22 101h138l-22 -101h296l22 101h137l-22 -101h48l-14 -66h-48l-115 -543h-137l64 303h-296l-64 -303h-138l115 543h-47zM538 423l25 120h-296l-25 -120h296z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u0127",
    horizAdvX: 582,
    d: "M79 671h59l13 59h134l-13 -59h94l-17 -80h-94l-35 -164q39 51 91 78.5t109 27.5q35 0 58.5 -9.5t38 -26t20.5 -39t6 -48.5q0 -20 -2.5 -41t-7.5 -42l-69 -327h-134l62 294q6 28 6 49q0 72 -61 72q-16 0 -36 -8t-39.5 -22.5t-37 -34.5t-29.5 -44l-65 -306h-134l125 591 h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Itilde",
    unicode: "\u0128",
    horizAdvX: 285,
    d: "M161 709h137l-151 -709h-137zM311 788q-21 0 -36 7t-27.5 15.5t-24.5 15.5t-28 7t-26.5 -7t-16.5 -16t-8.5 -16.5t-2.5 -8.5h-74q2 9 12 30.5t28 43t43.5 38t57.5 16.5q22 0 36 -7.5t26 -16t24 -16t29 -7.5t28.5 7t18.5 16t10.5 17t3.5 10h73q-2 -7 -12 -28t-28.5 -43 t-45 -39.5t-60.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "itilde",
    unicode: "\u0129",
    horizAdvX: 253,
    d: "M107 524h134l-111 -524h-134zM251 602q-21 0 -36 7t-27.5 15.5t-24.5 15.5t-28 7t-26.5 -7t-16.5 -16t-8.5 -16.5t-2.5 -8.5h-74q2 9 12 30.5t28 43t43.5 38t57.5 16.5q22 0 36 -7.5t26 -16t24 -16t29 -7.5t28.5 7t18.5 16t10.5 17t3.5 10h73q-2 -7 -12 -28t-28.5 -43 t-45 -39.5t-60.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron",
    unicode: "\u012A",
    horizAdvX: 285,
    d: "M161 709h137l-151 -709h-137zM109 818l18 83h286l-18 -83h-286z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "imacron",
    unicode: "\u012B",
    horizAdvX: 253,
    d: "M107 524h134l-111 -524h-134zM49 632l18 83h286l-18 -83h-286z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ibreve",
    unicode: "\u012C",
    horizAdvX: 285,
    d: "M161 709h137l-151 -709h-137zM250 842q21 0 41.5 21t30.5 53h72q-6 -29 -21 -53.5t-35.5 -42.5t-46 -28t-53.5 -10q-49 0 -76.5 28t-27.5 73q0 18 4 33h72q-3 -11 -3 -20q0 -23 12 -38.5t31 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ibreve",
    unicode: "\u012D",
    horizAdvX: 253,
    d: "M107 524h134l-111 -524h-134zM192 656q21 0 41.5 21t30.5 53h72q-6 -29 -21 -53.5t-35.5 -42.5t-46 -28t-53.5 -10q-49 0 -76.5 28t-27.5 73q0 18 4 33h72q-3 -11 -3 -20q0 -23 12 -38.5t31 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek",
    unicode: "\u012E",
    horizAdvX: 285,
    d: "M161 709h137l-151 -709q-92 -53 -92 -91q0 -32 52 -35l-42 -70q-50 8 -73.5 28.5t-23.5 47.5q0 62 103 120h-61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iogonek",
    unicode: "\u012F",
    horizAdvX: 253,
    d: "M107 524h134l-111 -524q-92 -53 -92 -91q0 -32 52 -35l-42 -70q-50 8 -73.5 28.5t-23.5 47.5q0 61 103 120h-58zM151 730h134l-28 -133h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotaccent",
    unicode: "\u0130",
    horizAdvX: 285,
    d: "M161 709h137l-151 -709h-137zM186 790l27 126h120l-26 -126h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 253,
    d: "M107 524h134l-111 -524h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "IJ",
    unicode: "\u0132",
    horizAdvX: 764,
    d: "M161 709h137l-151 -709h-137zM379 -11q-85 0 -137 44l54 112q10 -10 39 -22t70 -12q39 0 65 14.5t44 44.5t31 74.5t26 104.5l77 360h138l-77 -360q-17 -81 -39 -147.5t-58.5 -113.5t-92.5 -73t-140 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ij",
    unicode: "\u0133",
    horizAdvX: 511,
    d: "M107 524h134l-111 -524h-134zM151 730h134l-28 -133h-134zM170 -196q-36 0 -66.5 11.5t-51.5 35.5l76 91q8 -11 21.5 -16.5t28.5 -5.5q24 0 45 18.5t27 47.5l115 538h134l-112 -528q-9 -42 -30 -77.5t-50.5 -61t-64.5 -39.5t-72 -14zM409 730h134l-29 -133h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Jcircumflex",
    unicode: "\u0134",
    horizAdvX: 479,
    d: "M303 815l123 101h97l80 -101l-77 -32l-67 63l-94 -63zM94 -11q-85 0 -137 44l54 112q10 -10 39 -22t70 -12q39 0 65 14.5t44 44.5t31 74.5t26 104.5l77 360h138l-77 -360q-17 -81 -39 -147.5t-58.5 -113.5t-92.5 -73t-140 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "jcircumflex",
    unicode: "\u0135",
    horizAdvX: 253,
    d: "M-88 -196q-36 0 -66.5 11.5t-51.5 35.5l76 91q8 -11 21.5 -16.5t28.5 -5.5q24 0 45 18.5t27 47.5l115 538h134l-112 -528q-9 -42 -30 -77.5t-50.5 -61t-64.5 -39.5t-72 -14zM44 629l123 101h97l80 -101l-77 -32l-67 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Kcommaaccent",
    unicode: "\u0136",
    horizAdvX: 643,
    d: "M200 -213l43 72h-40l21 94h112l-19 -94l-56 -72h-61zM161 709h137l-72 -337l345 338h154l-325 -315l190 -395h-156l-139 307l-103 -95l-45 -212h-137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kcommaaccent",
    unicode: "\u0137",
    horizAdvX: 560,
    d: "M145 -213l43 72h-40l21 94h112l-19 -94l-56 -72h-61zM151 730h133l-72 -340q42 63 95.5 102t118.5 39q55 0 82 -30t27 -84q0 -65 -38.5 -120.5t-112.5 -91.5l98 -205h-142l-102 237q85 17 131 55t46 81q0 23 -13 34t-33 11q-26 0 -53.5 -14t-53 -39t-47.5 -58t-36 -70 l-50 -237h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kgreenlandic",
    unicode: "\u0138",
    horizAdvX: 539,
    d: "M107 524h134l-51 -237l242 236h143l-231 -222l134 -301h-143l-93 227l-79 -71l-33 -156h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lacute",
    unicode: "\u0139",
    horizAdvX: 561,
    d: "M267 780l-87 17l76 119h124zM161 710h137l-125 -589h339l-25 -121h-477z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute",
    unicode: "\u013A",
    horizAdvX: 309,
    d: "M244 755l-87 17l76 119h124zM121 -8q-51 0 -78 23.5t-27 67.5q0 9 1 18t3 20l130 609h133l-119 -562q-1 -5 -1.5 -10t-0.5 -10q0 -41 41 -41q11 0 25.5 4t27.5 10l-4 -102q-29 -13 -65.5 -20t-65.5 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcommaaccent",
    unicode: "\u013B",
    horizAdvX: 561,
    d: "M164 -213l43 72h-40l21 94h112l-19 -94l-56 -72h-61zM161 710h137l-125 -589h339l-25 -121h-477z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcommaaccent",
    unicode: "\u013C",
    horizAdvX: 309,
    d: "M22 -213l43 72h-40l21 94h112l-19 -94l-56 -72h-61zM121 -8q-51 0 -78 23.5t-27 67.5q0 9 1 18t3 20l130 609h133l-119 -562q-1 -5 -1.5 -10t-0.5 -10q0 -41 41 -41q11 0 25.5 4t27.5 10l-4 -102q-29 -13 -65.5 -20t-65.5 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcaron",
    unicode: "\u013D",
    horizAdvX: 562,
    d: "M343 611l77 119h123l-119 -145zM161 710h137l-125 -589h339l-25 -121h-477z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron",
    unicode: "\u013E",
    horizAdvX: 304,
    d: "M303 611l77 119h123l-119 -145zM121 -8q-51 0 -78 23.5t-27 67.5q0 9 1 18t3 20l130 609h133l-119 -562q-1 -5 -1.5 -10t-0.5 -10q0 -41 41 -41q11 0 25.5 4t27.5 10l-4 -102q-29 -13 -65.5 -20t-65.5 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ldot",
    unicode: "\u013F",
    horizAdvX: 562,
    d: "M161 710h137l-125 -589h339l-25 -121h-477zM336 340l32 151h110l-32 -151h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ldot",
    unicode: "\u0140",
    horizAdvX: 393,
    d: "M121 -8q-51 0 -78 23.5t-27 67.5q0 9 1 18t3 20l130 609h133l-119 -562q-1 -5 -1.5 -10t-0.5 -10q0 -41 41 -41q11 0 25.5 4t27.5 10l-4 -102q-29 -13 -65.5 -20t-65.5 -7zM262 266l32 151h110l-32 -151h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    horizAdvX: 569,
    d: "M3 315l93 54l73 341h137l-54 -251l115 66l17 -73l-152 -88l-51 -243h340l-26 -121h-477l58 274l-55 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    horizAdvX: 343,
    d: "M10 341l101 55l71 334h134l-54 -251l82 45l18 -72l-119 -65l-44 -208l-3.5 -17.5t-1.5 -13.5q0 -41 41 -41q11 0 25.5 4t28.5 10l-5 -102q-29 -13 -65.5 -20t-65.5 -7q-51 0 -78 23.5t-27 67.5q0 9 1.5 18t3.5 20l38 183l-63 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\u0143",
    horizAdvX: 733,
    d: "M489 780l-87 17l76 119h124zM161 710h107l242 -466l99 465h137l-151 -709h-111l-241 455l-96 -455h-137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\u0144",
    horizAdvX: 582,
    d: "M386 594l-87 17l76 119h124zM107 524h121l-21 -97q38 50 96 78t123 28q34 0 56.5 -9.5t36 -25.5t19 -38.5t5.5 -47.5q0 -20 -2.5 -41.5t-7.5 -43.5l-69 -327h-134l62 294q3 15 5 28.5t2 24.5q0 35 -15.5 51.5t-41.5 16.5q-18 0 -39 -8t-41 -22.5t-37.5 -34.5t-29.5 -44 l-65 -306h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncommaaccent",
    unicode: "\u0145",
    horizAdvX: 733,
    d: "M218 -213l43 72h-40l21 94h112l-19 -94l-56 -72h-61zM161 710h107l242 -466l99 465h137l-151 -709h-111l-241 455l-96 -455h-137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncommaaccent",
    unicode: "\u0146",
    horizAdvX: 582,
    d: "M137 -213l43 72h-40l21 94h112l-19 -94l-56 -72h-61zM107 524h121l-21 -97q38 50 96 78t123 28q34 0 56.5 -9.5t36 -25.5t19 -38.5t5.5 -47.5q0 -20 -2.5 -41.5t-7.5 -43.5l-69 -327h-134l62 294q3 15 5 28.5t2 24.5q0 35 -15.5 51.5t-41.5 16.5q-18 0 -39 -8t-41 -22.5 t-37.5 -34.5t-29.5 -44l-65 -306h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncaron",
    unicode: "\u0147",
    horizAdvX: 733,
    d: "M327 884l77 32l67 -63l94 63l63 -32l-124 -101h-97zM161 710h107l242 -466l99 465h137l-151 -709h-111l-241 455l-96 -455h-137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncaron",
    unicode: "\u0148",
    horizAdvX: 582,
    d: "M219 698l77 32l67 -63l94 63l63 -32l-124 -101h-97zM107 524h121l-21 -97q38 50 96 78t123 28q34 0 56.5 -9.5t36 -25.5t19 -38.5t5.5 -47.5q0 -20 -2.5 -41.5t-7.5 -43.5l-69 -327h-134l62 294q3 15 5 28.5t2 24.5q0 35 -15.5 51.5t-41.5 16.5q-18 0 -39 -8t-41 -22.5 t-37.5 -34.5t-29.5 -44l-65 -306h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "napostrophe",
    unicode: "\u0149",
    horizAdvX: 582,
    d: "M-50 611l47 73l3 46h150l-120 -145zM107 524h121l-21 -97q38 50 96 78t123 28q34 0 56.5 -9.5t36 -25.5t19 -38.5t5.5 -47.5q0 -20 -2.5 -41.5t-7.5 -43.5l-69 -327h-134l62 294q3 15 5 28.5t2 24.5q0 35 -15.5 51.5t-41.5 16.5q-18 0 -39 -8t-41 -22.5t-37.5 -34.5 t-29.5 -44l-65 -306h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eng",
    unicode: "\u014A",
    horizAdvX: 720,
    d: "M364 -196q-36 0 -66.5 11.5t-51.5 35.5l77 91q8 -11 21.5 -16.5t27.5 -5.5q25 0 46 18.5t27 47.5l9 42l-211 423l-96 -451h-137l151 710h105l232 -460l97 459h138l-153 -718q-9 -42 -30.5 -76.5t-50.5 -59t-64 -38t-71 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eng",
    unicode: "\u014B",
    horizAdvX: 582,
    d: "M245 -196q-36 0 -66 11.5t-51 35.5l76 91q8 -11 21.5 -16.5t28.5 -5.5q23 0 45 18t28 48l65 308q3 15 5 28.5t2 24.5q0 35 -15.5 51.5t-41.5 16.5q-18 0 -39 -8t-41 -22.5t-37.5 -34.5t-29.5 -44l-65 -306h-134l111 524h121l-21 -97q38 50 96 78t123 28q34 0 56.5 -9.5 t36 -25.5t19 -38t5.5 -47q0 -20 -2.5 -42t-7.5 -44l-71 -331q-9 -42 -30.5 -77.5t-50.5 -61t-64 -39.5t-72 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omacron",
    unicode: "\u014C",
    horizAdvX: 729,
    d: "M334 818l18 83h286l-18 -83h-286zM299 -5q-63 0 -112 24.5t-82.5 65.5t-50.5 94t-17 111q0 81 34.5 157.5t92.5 136t133.5 95.5t157.5 36q63 0 111.5 -25t81 -66t49.5 -95t17 -111q0 -80 -34 -156.5t-91.5 -135.5t-132.5 -95t-157 -36zM326 117q55 0 100.5 27t78.5 69 t51 93.5t18 101.5q0 37 -9 70.5t-27.5 58.5t-46.5 40t-65 15q-55 0 -101 -26.5t-79 -68.5t-51 -93.5t-18 -102.5q0 -37 9 -70t28 -58.5t46.5 -40.5t65.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omacron",
    unicode: "\u014D",
    horizAdvX: 586,
    d: "M221 632l18 83h286l-18 -83h-286zM227 -10q-53 0 -92.5 17.5t-66 47.5t-40 69.5t-13.5 83.5q0 62 24.5 120.5t68 104t103.5 73t131 27.5q52 0 91.5 -17.5t66.5 -47t40.5 -69.5t13.5 -85q0 -62 -24.5 -120t-68 -103.5t-103.5 -73t-131 -27.5zM251 104q31 0 60.5 15.5 t52.5 41.5t37 61.5t14 75.5q0 54 -26 87.5t-71 33.5q-31 0 -60.5 -15.5t-52.5 -42t-37 -61.5t-14 -75q0 -54 26 -87.5t71 -33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Obreve",
    unicode: "\u014E",
    horizAdvX: 729,
    d: "M299 -5q-63 0 -112 24.5t-82.5 65.5t-50.5 94t-17 111q0 81 34.5 157.5t92.5 136t133.5 95.5t157.5 36q63 0 111.5 -25t81 -66t49.5 -95t17 -111q0 -80 -34 -156.5t-91.5 -135.5t-132.5 -95t-157 -36zM326 117q55 0 100.5 27t78.5 69t51 93.5t18 101.5q0 37 -9 70.5 t-27.5 58.5t-46.5 40t-65 15q-55 0 -101 -26.5t-79 -68.5t-51 -93.5t-18 -102.5q0 -37 9 -70t28 -58.5t46.5 -40.5t65.5 -15zM477 842q21 0 41.5 21t30.5 53h72q-6 -29 -21 -53.5t-35.5 -42.5t-46 -28t-53.5 -10q-49 0 -76.5 28t-27.5 73q0 18 4 33h72q-3 -11 -3 -20 q0 -23 12 -38.5t31 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "obreve",
    unicode: "\u014F",
    horizAdvX: 586,
    d: "M227 -10q-53 0 -92.5 17.5t-66 47.5t-40 69.5t-13.5 83.5q0 62 24.5 120.5t68 104t103.5 73t131 27.5q52 0 91.5 -17.5t66.5 -47t40.5 -69.5t13.5 -85q0 -62 -24.5 -120t-68 -103.5t-103.5 -73t-131 -27.5zM251 104q31 0 60.5 15.5t52.5 41.5t37 61.5t14 75.5 q0 54 -26 87.5t-71 33.5q-31 0 -60.5 -15.5t-52.5 -42t-37 -61.5t-14 -75q0 -54 26 -87.5t71 -33.5zM365 656q21 0 41.5 21t30.5 53h72q-6 -29 -21 -53.5t-35.5 -42.5t-46 -28t-53.5 -10q-49 0 -76.5 28t-27.5 73q0 18 4 33h72q-3 -11 -3 -20q0 -23 12 -38.5t31 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohungarumlaut",
    unicode: "\u0150",
    horizAdvX: 729,
    d: "M401 771l-67 16l70 119h103zM557 771l-66 16l69 119h103zM299 -5q-63 0 -112 24.5t-82.5 65.5t-50.5 94t-17 111q0 81 34.5 157.5t92.5 136t133.5 95.5t157.5 36q63 0 111.5 -25t81 -66t49.5 -95t17 -111q0 -80 -34 -156.5t-91.5 -135.5t-132.5 -95t-157 -36zM326 117 q55 0 100.5 27t78.5 69t51 93.5t18 101.5q0 37 -9 70.5t-27.5 58.5t-46.5 40t-65 15q-55 0 -101 -26.5t-79 -68.5t-51 -93.5t-18 -102.5q0 -37 9 -70t28 -58.5t46.5 -40.5t65.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohungarumlaut",
    unicode: "\u0151",
    horizAdvX: 586,
    d: "M292 595l-67 16l70 119h103zM448 595l-66 16l69 119h103zM227 -10q-53 0 -92.5 17.5t-66 47.5t-40 69.5t-13.5 83.5q0 62 24.5 120.5t68 104t103.5 73t131 27.5q52 0 91.5 -17.5t66.5 -47t40.5 -69.5t13.5 -85q0 -62 -24.5 -120t-68 -103.5t-103.5 -73t-131 -27.5z M251 104q31 0 60.5 15.5t52.5 41.5t37 61.5t14 75.5q0 54 -26 87.5t-71 33.5q-31 0 -60.5 -15.5t-52.5 -42t-37 -61.5t-14 -75q0 -54 26 -87.5t71 -33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 1032,
    d: "M289 -5q-61 0 -108 24.5t-79 65t-48.5 93.5t-16.5 110q0 81 34 158t90.5 137t130 96t153.5 36q59 0 99.5 -31t62.5 -78l22 104h448l-26 -121h-311l-35 -167h259l-25 -121h-260l-38 -180h319l-26 -121h-456l22 105q-42 -48 -97 -79t-114 -31zM316 117q53 0 97 27t75.5 70 t49 95.5t17.5 102.5q0 36 -9 69t-26 57.5t-43 39.5t-60 15q-53 0 -97 -27t-75.5 -70t-49.5 -95t-18 -103q0 -36 8.5 -69t26 -58t43.5 -39.5t61 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 965,
    d: "M226 -10q-49 0 -88 16.5t-66.5 45.5t-42 69t-14.5 87q0 68 26.5 127t71.5 103t104 69.5t124 25.5q63 0 105.5 -31.5t63.5 -90.5q51 61 105.5 91.5t117.5 30.5q48 0 86.5 -16t65.5 -45t41.5 -69t14.5 -89q0 -38 -6.5 -60.5t-11.5 -34.5h-379q-2 -6 -2 -12v-11 q0 -49 28 -80t75 -31q39 0 76.5 21t55.5 53l105 -32q-44 -63 -114 -100t-147 -37q-60 0 -101.5 30t-73.5 88q-57 -60 -109.5 -89t-110.5 -29zM251 104q32 0 62 15.5t52.5 42t36 61.5t13.5 75q0 53 -26 87t-71 34q-32 0 -61.5 -15.5t-52.5 -42.5t-36.5 -62.5t-13.5 -75.5 q0 -52 26 -85.5t71 -33.5zM806 302q1 6 1.5 12t0.5 11q0 51 -27 81t-73 30q-51 0 -92.5 -37t-58.5 -97h249z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute",
    unicode: "\u0154",
    horizAdvX: 642,
    d: "M436 782l-87 17l76 119h124zM10 0l151 710h300q40 0 72 -16.5t54 -44t33.5 -63t11.5 -72.5q0 -39 -13 -76.5t-35.5 -70.5t-53 -59t-66.5 -41l96 -267h-156l-84 238h-123l-50 -238h-137zM382 359q20 0 39.5 11.5t34.5 31t24.5 45t9.5 53.5q0 38 -18.5 63.5t-45.5 25.5 h-154l-49 -230h159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "racute",
    unicode: "\u0155",
    horizAdvX: 378,
    d: "M290 594l-87 17l76 119h124zM107 524h123l-24 -112q38 54 85 85.5t94 31.5q10 0 15 -0.5t9 -1.5l-25 -119q-57 -1 -107.5 -23.5t-79.5 -67.5l-67 -317h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcommaaccent",
    unicode: "\u0156",
    horizAdvX: 642,
    d: "M170 -213l43 72h-40l21 94h112l-19 -94l-56 -72h-61zM10 0l151 710h300q40 0 72 -16.5t54 -44t33.5 -63t11.5 -72.5q0 -39 -13 -76.5t-35.5 -70.5t-53 -59t-66.5 -41l96 -267h-156l-84 238h-123l-50 -238h-137zM382 359q20 0 39.5 11.5t34.5 31t24.5 45t9.5 53.5 q0 38 -18.5 63.5t-45.5 25.5h-154l-49 -230h159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcommaaccent",
    unicode: "\u0157",
    horizAdvX: 378,
    d: "M-30 -213l43 72h-40l21 94h112l-19 -94l-56 -72h-61zM107 524h123l-24 -112q38 54 85 85.5t94 31.5q10 0 15 -0.5t9 -1.5l-25 -119q-57 -1 -107.5 -23.5t-79.5 -67.5l-67 -317h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron",
    unicode: "\u0158",
    horizAdvX: 642,
    d: "M282 886l77 32l67 -63l94 63l63 -32l-124 -101h-97zM10 0l151 710h300q40 0 72 -16.5t54 -44t33.5 -63t11.5 -72.5q0 -39 -13 -76.5t-35.5 -70.5t-53 -59t-66.5 -41l96 -267h-156l-84 238h-123l-50 -238h-137zM382 359q20 0 39.5 11.5t34.5 31t24.5 45t9.5 53.5 q0 38 -18.5 63.5t-45.5 25.5h-154l-49 -230h159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcaron",
    unicode: "\u0159",
    horizAdvX: 378,
    d: "M134 698l77 32l67 -63l94 63l63 -32l-124 -101h-97zM107 524h123l-24 -112q38 54 85 85.5t94 31.5q10 0 15 -0.5t9 -1.5l-25 -119q-57 -1 -107.5 -23.5t-79.5 -67.5l-67 -317h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\u015A",
    horizAdvX: 592,
    d: "M431 794l-87 17l76 119h124zM243 -8q-75 0 -144.5 24t-119.5 68l86 119q5 -9 23.5 -23.5t46 -29t63 -24.5t74.5 -10q60 0 89.5 23.5t29.5 62.5q0 19 -11.5 33t-31.5 25t-47.5 20.5t-60.5 19.5q-75 23 -114 57.5t-39 95.5q0 62 25 110.5t66.5 82.5t96 51.5t113.5 17.5 q71 0 126.5 -23.5t93.5 -55.5l-85 -112q-4 7 -19 19t-37.5 23.5t-50.5 19.5t-58 8q-60 0 -90 -26t-30 -69q0 -17 8.5 -29.5t25.5 -22t41 -17.5t56 -17q40 -11 72.5 -25t55.5 -33.5t35.5 -46.5t12.5 -64q0 -67 -26 -115t-68 -78.5t-96.5 -44.5t-111.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\u015B",
    horizAdvX: 480,
    d: "M319 594l-87 17l76 119h124zM184 -10q-63 0 -119 21t-90 60l67 84q77 -69 159 -69q42 0 66 18t24 50q0 22 -21.5 34.5t-69.5 26.5q-40 12 -68.5 23.5t-47 25.5t-27 31.5t-8.5 40.5q0 44 19 80.5t51.5 62.5t75.5 40.5t91 14.5q56 0 101 -17t80 -55l-71 -81 q-32 30 -64.5 44t-66.5 14q-35 0 -60.5 -17t-25.5 -52q0 -21 19 -32t64 -24q84 -23 124 -51.5t40 -78.5q0 -43 -18 -78.5t-50 -61t-76.5 -40t-97.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scircumflex",
    unicode: "\u015C",
    horizAdvX: 592,
    d: "M267 829l123 101h97l80 -101l-77 -32l-67 63l-94 -63zM243 -8q-75 0 -144.5 24t-119.5 68l86 119q5 -9 23.5 -23.5t46 -29t63 -24.5t74.5 -10q60 0 89.5 23.5t29.5 62.5q0 19 -11.5 33t-31.5 25t-47.5 20.5t-60.5 19.5q-75 23 -114 57.5t-39 95.5q0 62 25 110.5 t66.5 82.5t96 51.5t113.5 17.5q71 0 126.5 -23.5t93.5 -55.5l-85 -112q-4 7 -19 19t-37.5 23.5t-50.5 19.5t-58 8q-60 0 -90 -26t-30 -69q0 -17 8.5 -29.5t25.5 -22t41 -17.5t56 -17q40 -11 72.5 -25t55.5 -33.5t35.5 -46.5t12.5 -64q0 -67 -26 -115t-68 -78.5t-96.5 -44.5 t-111.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scircumflex",
    unicode: "\u015D",
    horizAdvX: 480,
    d: "M170 629l123 101h97l80 -101l-77 -32l-67 63l-94 -63zM184 -10q-63 0 -119 21t-90 60l67 84q77 -69 159 -69q42 0 66 18t24 50q0 22 -21.5 34.5t-69.5 26.5q-40 12 -68.5 23.5t-47 25.5t-27 31.5t-8.5 40.5q0 44 19 80.5t51.5 62.5t75.5 40.5t91 14.5q56 0 101 -17 t80 -55l-71 -81q-32 30 -64.5 44t-66.5 14q-35 0 -60.5 -17t-25.5 -52q0 -21 19 -32t64 -24q84 -23 124 -51.5t40 -78.5q0 -43 -18 -78.5t-50 -61t-76.5 -40t-97.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni015E",
    unicode: "\u015E",
    horizAdvX: 592,
    d: "M139 -127q10 -7 32.5 -13t48.5 -6q27 0 44 9t17 30q0 15 -12 21t-32 6t-43 -4.5t-35 -7.5l58 85q-69 4 -131 27.5t-107 63.5l86 119q5 -9 23.5 -23.5t46 -29t63 -24.5t74.5 -10q60 0 89.5 23.5t29.5 62.5q0 19 -11.5 33t-31.5 25t-47.5 20.5t-60.5 19.5q-75 23 -114 57.5 t-39 95.5q0 62 25 110.5t66.5 82.5t96 51.5t113.5 17.5q71 0 126.5 -23.5t93.5 -55.5l-85 -112q-4 7 -19 19t-37.5 23.5t-50.5 19.5t-58 8q-60 0 -90 -26t-30 -69q0 -17 8.5 -29.5t25.5 -22t41 -17.5t56 -17q40 -11 72.5 -25t55.5 -33.5t35.5 -46.5t12.5 -64 q0 -63 -22.5 -108.5t-60 -76t-86.5 -47t-101 -19.5l-29 -35q7 2 15 3t16 1q29 0 48.5 -13.5t19.5 -42.5q0 -43 -36 -72.5t-109 -29.5q-32 0 -56.5 6t-41.5 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni015F",
    unicode: "\u015F",
    horizAdvX: 480,
    d: "M72 -127q10 -7 32.5 -13t48.5 -6q27 0 44 9t17 30q0 15 -12 21t-32 6t-43 -4.5t-35 -7.5l58 84q-54 5 -100 25t-75 54l67 84q77 -69 159 -69q42 0 66 18t24 50q0 22 -21.5 34.5t-69.5 26.5q-40 12 -68.5 23.5t-47 25.5t-27 31.5t-8.5 40.5q0 44 19 80.5t51.5 62.5 t75.5 40.5t91 14.5q56 0 101 -17t80 -55l-71 -81q-32 30 -64.5 44t-66.5 14q-35 0 -60.5 -17t-25.5 -52q0 -21 19 -32t64 -24q84 -23 124 -51.5t40 -78.5q0 -41 -16 -75t-45 -59t-69.5 -40.5t-89.5 -18.5l-27 -33q7 2 15 3t16 1q29 0 48.5 -13.5t19.5 -42.5q0 -43 -36 -72.5 t-109 -29.5q-32 0 -56.5 6t-41.5 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    horizAdvX: 592,
    d: "M273 898l77 32l67 -63l94 63l63 -32l-124 -101h-97zM243 -8q-75 0 -144.5 24t-119.5 68l86 119q5 -9 23.5 -23.5t46 -29t63 -24.5t74.5 -10q60 0 89.5 23.5t29.5 62.5q0 19 -11.5 33t-31.5 25t-47.5 20.5t-60.5 19.5q-75 23 -114 57.5t-39 95.5q0 62 25 110.5t66.5 82.5 t96 51.5t113.5 17.5q71 0 126.5 -23.5t93.5 -55.5l-85 -112q-4 7 -19 19t-37.5 23.5t-50.5 19.5t-58 8q-60 0 -90 -26t-30 -69q0 -17 8.5 -29.5t25.5 -22t41 -17.5t56 -17q40 -11 72.5 -25t55.5 -33.5t35.5 -46.5t12.5 -64q0 -67 -26 -115t-68 -78.5t-96.5 -44.5t-111.5 -14 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 480,
    d: "M170 698l77 32l67 -63l94 63l63 -32l-124 -101h-97zM184 -10q-63 0 -119 21t-90 60l67 84q77 -69 159 -69q42 0 66 18t24 50q0 22 -21.5 34.5t-69.5 26.5q-40 12 -68.5 23.5t-47 25.5t-27 31.5t-8.5 40.5q0 44 19 80.5t51.5 62.5t75.5 40.5t91 14.5q56 0 101 -17t80 -55 l-71 -81q-32 30 -64.5 44t-66.5 14q-35 0 -60.5 -17t-25.5 -52q0 -21 19 -32t64 -24q84 -23 124 -51.5t40 -78.5q0 -43 -18 -78.5t-50 -61t-76.5 -40t-97.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0162",
    unicode: "\u0162",
    horizAdvX: 592,
    d: "M288 589h-213l25 121h563l-26 -121h-212l-125 -589h-39l-35 -42q7 2 15 3t16 1q29 0 48.5 -13.5t19.5 -42.5q0 -43 -36 -72.5t-109 -29.5q-32 0 -56.5 6t-41.5 14l37 49q10 -7 32.5 -13t48.5 -6q27 0 44 9t17 30q0 15 -12 21t-32 6t-43 -4.5t-35 -7.5l63 92h-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0163",
    unicode: "\u0163",
    horizAdvX: 373,
    d: "M38 -127q10 -7 32.5 -13t48.5 -6q27 0 44 9t17 30q0 15 -12 21t-32 6t-43 -4.5t-35 -7.5l60 87q-32 7 -51.5 28.5t-19.5 59.5q0 20 4 37l64 301h-65l22 103h64l36 170h134l-36 -170h105l-22 -103h-104l-55 -256q-1 -5 -1.5 -8.5t-0.5 -7.5q0 -19 10.5 -27t27.5 -8 q20 0 39.5 6.5t33.5 12.5l4 -106q-26 -13 -62 -23t-72 -12l-28 -34q7 2 15 3t16 1q29 0 48.5 -13.5t19.5 -42.5q0 -43 -36 -72.5t-109 -29.5q-32 0 -56.5 6t-41.5 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcaron",
    unicode: "\u0164",
    horizAdvX: 592,
    d: "M263 884l77 32l67 -63l94 63l63 -32l-124 -101h-97zM289 589h-213l25 121h563l-26 -121h-212l-125 -589h-138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcaron",
    unicode: "\u0165",
    horizAdvX: 373,
    d: "M342 611l77 119h123l-119 -145zM156 -9q-48 0 -78.5 21.5t-30.5 70.5q0 20 4 37l64 301h-65l22 103h64l36 170h134l-36 -170h105l-22 -103h-104l-55 -256q-1 -5 -1.5 -8.5t-0.5 -7.5q0 -19 10.5 -27t27.5 -8q20 0 39.5 6.5t33.5 12.5l4 -106q-29 -14 -70 -25t-81 -11z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tbar",
    unicode: "\u0166",
    horizAdvX: 618,
    d: "M79 379h177l45 210h-213l25 121h563l-25 -121h-213l-45 -210h178l-14 -66h-178l-66 -313h-137l66 313h-177z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tbar",
    unicode: "\u0167",
    horizAdvX: 374,
    d: "M35 344h64l17 77h-65l22 103h65l36 170h134l-36 -170h104l-22 -103h-104l-17 -77h105l-17 -80h-105l-19 -90q-2 -8 -2.5 -13.5t-0.5 -10.5q0 -20 10.5 -28t27.5 -8q19 0 39 7t33 12l5 -106q-30 -14 -71 -25t-82 -11q-47 0 -77.5 21.5t-30.5 70.5q0 17 3 37l31 144h-64z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Utilde",
    unicode: "\u0168",
    horizAdvX: 719,
    d: "M295 -5q-64 0 -108.5 18.5t-72.5 51t-40.5 76t-12.5 94.5q0 55 13 113l77 362h137l-77 -362q-5 -23 -7.5 -45.5t-2.5 -43.5q0 -30 6 -56t20.5 -45t37 -30t55.5 -11q45 0 80 20t60.5 52t42.5 73.5t26 85.5l77 362h137l-77 -362q-15 -73 -46 -137t-77 -112t-108 -76 t-140 -28zM519 788q-21 0 -36 7t-27.5 15.5t-24.5 15.5t-28 7t-26.5 -7t-16.5 -16t-8.5 -16.5t-2.5 -8.5h-74q2 9 12 30.5t28 43t43.5 38t57.5 16.5q22 0 36 -7.5t26 -16t24 -16t29 -7.5t28.5 7t18.5 16t10.5 17t3.5 10h73q-2 -7 -12 -28t-28.5 -43t-45 -39.5t-60.5 -17.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "utilde",
    unicode: "\u0169",
    horizAdvX: 595,
    d: "M145 -10q-123 0 -123 128q0 17 2.5 36.5t7.5 41.5l70 328h133l-63 -299q-3 -15 -5 -27t-2 -23q0 -71 60 -71q35 0 73.5 23.5t70.5 71.5l69 325h134l-79 -370q-1 -5 -1.5 -9.5t-0.5 -8.5q0 -21 24 -22l-24 -114q-18 -3 -31.5 -5t-24.5 -2q-35 0 -54.5 14t-19.5 43 q0 8 1 18t6 30q-45 -54 -102.5 -81t-120.5 -27zM408 602q-21 0 -36 7t-27.5 15.5t-24.5 15.5t-28 7t-26.5 -7t-16.5 -16t-8.5 -16.5t-2.5 -8.5h-74q2 9 12 30.5t28 43t43.5 38t57.5 16.5q22 0 36 -7.5t26 -16t24 -16t29 -7.5t28.5 7t18.5 16t10.5 17t3.5 10h73 q-2 -7 -12 -28t-28.5 -43t-45 -39.5t-60.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Umacron",
    unicode: "\u016A",
    horizAdvX: 719,
    d: "M295 -5q-64 0 -108.5 18.5t-72.5 51t-40.5 76t-12.5 94.5q0 55 13 113l77 362h137l-77 -362q-5 -23 -7.5 -45.5t-2.5 -43.5q0 -30 6 -56t20.5 -45t37 -30t55.5 -11q45 0 80 20t60.5 52t42.5 73.5t26 85.5l77 362h137l-77 -362q-15 -73 -46 -137t-77 -112t-108 -76 t-140 -28zM321 818l18 83h286l-18 -83h-286z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "umacron",
    unicode: "\u016B",
    horizAdvX: 595,
    d: "M145 -10q-123 0 -123 128q0 17 2.5 36.5t7.5 41.5l70 328h133l-63 -299q-3 -15 -5 -27t-2 -23q0 -71 60 -71q35 0 73.5 23.5t70.5 71.5l69 325h134l-79 -370q-1 -5 -1.5 -9.5t-0.5 -8.5q0 -21 24 -22l-24 -114q-18 -3 -31.5 -5t-24.5 -2q-35 0 -54.5 14t-19.5 43 q0 8 1 18t6 30q-45 -54 -102.5 -81t-120.5 -27zM209 632l18 83h286l-18 -83h-286z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ubreve",
    unicode: "\u016C",
    horizAdvX: 719,
    d: "M295 -5q-64 0 -108.5 18.5t-72.5 51t-40.5 76t-12.5 94.5q0 55 13 113l77 362h137l-77 -362q-5 -23 -7.5 -45.5t-2.5 -43.5q0 -30 6 -56t20.5 -45t37 -30t55.5 -11q45 0 80 20t60.5 52t42.5 73.5t26 85.5l77 362h137l-77 -362q-15 -73 -46 -137t-77 -112t-108 -76 t-140 -28zM459 842q21 0 41.5 21t30.5 53h72q-6 -29 -21 -53.5t-35.5 -42.5t-46 -28t-53.5 -10q-49 0 -76.5 28t-27.5 73q0 18 4 33h72q-3 -11 -3 -20q0 -23 12 -38.5t31 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ubreve",
    unicode: "\u016D",
    horizAdvX: 595,
    d: "M145 -10q-123 0 -123 128q0 17 2.5 36.5t7.5 41.5l70 328h133l-63 -299q-3 -15 -5 -27t-2 -23q0 -71 60 -71q35 0 73.5 23.5t70.5 71.5l69 325h134l-79 -370q-1 -5 -1.5 -9.5t-0.5 -8.5q0 -21 24 -22l-24 -114q-18 -3 -31.5 -5t-24.5 -2q-35 0 -54.5 14t-19.5 43 q0 8 1 18t6 30q-45 -54 -102.5 -81t-120.5 -27zM351 656q21 0 41.5 21t30.5 53h72q-6 -29 -21 -53.5t-35.5 -42.5t-46 -28t-53.5 -10q-49 0 -76.5 28t-27.5 73q0 18 4 33h72q-3 -11 -3 -20q0 -23 12 -38.5t31 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uring",
    unicode: "\u016E",
    horizAdvX: 719,
    d: "M374 824q0 44 32 68t81 24q38 0 59 -16.5t21 -45.5q0 -43 -31.5 -67.5t-81.5 -24.5q-37 0 -58.5 16.5t-21.5 45.5zM478 875q-19 0 -32.5 -12t-13.5 -30q0 -13 8.5 -21.5t22.5 -8.5q17 0 32 12t15 30q0 14 -9 22t-23 8zM295 -5q-64 0 -108.5 18.5t-72.5 51t-40.5 76 t-12.5 94.5q0 55 13 113l77 362h137l-77 -362q-5 -23 -7.5 -45.5t-2.5 -43.5q0 -30 6 -56t20.5 -45t37 -30t55.5 -11q45 0 80 20t60.5 52t42.5 73.5t26 85.5l77 362h137l-77 -362q-15 -73 -46 -137t-77 -112t-108 -76t-140 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uring",
    unicode: "\u016F",
    horizAdvX: 595,
    d: "M260 638q0 44 32 68t81 24q38 0 59 -16.5t21 -45.5q0 -43 -31.5 -67.5t-81.5 -24.5q-37 0 -58.5 16.5t-21.5 45.5zM364 689q-19 0 -32.5 -12t-13.5 -30q0 -13 8.5 -21.5t22.5 -8.5q17 0 32 12t15 30q0 14 -9 22t-23 8zM145 -10q-123 0 -123 128q0 17 2.5 36.5t7.5 41.5 l70 328h133l-63 -299q-3 -15 -5 -27t-2 -23q0 -71 60 -71q35 0 73.5 23.5t70.5 71.5l69 325h134l-79 -370q-1 -5 -1.5 -9.5t-0.5 -8.5q0 -21 24 -22l-24 -114q-18 -3 -31.5 -5t-24.5 -2q-35 0 -54.5 14t-19.5 43q0 8 1 18t6 30q-45 -54 -102.5 -81t-120.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhungarumlaut",
    unicode: "\u0170",
    horizAdvX: 719,
    d: "M295 -5q-64 0 -108.5 18.5t-72.5 51t-40.5 76t-12.5 94.5q0 55 13 113l77 362h137l-77 -362q-5 -23 -7.5 -45.5t-2.5 -43.5q0 -30 6 -56t20.5 -45t37 -30t55.5 -11q45 0 80 20t60.5 52t42.5 73.5t26 85.5l77 362h137l-77 -362q-15 -73 -46 -137t-77 -112t-108 -76 t-140 -28zM382 782l-67 16l70 119h103zM538 782l-66 16l69 119h103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhungarumlaut",
    unicode: "\u0171",
    horizAdvX: 595,
    d: "M145 -10q-123 0 -123 128q0 17 2.5 36.5t7.5 41.5l70 328h133l-63 -299q-3 -15 -5 -27t-2 -23q0 -71 60 -71q35 0 73.5 23.5t70.5 71.5l69 325h134l-79 -370q-1 -5 -1.5 -9.5t-0.5 -8.5q0 -21 24 -22l-24 -114q-18 -3 -31.5 -5t-24.5 -2q-35 0 -54.5 14t-19.5 43 q0 8 1 18t6 30q-45 -54 -102.5 -81t-120.5 -27zM265 595l-67 16l70 119h103zM421 595l-66 16l69 119h103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uogonek",
    unicode: "\u0172",
    horizAdvX: 719,
    d: "M260 -196q-50 8 -73.5 28.5t-23.5 47.5q0 60 97 117q-54 5 -92 25t-61.5 51.5t-34.5 73t-11 88.5q0 55 13 113l77 362h137l-77 -362q-5 -23 -7.5 -45.5t-2.5 -43.5q0 -30 6 -56t20.5 -45t37 -30t55.5 -11q45 0 80 20t60.5 52t42.5 73.5t26 85.5l77 362h137l-77 -362 q-14 -68 -41.5 -128.5t-69 -107.5t-96 -77.5t-122.5 -37.5q-45 -26 -66 -47t-21 -41q0 -32 52 -35l-42 -70v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uogonek",
    unicode: "\u0173",
    horizAdvX: 595,
    d: "M145 -10q-123 0 -123 128q0 17 2.5 36.5t7.5 41.5l70 328h133l-63 -299q-3 -15 -5 -27t-2 -23q0 -71 60 -71q35 0 73.5 23.5t70.5 71.5l69 325h134l-79 -370q-1 -5 -1.5 -9.5t-0.5 -8.5q0 -21 24 -22l-24 -114q-92 -53 -92 -91q0 -32 52 -35l-42 -70q-50 8 -73.5 28.5 t-23.5 47.5q0 59 95 116q-46 10 -46 54q0 8 1 18t6 30q-45 -54 -102.5 -81t-120.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex",
    unicode: "\u0174",
    horizAdvX: 1002,
    d: "M455 815l123 101h97l80 -101l-77 -32l-67 63l-94 -63zM82 710h149l68 -552l128 227l-44 323h127l24 -235l123 235h128l-183 -323l33 -227l302 552h150l-424 -710h-115l-51 298l-178 -298h-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wcircumflex",
    unicode: "\u0175",
    horizAdvX: 790,
    d: "M304 629l123 101h97l80 -101l-77 -32l-67 63l-94 -63zM42 524h131l63 -404q9 11 21 30.5t24 40.5t23.5 40.5t18.5 30.5l-56 262h117l26 -162q6 11 16.5 33.5t21.5 47t20 47t12 34.5h109q-24 -71 -54.5 -134t-72.5 -127l26 -120q40 54 71 100t55 90.5t43.5 90.5t38.5 100 h123q-45 -131 -124.5 -262t-190.5 -262h-101l-29 171q-7 -10 -22 -34.5t-31.5 -51.5t-32 -51t-23.5 -34h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ycircumflex",
    unicode: "\u0176",
    horizAdvX: 619,
    d: "M225 250l-144 460h150l88 -342l236 342h149l-343 -462l-52 -248h-137zM258 815l123 101h97l80 -101l-77 -32l-67 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex",
    unicode: "\u0177",
    horizAdvX: 520,
    d: "M-44 -126q30 3 51.5 7t38 12.5t30.5 22t29 34.5l29 39l-87 535h137l45 -408l34 56q31 51 54 95.5t41 86.5t31 83.5t24 86.5h130q-14 -48 -29 -90t-38 -89t-56.5 -104.5t-82.5 -137.5l-80 -129q-35 -56 -67.5 -94.5t-66 -62.5t-70.5 -34.5t-81 -11.5zM174 629l123 101h97 l80 -101l-77 -32l-67 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    horizAdvX: 619,
    d: "M225 250l-144 460h150l88 -342l236 342h149l-343 -462l-52 -248h-137zM257 791l26 119h111l-26 -119h-111zM445 791l25 119h110l-24 -119h-111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\u0179",
    horizAdvX: 597,
    d: "M413 780l-87 17l76 119h124zM-13 104l476 485h-361l25 121h521l-22 -104l-463 -485h362l-25 -121h-535z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\u017A",
    horizAdvX: 471,
    d: "M304 594l-87 17l76 119h124zM-21 82l342 348h-256l20 94h400l-18 -82l-341 -348h272l-20 -94h-416z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\u017B",
    horizAdvX: 597,
    d: "M-13 104l476 485h-361l25 121h521l-22 -104l-463 -485h362l-25 -121h-535zM335 790l27 126h120l-26 -126h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\u017C",
    horizAdvX: 471,
    d: "M-21 82l342 348h-256l20 94h400l-18 -82l-341 -348h272l-20 -94h-416zM228 604l27 126h120l-26 -126h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 597,
    d: "M261 884l77 32l67 -63l94 63l63 -32l-124 -101h-97zM-13 104l476 485h-361l25 121h521l-22 -104l-463 -485h362l-25 -121h-535z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 471,
    d: "M153 698l77 32l67 -63l94 63l63 -32l-124 -101h-97zM-21 82l342 348h-256l20 94h400l-18 -82l-341 -348h272l-20 -94h-416z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Schwa",
    unicode: "\u018F",
    horizAdvX: 718,
    d: "M288 -5q-65 0 -114.5 24t-83.5 64.5t-51 92t-17 107.5q0 42 8 71.5t16 46.5h508q1 8 1.5 15.5t0.5 15.5q0 75 -40 117.5t-102 42.5q-26 0 -52.5 -8t-50.5 -22t-43.5 -34.5t-31.5 -44.5l-130 47q28 41 65 75t80.5 58.5t92 38t99.5 13.5q63 0 111.5 -24t82 -64t50.5 -92.5 t17 -109.5q0 -80 -32.5 -157t-88.5 -138t-132 -98t-163 -37zM316 116q36 0 69 13t61.5 36.5t50 56t33.5 71.5h-364q-4 -17 -4 -38q0 -30 11 -55.5t31 -44t48.5 -29t63.5 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin",
    unicode: "\u0192",
    horizAdvX: 526,
    d: "M52 -196q-36 0 -66.5 11.5t-51.5 35.5l76 91q8 -11 21.5 -16.5t28.5 -5.5q24 0 45 18.5t27 47.5l80 374h-64l21 103h65l14 65q10 49 30.5 88t48 66.5t62 42.5t72.5 15q61 0 118 -31l-47 -101q-13 8 -31 13.5t-35 5.5q-63 0 -83 -94l-15 -70h120l-22 -103h-120l-79 -371 q-9 -41 -30 -75t-50 -58.5t-64 -38t-71 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C4",
    unicode: "\u01C4",
    horizAdvX: 1289,
    d: "M953 884l77 32l67 -63l94 63l63 -32l-124 -101h-97zM679 104l476 485h-361l25 121h521l-22 -104l-463 -485h362l-25 -121h-535zM161 710h247q69 0 119.5 -21.5t83.5 -58.5t49 -87t16 -108q0 -94 -31.5 -173.5t-88 -137.5t-133 -91t-166.5 -33h-247zM282 121 q57 0 103.5 24t79.5 64.5t51 93.5t18 112q0 78 -38.5 126t-113.5 48h-110l-99 -468h109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C5",
    unicode: "\u01C5",
    horizAdvX: 1163,
    d: "M845 698l77 32l67 -63l94 63l63 -32l-124 -101h-97zM671 82l342 348h-256l20 94h400l-18 -82l-341 -348h272l-20 -94h-416zM161 710h247q69 0 119.5 -21.5t83.5 -58.5t49 -87t16 -108q0 -94 -31.5 -173.5t-88 -137.5t-133 -91t-166.5 -33h-247zM282 121q57 0 103.5 24 t79.5 64.5t51 93.5t18 112q0 78 -38.5 126t-113.5 48h-110l-99 -468h109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C6",
    unicode: "\u01C6",
    horizAdvX: 1094,
    d: "M776 698l77 32l67 -63l94 63l63 -32l-124 -101h-97zM603 82l342 348h-256l20 94h400l-18 -82l-341 -348h272l-20 -94h-416zM201 -10q-44 0 -78.5 16.5t-58.5 45.5t-36.5 68.5t-12.5 84.5q0 65 23.5 124.5t63 104.5t91.5 72t109 27q54 0 92 -28t52 -73l64 298h134 l-122 -576q-3 -11 -3 -18q0 -21 24 -22l-24 -114q-18 -3 -31.5 -5t-23.5 -2q-35 0 -55.5 14t-20.5 43q0 8 1.5 17.5t4.5 23.5q-38 -50 -89.5 -75.5t-103.5 -25.5zM261 104q17 0 36.5 6.5t37.5 18.5t34 28t27 35l26 125q-6 44 -35 73t-67 29q-32 0 -62 -16.5t-52.5 -44 t-36 -62t-13.5 -70.5q0 -52 28 -87t77 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C7",
    unicode: "\u01C7",
    horizAdvX: 1040,
    d: "M655 -11q-85 0 -137 44l54 112q10 -10 39 -22t70 -12q39 0 65 14.5t44 44.5t31 74.5t26 104.5l77 360h138l-77 -360q-17 -81 -39 -147.5t-58.5 -113.5t-92.5 -73t-140 -26zM161 710h137l-125 -589h339l-25 -121h-477z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C8",
    unicode: "\u01C8",
    horizAdvX: 819,
    d: "M478 -196q-36 0 -66.5 11.5t-51.5 35.5l76 91q8 -11 21.5 -16.5t28.5 -5.5q24 0 45 18.5t27 47.5l115 538h134l-112 -528q-9 -42 -30 -77.5t-50.5 -61t-64.5 -39.5t-72 -14zM717 730h134l-29 -133h-134zM161 710h137l-125 -589h339l-25 -121h-477z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C9",
    unicode: "\u01C9",
    horizAdvX: 567,
    d: "M226 -196q-36 0 -66.5 11.5t-51.5 35.5l76 91q8 -11 21.5 -16.5t28.5 -5.5q24 0 45 18.5t27 47.5l115 538h134l-112 -528q-9 -42 -30 -77.5t-50.5 -61t-64.5 -39.5t-72 -14zM465 730h134l-29 -133h-134zM121 -8q-51 0 -78 23.5t-27 67.5q0 9 1 18t3 20l130 609h133 l-119 -562q-1 -5 -1.5 -10t-0.5 -10q0 -41 41 -41q11 0 25.5 4t27.5 10l-4 -102q-29 -13 -65.5 -20t-65.5 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CA",
    unicode: "\u01CA",
    horizAdvX: 1212,
    d: "M827 -11q-85 0 -137 44l54 112q10 -10 39 -22t70 -12q39 0 65 14.5t44 44.5t31 74.5t26 104.5l77 360h138l-77 -360q-17 -81 -39 -147.5t-58.5 -113.5t-92.5 -73t-140 -26zM161 710h107l242 -466l99 465h137l-151 -709h-111l-241 455l-96 -455h-137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CB",
    unicode: "\u01CB",
    horizAdvX: 991,
    d: "M650 -196q-36 0 -66.5 11.5t-51.5 35.5l76 91q8 -11 21.5 -16.5t28.5 -5.5q24 0 45 18.5t27 47.5l115 538h134l-112 -528q-9 -42 -30 -77.5t-50.5 -61t-64.5 -39.5t-72 -14zM889 730h134l-29 -133h-134zM161 710h107l242 -466l99 465h137l-151 -709h-111l-241 455 l-96 -455h-137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CC",
    unicode: "\u01CC",
    horizAdvX: 840,
    d: "M499 -196q-36 0 -66.5 11.5t-51.5 35.5l76 91q8 -11 21.5 -16.5t28.5 -5.5q24 0 45 18.5t27 47.5l115 538h134l-112 -528q-9 -42 -30 -77.5t-50.5 -61t-64.5 -39.5t-72 -14zM738 730h134l-29 -133h-134zM107 524h121l-21 -97q38 50 96 78t123 28q34 0 56.5 -9.5t36 -25.5 t19 -38.5t5.5 -47.5q0 -20 -2.5 -41.5t-7.5 -43.5l-69 -327h-134l62 294q3 15 5 28.5t2 24.5q0 35 -15.5 51.5t-41.5 16.5q-18 0 -39 -8t-41 -22.5t-37.5 -34.5t-29.5 -44l-65 -306h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oogonek",
    unicode: "\u01EA",
    horizAdvX: 728,
    d: "M264 -196q-50 8 -73.5 28.5t-23.5 47.5q0 61 98 117q-56 6 -98.5 32.5t-71 66.5t-43.5 90t-15 104q0 81 34.5 157.5t92.5 136t133.5 95.5t157.5 36q63 0 111.5 -25t81 -66t49.5 -95t17 -111q0 -75 -30 -146.5t-81 -129t-118.5 -96.5t-142.5 -48q-88 -51 -88 -89 q0 -32 52 -35zM326 117q55 0 100.5 27t78.5 69t51 93.5t18 101.5q0 37 -9 70.5t-27.5 58.5t-46.5 40t-65 15q-55 0 -101 -26.5t-79 -68.5t-51 -93.5t-18 -102.5q0 -37 9 -70t28 -58.5t46.5 -40.5t65.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oogonek",
    unicode: "\u01EB",
    horizAdvX: 586,
    d: "M202 -201q-50 8 -73.5 28.5t-23.5 47.5q0 59 96 116q-46 4 -81 23t-58 48t-35 66.5t-12 79.5q0 62 24.5 120.5t68 104t103.5 73t131 27.5q52 0 91.5 -17.5t66.5 -47t40.5 -69.5t13.5 -85q0 -56 -20 -108.5t-55.5 -96t-85.5 -74t-110 -40.5q-91 -53 -91 -91q0 -32 52 -35z M251 104q31 0 60.5 15.5t52.5 41.5t37 61.5t14 75.5q0 54 -26 87.5t-71 33.5q-31 0 -60.5 -15.5t-52.5 -42t-37 -61.5t-14 -75q0 -54 26 -87.5t71 -33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F1",
    unicode: "\u01F1",
    horizAdvX: 1279,
    d: "M669 104l476 485h-361l25 121h521l-22 -104l-463 -485h362l-25 -121h-535zM161 710h247q69 0 119.5 -21.5t83.5 -58.5t49 -87t16 -108q0 -94 -31.5 -173.5t-88 -137.5t-133 -91t-166.5 -33h-247zM282 121q57 0 103.5 24t79.5 64.5t51 93.5t18 112q0 78 -38.5 126 t-113.5 48h-110l-99 -468h109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F2",
    unicode: "\u01F2",
    horizAdvX: 1161,
    d: "M669 82l342 348h-256l20 94h400l-18 -82l-341 -348h272l-20 -94h-416zM161 710h247q69 0 119.5 -21.5t83.5 -58.5t49 -87t16 -108q0 -94 -31.5 -173.5t-88 -137.5t-133 -91t-166.5 -33h-247zM282 121q57 0 103.5 24t79.5 64.5t51 93.5t18 112q0 78 -38.5 126t-113.5 48 h-110l-99 -468h109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F3",
    unicode: "\u01F3",
    horizAdvX: 1094,
    d: "M603 82l342 348h-256l20 94h400l-18 -82l-341 -348h272l-20 -94h-416zM201 -10q-44 0 -78.5 16.5t-58.5 45.5t-36.5 68.5t-12.5 84.5q0 65 23.5 124.5t63 104.5t91.5 72t109 27q54 0 92 -28t52 -73l64 298h134l-122 -576q-3 -11 -3 -18q0 -21 24 -22l-24 -114 q-18 -3 -31.5 -5t-23.5 -2q-35 0 -55.5 14t-20.5 43q0 8 1.5 17.5t4.5 23.5q-38 -50 -89.5 -75.5t-103.5 -25.5zM261 104q17 0 36.5 6.5t37.5 18.5t34 28t27 35l26 125q-6 44 -35 73t-67 29q-32 0 -62 -16.5t-52.5 -44t-36 -62t-13.5 -70.5q0 -52 28 -87t77 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gacute",
    unicode: "\u01F4",
    horizAdvX: 697,
    d: "M487 780l-87 17l76 119h124zM494 80q-51 -44 -100.5 -64.5t-102.5 -20.5q-57 0 -103.5 22.5t-80 61.5t-52 92.5t-18.5 115.5q0 86 35 163.5t93 136.5t133 93.5t155 34.5q95 0 154.5 -42t79.5 -113l-119 -76q-14 53 -52.5 81t-92.5 28q-50 0 -94 -24.5t-78 -65t-53.5 -93 t-19.5 -108.5q0 -39 10.5 -73t30 -59t47.5 -39t63 -14q96 0 193 97l11 50h-135l22 101h249l-78 -365h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gacute",
    unicode: "\u01F5",
    horizAdvX: 611,
    d: "M348 594l-87 17l76 119h124zM162 -223q-82 0 -132.5 28.5t-79.5 80.5l88 71q20 -37 58 -58t87 -21q29 0 57.5 8.5t52 26.5t41 46t25.5 66l14 66q-34 -45 -83 -69.5t-100 -24.5q-42 0 -74 16.5t-54.5 44.5t-34 66t-11.5 82q0 65 24 124.5t64.5 104.5t94 71.5t113.5 26.5 q58 0 95.5 -27.5t55.5 -73.5l19 92h118l-107 -499q-12 -58 -42.5 -104t-74.5 -78t-98.5 -49t-115.5 -17zM259 104q39 0 76.5 26t59.5 62l26 125q-7 46 -36 74t-67 28q-33 0 -62.5 -17t-52 -44.5t-35.5 -62t-13 -69.5q0 -26 7.5 -48t21 -38.5t32.5 -26t43 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aringacute",
    unicode: "\u01FA",
    horizAdvX: 645,
    d: "M491 807q24 -16 24 -47q0 -23 -10 -41.5t-27 -30.5l100 -688h-142l-22 177h-229l-96 -177h-142l392 687q-17 17 -17 43q0 35 20.5 57t54.5 30l70 105h124zM411 274l-31 279l-152 -279h183zM426 781q-19 0 -32.5 -12t-13.5 -30q0 -13 8.5 -21.5t22.5 -8.5q17 0 32 12 t15 30q0 14 -9 22t-23 8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aringacute",
    unicode: "\u01FB",
    d: "M201 -10q-44 0 -78.5 16.5t-58.5 45.5t-36.5 68.5t-12.5 84.5q0 65 23.5 124.5t63 104.5t91.5 72t109 27q54 0 92 -28t52 -73l20 90h134l-78 -368q-3 -11 -3 -18q0 -21 24 -22l-24 -114q-18 -3 -31.5 -5t-23.5 -2q-35 0 -55.5 15t-20.5 45q0 12 6 38q-38 -50 -89.5 -75.5 t-103.5 -25.5zM261 104q17 0 36.5 6.5t37.5 18.5t34 28t27 35l26 125q-6 44 -35 73t-67 29q-32 0 -62 -16.5t-52.5 -44t-36 -62t-13.5 -70.5q0 -52 28 -87t77 -35zM398 750l-87 17l76 119h124zM246 638q0 44 32 68t81 24q38 0 59 -16.5t21 -45.5q0 -43 -31.5 -67.5 t-81.5 -24.5q-37 0 -58.5 16.5t-21.5 45.5zM350 689q-19 0 -32.5 -12t-13.5 -30q0 -13 8.5 -21.5t22.5 -8.5q17 0 32 12t15 30q0 14 -9 22t-23 8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AEacute",
    unicode: "\u01FC",
    horizAdvX: 929,
    d: "M620 780l-87 17l76 119h124zM490 710h484l-26 -121h-311l-35 -167h259l-26 -121h-259l-38 -180h318l-25 -121h-456l38 177h-213l-133 -177h-147zM428 297l55 258l-198 -258h143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aeacute",
    unicode: "\u01FD",
    horizAdvX: 893,
    d: "M525 594l-87 17l76 119h124zM131 -10q-66 0 -104 38.5t-38 98.5q0 43 20 79t54 62.5t80 41.5t98 15q31 0 59 -5t48 -15q5 19 11.5 34t6.5 32q0 31 -22.5 50t-67.5 19q-39 0 -80 -15t-88 -44l-22 85q112 67 224 67q58 0 97.5 -19.5t59.5 -54.5q39 34 88 54t105 20 q52 0 91.5 -17t66 -47t40 -70t13.5 -85q0 -38 -7 -60.5t-12 -34.5h-384q-1 -6 -1 -11.5v-10.5q0 -29 8.5 -49.5t22.5 -34t33 -19.5t39 -6q37 0 74 19.5t56 51.5l107 -32q-20 -30 -48 -55t-61.5 -43.5t-72 -28.5t-80.5 -10q-72 0 -120.5 29.5t-71.5 78.5q-23 -29 -52 -49.5 t-59 -33.5t-58.5 -19t-52.5 -6zM191 88q18 0 39 5.5t40.5 15t35.5 22t24 26.5q-1 5 -1.5 11.5t-0.5 13.5q0 23 5 51q-19 8 -42 12.5t-44 4.5q-26 0 -49.5 -7.5t-40.5 -20t-27 -30.5t-10 -39q0 -28 18 -46.5t53 -18.5zM734 302q1 7 1 12.5v12.5q0 50 -26 79.5t-73 29.5 q-52 0 -94 -37t-59 -97h251z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslashacute",
    unicode: "\u01FE",
    horizAdvX: 729,
    d: "M761 710l-97 -110q25 -39 37.5 -85.5t12.5 -96.5q0 -80 -34 -156.5t-91.5 -135.5t-132.5 -95t-157 -36q-39 0 -72.5 9.5t-61.5 26.5l-28 -31h-148l97 110q-25 38 -37 84t-12 96q0 81 34.5 157.5t92.5 136t133.5 95.5t157.5 36q38 0 70.5 -9.5t60.5 -26.5l27 31h148z M326 117q55 0 100.5 27t78.5 69t51 93.5t18 101.5q0 40 -11 76l-308 -350q31 -17 71 -17zM177 301q0 -42 10 -75l307 349q-14 8 -31 12.5t-37 4.5q-55 0 -101 -26.5t-79 -68.5t-51 -93.5t-18 -102.5zM498 780l-87 17l76 119h124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslashacute",
    unicode: "\u01FF",
    horizAdvX: 586,
    d: "M58 67q-22 29 -32.5 65t-10.5 76q0 62 24.5 120.5t68 104t104 73t131.5 27.5q39 0 71 -10t57 -28l34 33h76l-73 -69q46 -60 46 -145q0 -62 -24.5 -120t-68 -103.5t-103.5 -73t-131 -27.5q-41 0 -74 10.5t-58 30.5l-37 -35h-74zM251 104q31 0 60.5 15.5t52.5 41.5t37 61.5 t14 75.5q0 32 -11 60l-215 -230q24 -24 62 -24zM154 225q0 -34 10 -58l213 230q-25 22 -59 22q-31 0 -60.5 -15.5t-52.5 -42t-37 -61.5t-14 -75zM377 594l-87 17l76 119h124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adblgrave",
    unicode: "\u0200",
    horizAdvX: 645,
    d: "M352 710h123l103 -710h-142l-22 177h-229l-96 -177h-142zM411 274l-31 279l-152 -279h183zM433 918h102l20 -119l-73 -18zM276 918h104l18 -119l-72 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adblgrave",
    unicode: "\u0201",
    d: "M201 -10q-44 0 -78.5 16.5t-58.5 45.5t-36.5 68.5t-12.5 84.5q0 65 23.5 124.5t63 104.5t91.5 72t109 27q54 0 92 -28t52 -73l20 90h134l-78 -368q-3 -11 -3 -18q0 -21 24 -22l-24 -114q-18 -3 -31.5 -5t-23.5 -2q-35 0 -55.5 15t-20.5 45q0 12 6 38q-38 -50 -89.5 -75.5 t-103.5 -25.5zM261 104q17 0 36.5 6.5t37.5 18.5t34 28t27 35l26 125q-6 44 -35 73t-67 29q-32 0 -62 -16.5t-52.5 -44t-36 -62t-13.5 -70.5q0 -52 28 -87t77 -35zM345 730h102l20 -119l-73 -18zM188 730h104l18 -119l-72 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ainvertedbreve",
    unicode: "\u0202",
    horizAdvX: 645,
    d: "M352 710h123l103 -710h-142l-22 177h-229l-96 -177h-142zM411 274l-31 279l-152 -279h183zM301 782q6 29 20.5 53.5t35.5 42.5t46.5 28t52.5 10q49 0 76 -30t27 -74q0 -15 -3 -30h-71q1 8 1.5 15t0.5 13q0 46 -42 46q-58 0 -73 -74h-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ainvertedbreve",
    unicode: "\u0203",
    d: "M201 -10q-44 0 -78.5 16.5t-58.5 45.5t-36.5 68.5t-12.5 84.5q0 65 23.5 124.5t63 104.5t91.5 72t109 27q54 0 92 -28t52 -73l20 90h134l-78 -368q-3 -11 -3 -18q0 -21 24 -22l-24 -114q-18 -3 -31.5 -5t-23.5 -2q-35 0 -55.5 15t-20.5 45q0 12 6 38q-38 -50 -89.5 -75.5 t-103.5 -25.5zM261 104q17 0 36.5 6.5t37.5 18.5t34 28t27 35l26 125q-6 44 -35 73t-67 29q-32 0 -62 -16.5t-52.5 -44t-36 -62t-13.5 -70.5q0 -52 28 -87t77 -35zM211 596q6 29 20.5 53.5t35.5 42.5t46.5 28t52.5 10q49 0 76 -30t27 -74q0 -15 -3 -30h-71q1 8 1.5 15 t0.5 13q0 46 -42 46q-58 0 -73 -74h-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edblgrave",
    unicode: "\u0204",
    horizAdvX: 578,
    d: "M422 918h102l20 -119l-73 -18zM265 918h104l18 -119l-72 -18zM161 710h460l-25 -121h-324l-36 -171h279l-24 -112h-279l-39 -185h332l-26 -121h-469z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edblgrave",
    unicode: "\u0205",
    horizAdvX: 551,
    d: "M366 730h102l20 -119l-73 -18zM209 730h104l18 -119l-72 -18zM230 -10q-50 0 -89.5 16.5t-67.5 46t-42.5 70t-14.5 88.5q0 65 25.5 123.5t70 102.5t105 70t130.5 26q85 0 135.5 -37.5t50.5 -108.5q0 -169 -302 -169h-37t-40 2v-13q0 -53 24 -86t76 -33q40 0 75.5 19 t56.5 53l106 -33q-20 -30 -49 -55.5t-63.5 -43.5t-72.5 -28t-77 -10zM327 436q-29 0 -54 -10.5t-44.5 -28.5t-34.5 -42t-24 -51q16 -1 31 -1h31q48 0 81.5 5t54 15t29.5 23.5t9 31.5q0 29 -22 43.5t-57 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Einvertedbreve",
    unicode: "\u0206",
    horizAdvX: 578,
    d: "M281 782q6 29 20.5 53.5t35.5 42.5t46.5 28t52.5 10q49 0 76 -30t27 -74q0 -15 -3 -30h-71q1 8 1.5 15t0.5 13q0 46 -42 46q-58 0 -73 -74h-71zM161 710h460l-25 -121h-324l-36 -171h279l-24 -112h-279l-39 -185h332l-26 -121h-469z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "einvertedbreve",
    unicode: "\u0207",
    horizAdvX: 551,
    d: "M237 596q6 29 20.5 53.5t35.5 42.5t46.5 28t52.5 10q49 0 76 -30t27 -74q0 -15 -3 -30h-71q1 8 1.5 15t0.5 13q0 46 -42 46q-58 0 -73 -74h-71zM230 -10q-50 0 -89.5 16.5t-67.5 46t-42.5 70t-14.5 88.5q0 65 25.5 123.5t70 102.5t105 70t130.5 26q85 0 135.5 -37.5 t50.5 -108.5q0 -169 -302 -169h-37t-40 2v-13q0 -53 24 -86t76 -33q40 0 75.5 19t56.5 53l106 -33q-20 -30 -49 -55.5t-63.5 -43.5t-72.5 -28t-77 -10zM327 436q-29 0 -54 -10.5t-44.5 -28.5t-34.5 -42t-24 -51q16 -1 31 -1h31q48 0 81.5 5t54 15t29.5 23.5t9 31.5 q0 29 -22 43.5t-57 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idblgrave",
    unicode: "\u0208",
    horizAdvX: 285,
    d: "M161 709h137l-151 -709h-137zM256 918h102l20 -119l-73 -18zM99 918h104l18 -119l-72 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idblgrave",
    unicode: "\u0209",
    horizAdvX: 253,
    d: "M204 730h102l20 -119l-73 -18zM47 730h104l18 -119l-72 -18zM107 524h134l-111 -524h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iinvertedbreve",
    unicode: "\u020A",
    horizAdvX: 285,
    d: "M161 709h137l-151 -709h-137zM118 782q6 29 20.5 53.5t35.5 42.5t46.5 28t52.5 10q49 0 76 -30t27 -74q0 -15 -3 -30h-71q1 8 1.5 15t0.5 13q0 46 -42 46q-58 0 -73 -74h-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iinvertedbreve",
    unicode: "\u020B",
    horizAdvX: 253,
    d: "M66 596q6 29 20.5 53.5t35.5 42.5t46.5 28t52.5 10q49 0 76 -30t27 -74q0 -15 -3 -30h-71q1 8 1.5 15t0.5 13q0 46 -42 46q-58 0 -73 -74h-71zM107 524h134l-111 -524h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odblgrave",
    unicode: "\u020C",
    horizAdvX: 729,
    d: "M502 918h102l20 -119l-73 -18zM345 918h104l18 -119l-72 -18zM299 -5q-63 0 -112 24.5t-82.5 65.5t-50.5 94t-17 111q0 81 34.5 157.5t92.5 136t133.5 95.5t157.5 36q63 0 111.5 -25t81 -66t49.5 -95t17 -111q0 -80 -34 -156.5t-91.5 -135.5t-132.5 -95t-157 -36z M326 117q55 0 100.5 27t78.5 69t51 93.5t18 101.5q0 37 -9 70.5t-27.5 58.5t-46.5 40t-65 15q-55 0 -101 -26.5t-79 -68.5t-51 -93.5t-18 -102.5q0 -37 9 -70t28 -58.5t46.5 -40.5t65.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odblgrave",
    unicode: "\u020D",
    horizAdvX: 586,
    d: "M368 730h102l20 -119l-73 -18zM211 730h104l18 -119l-72 -18zM227 -10q-53 0 -92.5 17.5t-66 47.5t-40 69.5t-13.5 83.5q0 62 24.5 120.5t68 104t103.5 73t131 27.5q52 0 91.5 -17.5t66.5 -47t40.5 -69.5t13.5 -85q0 -62 -24.5 -120t-68 -103.5t-103.5 -73t-131 -27.5z M251 104q31 0 60.5 15.5t52.5 41.5t37 61.5t14 75.5q0 54 -26 87.5t-71 33.5q-31 0 -60.5 -15.5t-52.5 -42t-37 -61.5t-14 -75q0 -54 26 -87.5t71 -33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oinvertedbreve",
    unicode: "\u020E",
    horizAdvX: 729,
    d: "M349 782q6 29 20.5 53.5t35.5 42.5t46.5 28t52.5 10q49 0 76 -30t27 -74q0 -15 -3 -30h-71q1 8 1.5 15t0.5 13q0 46 -42 46q-58 0 -73 -74h-71zM299 -5q-63 0 -112 24.5t-82.5 65.5t-50.5 94t-17 111q0 81 34.5 157.5t92.5 136t133.5 95.5t157.5 36q63 0 111.5 -25 t81 -66t49.5 -95t17 -111q0 -80 -34 -156.5t-91.5 -135.5t-132.5 -95t-157 -36zM326 117q55 0 100.5 27t78.5 69t51 93.5t18 101.5q0 37 -9 70.5t-27.5 58.5t-46.5 40t-65 15q-55 0 -101 -26.5t-79 -68.5t-51 -93.5t-18 -102.5q0 -37 9 -70t28 -58.5t46.5 -40.5t65.5 -15z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oinvertedbreve",
    unicode: "\u020F",
    horizAdvX: 586,
    d: "M235 596q6 29 20.5 53.5t35.5 42.5t46.5 28t52.5 10q49 0 76 -30t27 -74q0 -15 -3 -30h-71q1 8 1.5 15t0.5 13q0 46 -42 46q-58 0 -73 -74h-71zM227 -10q-53 0 -92.5 17.5t-66 47.5t-40 69.5t-13.5 83.5q0 62 24.5 120.5t68 104t103.5 73t131 27.5q52 0 91.5 -17.5 t66.5 -47t40.5 -69.5t13.5 -85q0 -62 -24.5 -120t-68 -103.5t-103.5 -73t-131 -27.5zM251 104q31 0 60.5 15.5t52.5 41.5t37 61.5t14 75.5q0 54 -26 87.5t-71 33.5q-31 0 -60.5 -15.5t-52.5 -42t-37 -61.5t-14 -75q0 -54 26 -87.5t71 -33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rdblgrave",
    unicode: "\u0210",
    horizAdvX: 642,
    d: "M419 918h102l20 -119l-73 -18zM262 918h104l18 -119l-72 -18zM10 0l151 710h300q40 0 72 -16.5t54 -44t33.5 -63t11.5 -72.5q0 -39 -13 -76.5t-35.5 -70.5t-53 -59t-66.5 -41l96 -267h-156l-84 238h-123l-50 -238h-137zM382 359q20 0 39.5 11.5t34.5 31t24.5 45t9.5 53.5 q0 38 -18.5 63.5t-45.5 25.5h-154l-49 -230h159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rdblgrave",
    unicode: "\u0211",
    horizAdvX: 378,
    d: "M268 730h102l20 -119l-73 -18zM111 730h104l18 -119l-72 -18zM107 524h123l-24 -112q38 54 85 85.5t94 31.5q10 0 15 -0.5t9 -1.5l-25 -119q-57 -1 -107.5 -23.5t-79.5 -67.5l-67 -317h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rinvertedbreve",
    unicode: "\u0212",
    horizAdvX: 642,
    d: "M288 782q6 29 20.5 53.5t35.5 42.5t46.5 28t52.5 10q49 0 76 -30t27 -74q0 -15 -3 -30h-71q1 8 1.5 15t0.5 13q0 46 -42 46q-58 0 -73 -74h-71zM10 0l151 710h300q40 0 72 -16.5t54 -44t33.5 -63t11.5 -72.5q0 -39 -13 -76.5t-35.5 -70.5t-53 -59t-66.5 -41l96 -267h-156 l-84 238h-123l-50 -238h-137zM382 359q20 0 39.5 11.5t34.5 31t24.5 45t9.5 53.5q0 38 -18.5 63.5t-45.5 25.5h-154l-49 -230h159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rinvertedbreve",
    unicode: "\u0213",
    horizAdvX: 378,
    d: "M137 596q6 29 20.5 53.5t35.5 42.5t46.5 28t52.5 10q49 0 76 -30t27 -74q0 -15 -3 -30h-71q1 8 1.5 15t0.5 13q0 46 -42 46q-58 0 -73 -74h-71zM107 524h123l-24 -112q38 54 85 85.5t94 31.5q10 0 15 -0.5t9 -1.5l-25 -119q-57 -1 -107.5 -23.5t-79.5 -67.5l-67 -317 h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udblgrave",
    unicode: "\u0214",
    horizAdvX: 719,
    d: "M473 918h102l20 -119l-73 -18zM316 918h104l18 -119l-72 -18zM295 -5q-64 0 -108.5 18.5t-72.5 51t-40.5 76t-12.5 94.5q0 55 13 113l77 362h137l-77 -362q-5 -23 -7.5 -45.5t-2.5 -43.5q0 -30 6 -56t20.5 -45t37 -30t55.5 -11q45 0 80 20t60.5 52t42.5 73.5t26 85.5 l77 362h137l-77 -362q-15 -73 -46 -137t-77 -112t-108 -76t-140 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udblgrave",
    unicode: "\u0215",
    horizAdvX: 595,
    d: "M356 730h102l20 -119l-73 -18zM199 730h104l18 -119l-72 -18zM145 -10q-123 0 -123 128q0 17 2.5 36.5t7.5 41.5l70 328h133l-63 -299q-3 -15 -5 -27t-2 -23q0 -71 60 -71q35 0 73.5 23.5t70.5 71.5l69 325h134l-79 -370q-1 -5 -1.5 -9.5t-0.5 -8.5q0 -21 24 -22 l-24 -114q-18 -3 -31.5 -5t-24.5 -2q-35 0 -54.5 14t-19.5 43q0 8 1 18t6 30q-45 -54 -102.5 -81t-120.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uinvertedbreve",
    unicode: "\u0216",
    horizAdvX: 719,
    d: "M337 782q6 29 20.5 53.5t35.5 42.5t46.5 28t52.5 10q49 0 76 -30t27 -74q0 -15 -3 -30h-71q1 8 1.5 15t0.5 13q0 46 -42 46q-58 0 -73 -74h-71zM295 -5q-64 0 -108.5 18.5t-72.5 51t-40.5 76t-12.5 94.5q0 55 13 113l77 362h137l-77 -362q-5 -23 -7.5 -45.5t-2.5 -43.5 q0 -30 6 -56t20.5 -45t37 -30t55.5 -11q45 0 80 20t60.5 52t42.5 73.5t26 85.5l77 362h137l-77 -362q-15 -73 -46 -137t-77 -112t-108 -76t-140 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uinvertedbreve",
    unicode: "\u0217",
    horizAdvX: 595,
    d: "M219 596q6 29 20.5 53.5t35.5 42.5t46.5 28t52.5 10q49 0 76 -30t27 -74q0 -15 -3 -30h-71q1 8 1.5 15t0.5 13q0 46 -42 46q-58 0 -73 -74h-71zM145 -10q-123 0 -123 128q0 17 2.5 36.5t7.5 41.5l70 328h133l-63 -299q-3 -15 -5 -27t-2 -23q0 -71 60 -71q35 0 73.5 23.5 t70.5 71.5l69 325h134l-79 -370q-1 -5 -1.5 -9.5t-0.5 -8.5q0 -21 24 -22l-24 -114q-18 -3 -31.5 -5t-24.5 -2q-35 0 -54.5 14t-19.5 43q0 8 1 18t6 30q-45 -54 -102.5 -81t-120.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0218",
    unicode: "\u0218",
    horizAdvX: 592,
    d: "M152 -213l43 72h-40l21 94h112l-19 -94l-56 -72h-61zM243 -8q-75 0 -144.5 24t-119.5 68l86 119q5 -9 23.5 -23.5t46 -29t63 -24.5t74.5 -10q60 0 89.5 23.5t29.5 62.5q0 19 -11.5 33t-31.5 25t-47.5 20.5t-60.5 19.5q-75 23 -114 57.5t-39 95.5q0 62 25 110.5t66.5 82.5 t96 51.5t113.5 17.5q71 0 126.5 -23.5t93.5 -55.5l-85 -112q-4 7 -19 19t-37.5 23.5t-50.5 19.5t-58 8q-60 0 -90 -26t-30 -69q0 -17 8.5 -29.5t25.5 -22t41 -17.5t56 -17q40 -11 72.5 -25t55.5 -33.5t35.5 -46.5t12.5 -64q0 -67 -26 -115t-68 -78.5t-96.5 -44.5t-111.5 -14 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0219",
    unicode: "\u0219",
    horizAdvX: 480,
    d: "M86 -213l43 72h-40l21 94h112l-19 -94l-56 -72h-61zM184 -10q-63 0 -119 21t-90 60l67 84q77 -69 159 -69q42 0 66 18t24 50q0 22 -21.5 34.5t-69.5 26.5q-40 12 -68.5 23.5t-47 25.5t-27 31.5t-8.5 40.5q0 44 19 80.5t51.5 62.5t75.5 40.5t91 14.5q56 0 101 -17t80 -55 l-71 -81q-32 30 -64.5 44t-66.5 14q-35 0 -60.5 -17t-25.5 -52q0 -21 19 -32t64 -24q84 -23 124 -51.5t40 -78.5q0 -43 -18 -78.5t-50 -61t-76.5 -40t-97.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021A",
    unicode: "\u021A",
    horizAdvX: 592,
    d: "M142 -213l43 72h-40l21 94h112l-19 -94l-56 -72h-61zM289 589h-213l25 121h563l-26 -121h-212l-125 -589h-138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021B",
    unicode: "\u021B",
    horizAdvX: 373,
    d: "M66 -213l43 72h-40l21 94h112l-19 -94l-56 -72h-61zM156 -9q-48 0 -78.5 21.5t-30.5 70.5q0 20 4 37l64 301h-65l22 103h64l36 170h134l-36 -170h105l-22 -103h-104l-55 -256q-1 -5 -1.5 -8.5t-0.5 -7.5q0 -19 10.5 -27t27.5 -8q20 0 39.5 6.5t33.5 12.5l4 -106 q-29 -14 -70 -25t-81 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessj",
    unicode: "\u0237",
    horizAdvX: 253,
    d: "M-88 -196q-36 0 -66.5 11.5t-51.5 35.5l76 91q8 -11 21.5 -16.5t28.5 -5.5q24 0 45 18.5t27 47.5l115 538h134l-112 -528q-9 -42 -30 -77.5t-50.5 -61t-64.5 -39.5t-72 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "schwa",
    unicode: "\u0259",
    horizAdvX: 578,
    d: "M219 -10q-53 0 -92.5 16t-66.5 43.5t-40.5 65.5t-13.5 82q0 26 5 54.5t15 52.5h380q1 6 1 12.5v12.5q0 50 -28.5 78t-70.5 28q-38 0 -74.5 -19.5t-55.5 -51.5l-107 32q20 30 48 55t61.5 43.5t72.5 28.5t81 10q52 0 91.5 -17t66.5 -47t40.5 -69.5t13.5 -84.5 q0 -63 -24 -121.5t-67.5 -103.5t-103.5 -72.5t-132 -27.5zM242 87q50 0 91 37t58 97h-247q-1 -7 -1 -12.5v-12.5q0 -50 27 -79.5t72 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "apostrophe",
    unicode: "\u02BC",
    horizAdvX: 522,
    d: "M247 611l47 73l3 46h150l-120 -145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 355,
    d: "M42 629l123 101h97l80 -101l-77 -32l-67 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    horizAdvX: 355,
    d: "M49 698l77 32l67 -63l94 63l63 -32l-124 -101h-97z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni02C9",
    unicode: "\u02C9",
    horizAdvX: 401,
    d: "M86 715h286l-18 -83h-286z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    horizAdvX: 316,
    d: "M161 656q21 0 41.5 21t30.5 53h72q-6 -29 -21 -53.5t-35.5 -42.5t-46 -28t-53.5 -10q-49 0 -76.5 28t-27.5 73q0 18 4 33h72q-3 -11 -3 -20q0 -23 12 -38.5t31 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    horizAdvX: 215,
    d: "M45 604l27 126h120l-26 -126h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 250,
    d: "M45 638q0 44 32 68t81 24q38 0 59 -16.5t21 -45.5q0 -43 -31.5 -67.5t-81.5 -24.5q-37 0 -58.5 16.5t-21.5 45.5zM149 689q-19 0 -32.5 -12t-13.5 -30q0 -13 8.5 -21.5t22.5 -8.5q17 0 32 12t15 30q0 14 -9 22t-23 8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    horizAdvX: 280,
    d: "M135 -196q-50 8 -73.5 28.5t-23.5 47.5q0 73 144 141l35 -21q-92 -53 -92 -91q0 -32 52 -35l-42 -70v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 419,
    d: "M269 602q-21 0 -36 7t-27.5 15.5t-24.5 15.5t-28 7t-26.5 -7t-16.5 -16t-8.5 -16.5t-2.5 -8.5h-74q2 9 12 30.5t28 43t43.5 38t57.5 16.5q22 0 36 -7.5t26 -16t24 -16t29 -7.5t28.5 7t18.5 16t10.5 17t3.5 10h73q-2 -7 -12 -28t-28.5 -43t-45 -39.5t-60.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    horizAdvX: 351,
    d: "M89 595l-67 16l70 119h103zM245 595l-66 16l69 119h103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030F",
    unicode: "\u030F",
    horizAdvX: 351,
    d: "M204 730h102l20 -119l-73 -18zM47 730h104l18 -119l-72 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0311",
    unicode: "\u0311",
    horizAdvX: 316,
    d: "M43 596q6 29 20.5 53.5t35.5 42.5t46.5 28t52.5 10q49 0 76 -30t27 -74q0 -15 -3 -30h-71q1 8 1.5 15t0.5 13q0 46 -42 46q-58 0 -73 -74h-71v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0394",
    unicode: "\u0394",
    horizAdvX: 637,
    d: "M-16 104l253 606h112l250 -606v-104h-615v104zM463 121l-170 436l-169 -436h339z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03A9",
    unicode: "\u03A9",
    horizAdvX: 816,
    d: "M44 102h166q-72 41 -114 110.5t-42 157.5q0 68 26 130.5t71.5 110t107.5 76t135 28.5t135 -28.5t107.5 -76t71 -110t25.5 -130.5q0 -88 -41.5 -157.5t-113.5 -110.5h165v-102h-307v102q37 13 67 41t51 64t32 78.5t11 84.5q0 41 -14 81t-40.5 71.5t-64 50.5t-84.5 19 t-85 -19t-64.5 -50.5t-40.5 -71.5t-14 -81q0 -42 11.5 -84.5t32.5 -78.5t50.5 -64t66.5 -41v-102h-307v102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03BC",
    unicode: "\u03BC",
    horizAdvX: 606,
    d: "M107 524h134l-64 -299q-3 -14 -5 -27t-2 -24q0 -70 63 -70q33 0 71.5 23.5t70.5 71.5l69 325h134l-79 -370q-1 -5 -1.5 -9t-0.5 -8q0 -22 29 -23l-24 -114q-20 -3 -35 -5t-26 -2q-74 0 -74 57q0 5 1 17t6 31q-12 -18 -31.5 -37t-43 -35t-49 -26t-49.5 -10 q-33 0 -50.5 16.5t-19.5 42.5l-47 -261h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "pi",
    unicode: "\u03C0",
    horizAdvX: 713,
    d: "M519 -8q-61 0 -95.5 33.5t-34.5 95.5v285h-130v-406h-132v406h-76v116h567v-116h-96v-238q0 -29 14 -45t40 -16q12 0 26.5 4t26.5 10l19 -102q-27 -13 -63 -20t-66 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ddotbelow",
    unicode: "\u1E0C",
    horizAdvX: 692,
    d: "M166 -196l27 126h120l-27 -126h-120zM161 710h247q69 0 119.5 -21.5t83.5 -58.5t49 -87t16 -108q0 -94 -31.5 -173.5t-88 -137.5t-133 -91t-166.5 -33h-247zM282 121q57 0 103.5 24t79.5 64.5t51 93.5t18 112q0 78 -38.5 126t-113.5 48h-110l-99 -468h109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ddotbelow",
    unicode: "\u1E0D",
    d: "M149 -196l27 126h120l-27 -126h-120zM201 -10q-44 0 -78.5 16.5t-58.5 45.5t-36.5 68.5t-12.5 84.5q0 65 23.5 124.5t63 104.5t91.5 72t109 27q54 0 92 -28t52 -73l64 298h134l-122 -576q-3 -11 -3 -18q0 -21 24 -22l-24 -114q-18 -3 -31.5 -5t-23.5 -2q-35 0 -55.5 14 t-20.5 43q0 8 1.5 17.5t4.5 23.5q-38 -50 -89.5 -75.5t-103.5 -25.5zM261 104q17 0 36.5 6.5t37.5 18.5t34 28t27 35l26 125q-6 44 -35 73t-67 29q-32 0 -62 -16.5t-52.5 -44t-36 -62t-13.5 -70.5q0 -52 28 -87t77 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hdotbelow",
    unicode: "\u1E24",
    horizAdvX: 718,
    d: "M161 710h137l-61 -287h296l61 287h137l-151 -710h-137l64 303h-296l-64 -303h-137zM192 -196l27 126h120l-27 -126h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hdotbelow",
    unicode: "\u1E25",
    horizAdvX: 582,
    d: "M151 730h134l-65 -303q39 51 91 78.5t109 27.5q35 0 58.5 -9.5t38 -26t20.5 -39t6 -48.5q0 -20 -2.5 -41t-7.5 -42l-69 -327h-134l62 294q6 28 6 49q0 72 -61 72q-16 0 -36 -8t-39.5 -22.5t-37 -34.5t-29.5 -44l-65 -306h-134zM126 -196l27 126h120l-27 -126h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ndotaccent",
    unicode: "\u1E44",
    horizAdvX: 733,
    d: "M404 790l27 126h120l-26 -126h-121zM161 710h107l242 -466l99 465h137l-151 -709h-111l-241 455l-96 -455h-137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ndotaccent",
    unicode: "\u1E45",
    horizAdvX: 582,
    d: "M285 604l27 126h120l-26 -126h-121zM107 524h121l-21 -97q38 50 96 78t123 28q34 0 56.5 -9.5t36 -25.5t19 -38.5t5.5 -47.5q0 -20 -2.5 -41.5t-7.5 -43.5l-69 -327h-134l62 294q3 15 5 28.5t2 24.5q0 35 -15.5 51.5t-41.5 16.5q-18 0 -39 -8t-41 -22.5t-37.5 -34.5 t-29.5 -44l-65 -306h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rdotbelow",
    unicode: "\u1E5A",
    horizAdvX: 642,
    d: "M10 0l151 710h300q40 0 72 -16.5t54 -44t33.5 -63t11.5 -72.5q0 -39 -13 -76.5t-35.5 -70.5t-53 -59t-66.5 -41l96 -267h-156l-84 238h-123l-50 -238h-137zM382 359q20 0 39.5 11.5t34.5 31t24.5 45t9.5 53.5q0 38 -18.5 63.5t-45.5 25.5h-154l-49 -230h159zM158 -196 l27 126h120l-27 -126h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rdotbelow",
    unicode: "\u1E5B",
    horizAdvX: 378,
    d: "M107 524h123l-24 -112q38 54 85 85.5t94 31.5q10 0 15 -0.5t9 -1.5l-25 -119q-57 -1 -107.5 -23.5t-79.5 -67.5l-67 -317h-134zM-37 -196l27 126h120l-27 -126h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sdotbelow",
    unicode: "\u1E62",
    horizAdvX: 592,
    d: "M243 -8q-75 0 -144.5 24t-119.5 68l86 119q5 -9 23.5 -23.5t46 -29t63 -24.5t74.5 -10q60 0 89.5 23.5t29.5 62.5q0 19 -11.5 33t-31.5 25t-47.5 20.5t-60.5 19.5q-75 23 -114 57.5t-39 95.5q0 62 25 110.5t66.5 82.5t96 51.5t113.5 17.5q71 0 126.5 -23.5t93.5 -55.5 l-85 -112q-4 7 -19 19t-37.5 23.5t-50.5 19.5t-58 8q-60 0 -90 -26t-30 -69q0 -17 8.5 -29.5t25.5 -22t41 -17.5t56 -17q40 -11 72.5 -25t55.5 -33.5t35.5 -46.5t12.5 -64q0 -67 -26 -115t-68 -78.5t-96.5 -44.5t-111.5 -14zM140 -196l27 126h120l-27 -126h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sdotbelow",
    unicode: "\u1E63",
    horizAdvX: 480,
    d: "M184 -10q-63 0 -119 21t-90 60l67 84q77 -69 159 -69q42 0 66 18t24 50q0 22 -21.5 34.5t-69.5 26.5q-40 12 -68.5 23.5t-47 25.5t-27 31.5t-8.5 40.5q0 44 19 80.5t51.5 62.5t75.5 40.5t91 14.5q56 0 101 -17t80 -55l-71 -81q-32 30 -64.5 44t-66.5 14q-35 0 -60.5 -17 t-25.5 -52q0 -21 19 -32t64 -24q84 -23 124 -51.5t40 -78.5q0 -43 -18 -78.5t-50 -61t-76.5 -40t-97.5 -14.5zM74 -196l27 126h120l-27 -126h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tdotbelow",
    unicode: "\u1E6C",
    horizAdvX: 592,
    d: "M130 -196l27 126h120l-27 -126h-120zM289 589h-213l25 121h563l-26 -121h-212l-125 -589h-138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tdotbelow",
    unicode: "\u1E6D",
    horizAdvX: 373,
    d: "M51 -196l27 126h120l-27 -126h-120zM156 -9q-48 0 -78.5 21.5t-30.5 70.5q0 20 4 37l64 301h-65l22 103h64l36 170h134l-36 -170h105l-22 -103h-104l-55 -256q-1 -5 -1.5 -8.5t-0.5 -7.5q0 -19 10.5 -27t27.5 -8q20 0 39.5 6.5t33.5 12.5l4 -106q-29 -14 -70 -25t-81 -11 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave",
    unicode: "\u1E80",
    horizAdvX: 1002,
    d: "M82 710h149l68 -552l128 227l-44 323h127l24 -235l123 235h128l-183 -323l33 -227l302 552h150l-424 -710h-115l-51 298l-178 -298h-115zM507 917h123l26 -119l-93 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wgrave",
    unicode: "\u1E81",
    horizAdvX: 790,
    d: "M42 524h131l63 -404q9 11 21 30.5t24 40.5t23.5 40.5t18.5 30.5l-56 262h117l26 -162q6 11 16.5 33.5t21.5 47t20 47t12 34.5h109q-24 -71 -54.5 -134t-72.5 -127l26 -120q40 54 71 100t55 90.5t43.5 90.5t38.5 100h123q-45 -131 -124.5 -262t-190.5 -262h-101l-29 171 q-7 -10 -22 -34.5t-31.5 -51.5t-32 -51t-23.5 -34h-122zM362 730h123l26 -119l-93 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute",
    unicode: "\u1E82",
    horizAdvX: 1002,
    d: "M615 780l-87 17l76 119h124zM82 710h149l68 -552l128 227l-44 323h127l24 -235l123 235h128l-183 -323l33 -227l302 552h150l-424 -710h-115l-51 298l-178 -298h-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wacute",
    unicode: "\u1E83",
    horizAdvX: 790,
    d: "M465 594l-87 17l76 119h124zM42 524h131l63 -404q9 11 21 30.5t24 40.5t23.5 40.5t18.5 30.5l-56 262h117l26 -162q6 11 16.5 33.5t21.5 47t20 47t12 34.5h109q-24 -71 -54.5 -134t-72.5 -127l26 -120q40 54 71 100t55 90.5t43.5 90.5t38.5 100h123q-45 -131 -124.5 -262 t-190.5 -262h-101l-29 171q-7 -10 -22 -34.5t-31.5 -51.5t-32 -51t-23.5 -34h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wdieresis",
    unicode: "\u1E84",
    horizAdvX: 1002,
    d: "M445 791l26 119h111l-26 -119h-111zM633 791l25 119h110l-24 -119h-111zM82 710h149l68 -552l128 227l-44 323h127l24 -235l123 235h128l-183 -323l33 -227l302 552h150l-424 -710h-115l-51 298l-178 -298h-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wdieresis",
    unicode: "\u1E85",
    horizAdvX: 790,
    d: "M295 604l26 119h111l-26 -119h-111zM483 604l25 119h110l-24 -119h-111zM42 524h131l63 -404q9 11 21 30.5t24 40.5t23.5 40.5t18.5 30.5l-56 262h117l26 -162q6 11 16.5 33.5t21.5 47t20 47t12 34.5h109q-24 -71 -54.5 -134t-72.5 -127l26 -120q40 54 71 100t55 90.5 t43.5 90.5t38.5 100h123q-45 -131 -124.5 -262t-190.5 -262h-101l-29 171q-7 -10 -22 -34.5t-31.5 -51.5t-32 -51t-23.5 -34h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotbelow",
    unicode: "\u1E92",
    horizAdvX: 597,
    d: "M-13 104l476 485h-361l25 121h521l-22 -104l-463 -485h362l-25 -121h-535zM135 -196l27 126h120l-27 -126h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotbelow",
    unicode: "\u1E93",
    horizAdvX: 471,
    d: "M-21 82l342 348h-256l20 94h400l-18 -82l-341 -348h272l-20 -94h-416zM69 -196l27 126h120l-27 -126h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotbelow",
    unicode: "\u1EB8",
    horizAdvX: 578,
    d: "M161 710h460l-25 -121h-324l-36 -171h279l-24 -112h-279l-39 -185h332l-26 -121h-469zM137 -196l27 126h120l-27 -126h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotbelow",
    unicode: "\u1EB9",
    horizAdvX: 551,
    d: "M230 -10q-50 0 -89.5 16.5t-67.5 46t-42.5 70t-14.5 88.5q0 65 25.5 123.5t70 102.5t105 70t130.5 26q85 0 135.5 -37.5t50.5 -108.5q0 -169 -302 -169h-37t-40 2v-13q0 -53 24 -86t76 -33q40 0 75.5 19t56.5 53l106 -33q-20 -30 -49 -55.5t-63.5 -43.5t-72.5 -28 t-77 -10zM327 436q-29 0 -54 -10.5t-44.5 -28.5t-34.5 -42t-24 -51q16 -1 31 -1h31q48 0 81.5 5t54 15t29.5 23.5t9 31.5q0 29 -22 43.5t-57 14.5zM134 -196l27 126h120l-27 -126h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Etilde",
    unicode: "\u1EBC",
    horizAdvX: 578,
    d: "M161 710h460l-25 -121h-324l-36 -171h279l-24 -112h-279l-39 -185h332l-26 -121h-469zM463 788q-21 0 -36 7t-27.5 15.5t-24.5 15.5t-28 7t-26.5 -7t-16.5 -16t-8.5 -16.5t-2.5 -8.5h-74q2 9 12 30.5t28 43t43.5 38t57.5 16.5q22 0 36 -7.5t26 -16t24 -16t29 -7.5t28.5 7 t18.5 16t10.5 17t3.5 10h73q-2 -7 -12 -28t-28.5 -43t-45 -39.5t-60.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "etilde",
    unicode: "\u1EBD",
    horizAdvX: 551,
    d: "M230 -10q-50 0 -89.5 16.5t-67.5 46t-42.5 70t-14.5 88.5q0 65 25.5 123.5t70 102.5t105 70t130.5 26q85 0 135.5 -37.5t50.5 -108.5q0 -169 -302 -169h-37t-40 2v-13q0 -53 24 -86t76 -33q40 0 75.5 19t56.5 53l106 -33q-20 -30 -49 -55.5t-63.5 -43.5t-72.5 -28 t-77 -10zM327 436q-29 0 -54 -10.5t-44.5 -28.5t-34.5 -42t-24 -51q16 -1 31 -1h31q48 0 81.5 5t54 15t29.5 23.5t9 31.5q0 29 -22 43.5t-57 14.5zM416 602q-21 0 -36 7t-27.5 15.5t-24.5 15.5t-28 7t-26.5 -7t-16.5 -16t-8.5 -16.5t-2.5 -8.5h-74q2 9 12 30.5t28 43 t43.5 38t57.5 16.5q22 0 36 -7.5t26 -16t24 -16t29 -7.5t28.5 7t18.5 16t10.5 17t3.5 10h73q-2 -7 -12 -28t-28.5 -43t-45 -39.5t-60.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotbelow",
    unicode: "\u1ECA",
    horizAdvX: 285,
    d: "M161 709h137l-151 -709h-137zM-23 -196l27 126h120l-27 -126h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idotbelow",
    unicode: "\u1ECB",
    horizAdvX: 253,
    d: "M107 524h134l-111 -524h-134zM151 730h134l-28 -133h-134zM-38 -196l27 126h120l-27 -126h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odotbelow",
    unicode: "\u1ECC",
    horizAdvX: 729,
    d: "M203 -196l27 126h120l-27 -126h-120zM299 -5q-63 0 -112 24.5t-82.5 65.5t-50.5 94t-17 111q0 81 34.5 157.5t92.5 136t133.5 95.5t157.5 36q63 0 111.5 -25t81 -66t49.5 -95t17 -111q0 -80 -34 -156.5t-91.5 -135.5t-132.5 -95t-157 -36zM326 117q55 0 100.5 27t78.5 69 t51 93.5t18 101.5q0 37 -9 70.5t-27.5 58.5t-46.5 40t-65 15q-55 0 -101 -26.5t-79 -68.5t-51 -93.5t-18 -102.5q0 -37 9 -70t28 -58.5t46.5 -40.5t65.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odotbelow",
    unicode: "\u1ECD",
    horizAdvX: 586,
    d: "M132 -196l27 126h120l-27 -126h-120zM227 -10q-53 0 -92.5 17.5t-66 47.5t-40 69.5t-13.5 83.5q0 62 24.5 120.5t68 104t103.5 73t131 27.5q52 0 91.5 -17.5t66.5 -47t40.5 -69.5t13.5 -85q0 -62 -24.5 -120t-68 -103.5t-103.5 -73t-131 -27.5zM251 104q31 0 60.5 15.5 t52.5 41.5t37 61.5t14 75.5q0 54 -26 87.5t-71 33.5q-31 0 -60.5 -15.5t-52.5 -42t-37 -61.5t-14 -75q0 -54 26 -87.5t71 -33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udotbelow",
    unicode: "\u1EE4",
    horizAdvX: 719,
    d: "M295 -5q-64 0 -108.5 18.5t-72.5 51t-40.5 76t-12.5 94.5q0 55 13 113l77 362h137l-77 -362q-5 -23 -7.5 -45.5t-2.5 -43.5q0 -30 6 -56t20.5 -45t37 -30t55.5 -11q45 0 80 20t60.5 52t42.5 73.5t26 85.5l77 362h137l-77 -362q-15 -73 -46 -137t-77 -112t-108 -76 t-140 -28zM190 -196l27 126h120l-27 -126h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udotbelow",
    unicode: "\u1EE5",
    horizAdvX: 595,
    d: "M145 -10q-123 0 -123 128q0 17 2.5 36.5t7.5 41.5l70 328h133l-63 -299q-3 -15 -5 -27t-2 -23q0 -71 60 -71q35 0 73.5 23.5t70.5 71.5l69 325h134l-79 -370q-1 -5 -1.5 -9.5t-0.5 -8.5q0 -21 24 -22l-24 -114q-18 -3 -31.5 -5t-24.5 -2q-35 0 -54.5 14t-19.5 43 q0 8 1 18t6 30q-45 -54 -102.5 -81t-120.5 -27zM123 -196l27 126h120l-27 -126h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ygrave",
    unicode: "\u1EF2",
    horizAdvX: 619,
    d: "M225 250l-144 460h150l88 -342l236 342h149l-343 -462l-52 -248h-137zM321 917h123l26 -119l-93 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave",
    unicode: "\u1EF3",
    horizAdvX: 520,
    d: "M-44 -126q30 3 51.5 7t38 12.5t30.5 22t29 34.5l29 39l-87 535h137l45 -408l34 56q31 51 54 95.5t41 86.5t31 83.5t24 86.5h130q-14 -48 -29 -90t-38 -89t-56.5 -104.5t-82.5 -137.5l-80 -129q-35 -56 -67.5 -94.5t-66 -62.5t-70.5 -34.5t-81 -11.5zM224 730h123l26 -119 l-93 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ytilde",
    unicode: "\u1EF8",
    horizAdvX: 619,
    d: "M225 250l-144 460h150l88 -342l236 342h149l-343 -462l-52 -248h-137zM464 788q-21 0 -36 7t-27.5 15.5t-24.5 15.5t-28 7t-26.5 -7t-16.5 -16t-8.5 -16.5t-2.5 -8.5h-74q2 9 12 30.5t28 43t43.5 38t57.5 16.5q22 0 36 -7.5t26 -16t24 -16t29 -7.5t28.5 7t18.5 16 t10.5 17t3.5 10h73q-2 -7 -12 -28t-28.5 -43t-45 -39.5t-60.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ytilde",
    unicode: "\u1EF9",
    horizAdvX: 520,
    d: "M-44 -126q30 3 51.5 7t38 12.5t30.5 22t29 34.5l29 39l-87 535h137l45 -408l34 56q31 51 54 95.5t41 86.5t31 83.5t24 86.5h130q-14 -48 -29 -90t-38 -89t-56.5 -104.5t-82.5 -137.5l-80 -129q-35 -56 -67.5 -94.5t-66 -62.5t-70.5 -34.5t-81 -11.5zM371 602q-21 0 -36 7 t-27.5 15.5t-24.5 15.5t-28 7t-26.5 -7t-16.5 -16t-8.5 -16.5t-2.5 -8.5h-74q2 9 12 30.5t28 43t43.5 38t57.5 16.5q22 0 36 -7.5t26 -16t24 -16t29 -7.5t28.5 7t18.5 16t10.5 17t3.5 10h73q-2 -7 -12 -28t-28.5 -43t-45 -39.5t-60.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "enspace",
    unicode: "\u2002",
    horizAdvX: 574
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emspace",
    unicode: "\u2003",
    horizAdvX: 884
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 582,
    d: "M38 214l26 121h468l-25 -121h-469z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 890,
    d: "M38 214l26 121h776l-26 -121h-776z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 245,
    d: "M263 730l-47 -122h39l-28 -135h-136l29 137l61 120h82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 236,
    d: "M110 501l47 122h-39l28 135h136l-29 -137l-61 -120h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 251,
    d: "M-16 -131l50 131h-39l30 146h136l-31 -148l-62 -129h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 420,
    d: "M263 730l-47 -122h39l-28 -135h-136l29 137l61 120h82zM439 730l-48 -122h40l-29 -135h-135l29 137l60 120h83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 412,
    d: "M286 501l47 122h-39l28 135h136l-29 -137l-61 -120h-82zM110 501l48 122h-40l29 135h135l-29 -137l-60 -120h-83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 431,
    d: "M-16 -131l50 131h-39l30 146h136l-31 -148l-62 -129h-84zM164 -131l50 131h-39l31 146h135l-32 -148l-61 -129h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 449,
    d: "M70 -130l72 341h-125l25 120h126l94 444h127l-94 -444h125l-26 -120h-125l-72 -341h-127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 460,
    d: "M77 -130l48 232h-125l26 120h125l24 112h-125l25 121h126l68 320h127l-68 -320h124l-26 -121h-124l-24 -112h125l-26 -120h-125l-49 -232h-126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 354,
    d: "M289 368q0 -25 -10.5 -47t-28.5 -39t-40.5 -27t-46.5 -10q-35 0 -57.5 25t-22.5 61q0 25 11 47t28.5 39t40 27t45.5 10q37 0 59 -25.5t22 -60.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 593,
    d: "M-6 0l31 144h110l-31 -144h-110zM179 0l30 144h110l-31 -144h-109zM362 0l31 144h110l-30 -144h-111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 1127,
    d: "M225 417q-30 0 -54 9.5t-41.5 26.5t-26.5 40t-9 50q0 36 16.5 68t43.5 56.5t61.5 38.5t70.5 14q30 0 54 -9.5t41.5 -26.5t26.5 -40t9 -50q0 -36 -16.5 -68t-43.5 -56.5t-61.5 -38.5t-70.5 -14zM239 484q15 0 30 8.5t27 23t19.5 33.5t7.5 39q0 27 -14 46t-37 19 q-15 0 -30 -8.5t-27 -23t-19.5 -33.5t-7.5 -39q0 -27 14 -46t37 -19zM507 -10q-30 0 -54.5 9.5t-41.5 26.5t-26.5 40t-9.5 50q0 36 16.5 68t43.5 56.5t61.5 38.5t70.5 14q30 0 54 -9.5t41.5 -26.5t26.5 -40t9 -50q0 -36 -16 -68t-43 -56.5t-61.5 -38.5t-70.5 -14zM520 57 q15 0 30 8.5t27 23t19.5 33.5t7.5 39q0 27 -14 46t-37 19q-15 0 -30 -8.5t-27 -23t-19.5 -33.5t-7.5 -39q0 -27 14 -46t37 -19zM872 -10q-30 0 -54.5 9.5t-41.5 26.5t-26.5 40t-9.5 49q0 36 16.5 68.5t43.5 57t61.5 38.5t70.5 14q30 0 54 -9.5t41.5 -26.5t26.5 -40t9 -50 q0 -36 -16 -68t-43 -56.5t-61.5 -38.5t-70.5 -14zM885 57q15 0 30 8.5t27 23t19.5 33.5t7.5 39q0 27 -13.5 46t-36.5 19q-15 0 -30 -8.5t-27.5 -23t-20 -33.5t-7.5 -39q0 -27 14 -46t37 -19zM44 47l337 329l319 342l49 -54l-329 -324l-328 -347z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 345,
    d: "M33 288l292 189l-23 -109l-169 -109l124 -103l-23 -110l-215 177z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 345,
    d: "M292 223l-289 -177l23 110l168 103l-123 109l23 109l212 -189z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 200,
    d: "M-240 47l337 329l319 342l49 -54l-329 -324l-328 -347z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zerosuperior",
    unicode: "\u2070",
    horizAdvX: 471,
    d: "M254 388q-43 0 -73.5 16t-50.5 41t-29.5 56.5t-9.5 62.5q0 43 19.5 87.5t54 81t81 59.5t99.5 23q43 0 73.5 -16.5t50 -42t29 -57.5t9.5 -63q0 -43 -19.5 -87t-53.5 -80t-80 -58.5t-100 -22.5zM174 575q0 -20 5.5 -39.5t17.5 -34.5t30 -24.5t44 -9.5q36 0 65 16t48.5 39.5 t30 51.5t10.5 52q0 20 -6 39.5t-18 35t-30 25t-43 9.5q-36 0 -65 -16t-48.5 -40t-30 -52t-10.5 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "foursuperior",
    unicode: "\u2074",
    horizAdvX: 396,
    d: "M252 394l19 92h-209l16 77l287 252h55l-54 -251h59l-17 -78h-58l-20 -92h-78zM154 564h137l32 153z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fivesuperior",
    unicode: "\u2075",
    horizAdvX: 381,
    d: "M273 666q60 0 95.5 -31t35.5 -81q0 -36 -16.5 -66.5t-45 -52.5t-66.5 -34.5t-80 -12.5q-50 0 -87 19t-51 52l58 53q14 -23 40 -35.5t62 -12.5q42 0 73.5 21t31.5 62q0 31 -21.5 45.5t-46.5 14.5t-52 -13t-42 -33h-70q11 27 26 61t30 69t29.5 67.5t23.5 56.5h232l-17 -79 h-175l-41 -88q13 8 31.5 13t42.5 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixsuperior",
    unicode: "\u2076",
    horizAdvX: 413,
    d: "M436 552q0 -34 -17 -64.5t-45.5 -53.5t-66.5 -36.5t-79 -13.5q-66 0 -102 39t-36 108q0 61 17.5 113t49 90t76 59.5t97.5 21.5q44 0 78.5 -16.5t51.5 -48.5l-58 -55q-11 20 -35 32t-56 12q-48 0 -83 -28.5t-47 -80.5q19 20 51 30.5t61 10.5q66 0 104.5 -34t38.5 -85z M245 457q21 0 41.5 7t36.5 18t26 26t10 31q0 27 -23.5 45t-59.5 18q-22 0 -42.5 -6.5t-36.5 -17.5t-25.5 -26t-9.5 -31q0 -26 24 -45t59 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sevensuperior",
    unicode: "\u2077",
    horizAdvX: 377,
    d: "M342 736h-226l16 79h350l-326 -421h-89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightsuperior",
    unicode: "\u2078",
    horizAdvX: 405,
    d: "M421 533q0 -31 -17 -57.5t-45 -46t-64 -30.5t-74 -11q-32 0 -59 8.5t-46.5 23.5t-30 35.5t-10.5 44.5t9 42.5t23.5 32.5t33.5 25t39 19q-21 9 -35.5 25.5t-14.5 42.5q0 28 17 51.5t43.5 40.5t58.5 26.5t62 9.5q25 0 49.5 -7t43 -20.5t30 -32t11.5 -40.5q0 -35 -25 -59 t-60 -37q27 -14 44 -35t17 -51zM341 532q0 24 -24 37.5t-55 13.5q-20 0 -38.5 -5t-33 -13.5t-23.5 -20.5t-9 -26q0 -24 25 -37.5t56 -13.5q18 0 36.5 5t33 13.5t23.5 20.5t9 26zM209 688q0 -19 21 -29.5t46 -10.5q14 0 29.5 3.5t28 10t21 15.5t8.5 21q0 19 -20 29.5 t-48 10.5q-33 0 -59.5 -13.5t-26.5 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ninesuperior",
    unicode: "\u2079",
    horizAdvX: 413,
    d: "M104 645q0 34 17 65t45.5 54.5t66 37t78.5 13.5q66 0 102.5 -39.5t36.5 -108.5q0 -60 -17.5 -112t-49 -90t-76 -59.5t-97.5 -21.5q-45 0 -79 16.5t-51 48.5l57 54q11 -20 35.5 -32t56.5 -12q48 0 83 28.5t47 80.5q-19 -20 -51 -30.5t-63 -10.5q-32 0 -58 9t-44.5 25 t-28.5 37.5t-10 46.5zM295 741q-22 0 -42.5 -7t-36.5 -18t-25.5 -26t-9.5 -31q0 -26 24 -44t59 -18q22 0 42 6.5t36 17t25.5 25t9.5 30.5q0 27 -23.5 46t-58.5 19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zeroinferior",
    unicode: "\u2080",
    horizAdvX: 471,
    d: "M153 -90q-43 0 -74 16t-51 41t-29.5 56.5t-9.5 63.5q0 43 20 87.5t54.5 80.5t81 59t99.5 23q42 0 72.5 -16.5t50 -42t29 -57t9.5 -62.5q0 -43 -19.5 -87t-53.5 -80t-80 -59t-99 -23zM72 97q0 -20 5.5 -39t17.5 -34.5t30 -25t44 -9.5q36 0 65 16t49 40t30.5 52t10.5 52 q0 20 -6 39.5t-18 34.5t-30.5 24.5t-43.5 9.5q-36 0 -65 -16t-48.5 -40t-30 -52t-10.5 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneinferior",
    unicode: "\u2081",
    horizAdvX: 322,
    d: "M239 -7l-16 -78h-258l16 78h93l55 262q-7 -7 -21.5 -15.5t-31.5 -16.5t-34.5 -13.5t-30.5 -5.5l17 80q18 0 38.5 8.5t38.5 19t30 19.5t12 10h81l-75 -348h86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twoinferior",
    unicode: "\u2082",
    horizAdvX: 408,
    d: "M-51 -85q9 41 21.5 71.5t32 53.5t47.5 40.5t66 32.5q26 10 52 19.5t47 21.5t34 27t13 38q0 22 -18 33.5t-51 11.5q-42 0 -74.5 -16t-52.5 -33l-38 58q10 10 28 22t42.5 22.5t55.5 17.5t67 7q66 0 99.5 -28t33.5 -78q0 -35 -12 -60.5t-33 -44.5t-49.5 -32.5t-61.5 -23.5 q-50 -16 -74 -37.5t-29 -44.5h211l-17 -78h-340z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeinferior",
    unicode: "\u2083",
    horizAdvX: 392,
    d: "M100 -90q-59 0 -96.5 20.5t-42.5 58.5l55 58q0 -6 6 -16t18.5 -19t31 -15.5t44.5 -6.5q21 0 40.5 3.5t34.5 11t23.5 18.5t8.5 25q0 26 -34.5 38t-94.5 12h-23l15 72h22q62 0 101 13.5t39 44.5q0 20 -22.5 30.5t-46.5 10.5q-38 0 -66.5 -13.5t-51.5 -36.5l-37 64 q28 29 74.5 44t94.5 15q64 0 103 -28.5t39 -71.5q0 -41 -30.5 -68t-81.5 -36q38 -6 59 -31t21 -59q0 -35 -18 -61t-47 -43t-65 -25.5t-73 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fourinferior",
    unicode: "\u2084",
    horizAdvX: 395,
    d: "M149 -84l20 92h-210l17 78l287 251h54l-53 -251h59l-17 -78h-59l-19 -92h-79zM52 86h136l33 154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveinferior",
    unicode: "\u2085",
    horizAdvX: 382,
    d: "M173 189q59 0 95 -31.5t36 -81.5q0 -36 -16.5 -66t-45 -52.5t-66.5 -35t-80 -12.5q-50 0 -87 19.5t-52 51.5l58 53q14 -22 40.5 -35t61.5 -13q42 0 73.5 21t31.5 62q0 31 -21.5 45.5t-46.5 14.5q-24 0 -51 -12.5t-43 -32.5h-70q11 27 26 61t30 68.5t29.5 67t23.5 56.5 h232l-17 -79h-174l-41 -87q12 7 30.5 12.5t43.5 5.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixinferior",
    unicode: "\u2086",
    horizAdvX: 412,
    d: "M335 78q0 -34 -17 -64.5t-45.5 -53.5t-66.5 -36.5t-79 -13.5q-66 0 -102 39t-36 108q0 61 17.5 112.5t49.5 89.5t76 59.5t98 21.5q44 0 78 -16t51 -48l-57 -55q-11 20 -35.5 32t-56.5 12q-48 0 -83 -28.5t-47 -80.5q19 20 51.5 30t61.5 10q66 0 104 -33.5t38 -84.5z M144 -17q22 0 42.5 7t36.5 18t25.5 26t9.5 31q0 26 -23.5 44.5t-59.5 18.5q-22 0 -42.5 -6.5t-36.5 -17.5t-25.5 -26t-9.5 -31q0 -26 24 -45t59 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveninferior",
    unicode: "\u2087",
    horizAdvX: 376,
    d: "M240 258h-226l17 79h350l-327 -421h-89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightinferior",
    unicode: "\u2088",
    horizAdvX: 407,
    d: "M321 56q0 -32 -17 -58.5t-45 -46t-64.5 -30.5t-74.5 -11q-32 0 -58.5 8.5t-46 24t-30 36t-10.5 44.5t8.5 42t23 32.5t33.5 25t39 18.5q-20 9 -34.5 26t-14.5 42q0 28 17 51.5t43 40.5t58 26.5t62 9.5q25 0 49.5 -7t43.5 -20t30.5 -31.5t11.5 -40.5q0 -35 -25 -59t-60 -38 q26 -13 43.5 -34.5t17.5 -50.5zM241 54q0 24 -24 37.5t-56 13.5q-19 0 -37.5 -4.5t-33 -13t-23.5 -20.5t-9 -27q0 -23 24.5 -37t55.5 -14q18 0 36.5 5t33.5 13.5t24 20.5t9 26zM108 210q0 -19 21 -29.5t46 -10.5q15 0 30 3.5t28 10t21 16t8 21.5q0 18 -20 28.5t-48 10.5 q-16 0 -31.5 -3.5t-27.5 -10t-19.5 -15.5t-7.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nineinferior",
    unicode: "\u2089",
    horizAdvX: 414,
    d: "M3 171q0 34 17 65t45.5 54t66.5 36.5t79 13.5q66 0 102 -39t36 -109q0 -60 -17.5 -112t-49 -89.5t-75.5 -59t-98 -21.5q-44 0 -78.5 16.5t-51.5 48.5l58 55q11 -21 35 -33t56 -12q48 0 83 28.5t47 80.5q-19 -20 -51 -30.5t-62 -10.5q-66 0 -104 33.5t-38 84.5zM194 267 q-22 0 -42.5 -7t-36 -18t-25 -26t-9.5 -31q0 -26 23.5 -44t59.5 -18q21 0 41.5 6.5t36 17.5t25 25.5t9.5 30.5q0 26 -23 45t-59 19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colonmonetary",
    unicode: "\u20A1",
    horizAdvX: 548,
    d: "M138 8q-60 26 -90 80t-30 122q0 51 16.5 99t46.5 89.5t72 72.5t93 47l27 127h62l-25 -114q9 1 18 1.5t18 0.5q5 0 10.5 -0.5t10.5 -0.5l25 113h62l-27 -124q47 -15 76 -46.5t41 -75.5l-139 -40q-9 29 -31 44.5t-54 15.5q-31 0 -60.5 -14.5t-52 -40.5t-36.5 -61.5 t-14 -76.5q0 -54 26.5 -88t70.5 -34q32 0 63.5 18t48.5 44l122 -40q-29 -44 -73 -76.5t-99 -48.5l-25 -121h-62l24 111q-5 0 -11 -0.5t-11 -0.5q-19 0 -35 3l-24 -113h-61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "franc",
    unicode: "\u20A3",
    horizAdvX: 585,
    d: "M43 0l22 104h-74l19 91h74l110 515h455l-26 -121h-317l-39 -183h264l-25 -112h-263l-21 -99h105l-18 -91h-107l-22 -104h-137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lira",
    unicode: "\u20A4",
    horizAdvX: 514,
    d: "M72 430h63q-4 19 -6.5 37t-2.5 37q0 44 20 82.5t53.5 67t77 45t89.5 16.5q59 0 105.5 -28t72.5 -77l-87 -82q-17 35 -49 56.5t-66 21.5q-20 0 -37.5 -8t-31 -21.5t-21.5 -32.5t-8 -41q0 -17 3.5 -35t8.5 -38h164l-17 -83h-131q0 -6 0.5 -12.5t0.5 -12.5v-10t-1 -10h121 l-17 -83h-127q-14 -26 -37.5 -54t-60.5 -61q22 7 40 9.5t35 2.5q34 0 63 -8.5t61 -8.5q17 0 34 4t40 12l11 -100q-26 -14 -57 -22t-59 -8q-22 0 -43 4.5t-42 10t-42.5 10t-44.5 4.5q-25 0 -60 -6t-67 -16l-9 95q87 66 121 132h-105l17 83h111v7q0 18 -3 38h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A6",
    unicode: "\u20A6",
    horizAdvX: 823,
    d: "M806 402h-80l-23 -109h80l-17 -83h-81l-44 -210h-112l-111 210h-181l-44 -210h-138l44 210h-80l17 83h81l23 109h-80l17 82h81l48 226h107l117 -226h176l49 225h137l-48 -225h79zM255 293h119l-57 109h-39zM529 293h36l24 109h-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A9",
    unicode: "\u20A9",
    horizAdvX: 1095,
    d: "M38 296h164l-15 88h-130l17 82h99l-41 244h148l30 -244h154l-33 242h128l24 -235l124 235h127l-137 -242h155l134 244h150l-146 -244h101l-17 -82h-133l-52 -88h167l-18 -83h-199l-127 -213h-116l-50 298l-178 -298h-116l-36 213h-196zM331 296h95l49 88h-155zM664 296 h95l48 88h-155zM348 158l31 55h-38zM684 158l30 55h-38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    horizAdvX: 762,
    d: "M147 441q23 55 61 104.5t87.5 87t110 59.5t128.5 22q94 0 153 -43t78 -112l-122 -73q-6 30 -20 50.5t-33 32.5t-41.5 17.5t-44.5 5.5q-37 0 -69.5 -12t-59.5 -32.5t-48.5 -48t-36.5 -58.5h240l-45 -74h-221q-3 -13 -4.5 -26t-2.5 -25h216l-45 -74h-164q14 -54 49 -90 t92 -36q22 0 47.5 6t50 19t47 33.5t40.5 49.5l99 -65q-24 -40 -60.5 -70.5t-79 -51.5t-88 -32t-86.5 -11q-55 0 -98.5 20t-76 54t-52.5 79t-27 95h-99l45 74h51q1 25 6 51h-65l46 74h42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B9",
    unicode: "\u20B9",
    horizAdvX: 517,
    d: "M516 477h-93q-6 -35 -21 -67t-38 -59.5t-52.5 -49t-63.5 -34.5l111 -267h-156l-140 350h111q18 0 35.5 10t32.5 27.5t26 40.5t15 49h-206l17 82h180q-8 18 -21.5 28.5t-29.5 10.5h-121l24 112h439l-17 -83h-152q19 -33 26 -68h111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2113",
    unicode: "\u2113",
    horizAdvX: 344,
    d: "M182 -7q-56 0 -87.5 29t-31.5 81v507q0 28 11 51.5t30.5 41t46 27.5t56.5 10q61 0 98 -36t37 -94q0 -41 -15.5 -93.5t-41 -106.5t-58.5 -103.5t-68 -83.5v-70q0 -29 16 -45.5t42 -16.5q11 0 25.5 3.5t27.5 8.5l17 -89q-22 -9 -52 -15t-53 -6zM253 586q0 67 -45 67 q-21 0 -35 -17t-14 -44v-247q19 26 36 58t30 64.5t20.5 63.5t7.5 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii61352",
    unicode: "\u2116",
    horizAdvX: 1097,
    d: "M244 455l-96 -455h-138l151 710h107l243 -466l99 465h137l-151 -709h-111zM913 339q-36 0 -62.5 12t-44.5 32t-27 47.5t-9 57.5q0 43 16.5 83.5t46 72t70.5 50.5t90 19q35 0 61.5 -12t44.5 -32t27 -47t9 -58q0 -43 -16.5 -83.5t-45.5 -72t-70 -50.5t-90 -19zM870 501 q0 -35 16.5 -56.5t44.5 -21.5q20 0 38.5 10t33 27.5t23.5 41t9 49.5q0 34 -16.5 55.5t-43.5 21.5q-20 0 -39 -10t-33.5 -27.5t-23.5 -40.5t-9 -49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "servicemark",
    unicode: "\u2120",
    horizAdvX: 763,
    d: "M658 710h129l-63 -299h-86l39 187l-90 -145h-70l-29 145l-40 -187h-86l63 299h129l19 -157zM326 618q-19 13 -38 21.5t-42 8.5q-44 0 -44 -25q0 -8 10.5 -14.5t39.5 -14.5q48 -11 71 -28.5t23 -49.5q0 -27 -11 -47t-30 -34t-45 -21t-57 -7q-37 0 -72 10.5t-58 28.5l47 64 q19 -14 44 -24.5t53 -10.5q44 0 44 22q0 10 -12 16.5t-43 14.5q-45 12 -66 28.5t-21 45.5q0 25 11 46t30.5 36t45 23t54.5 8q31 0 58.5 -8.5t52.5 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 801,
    d: "M394 625h-90l-45 -214h-87l45 214h-90l19 87h267zM456 710h129l18 -157l86 157h129l-63 -299h-87l40 187l-91 -145h-69l-29 145l-40 -187h-87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omega",
    unicode: "\u2126",
    horizAdvX: 816,
    d: "M44 102h166q-72 41 -114 110.5t-42 157.5q0 68 26 130.5t71.5 110t107.5 76t135 28.5t135 -28.5t107.5 -76t71 -110t25.5 -130.5q0 -88 -41.5 -157.5t-113.5 -110.5h165v-102h-307v102q37 13 67 41t51 64t32 78.5t11 84.5q0 41 -14 81t-40.5 71.5t-64 50.5t-84.5 19 t-85 -19t-64.5 -50.5t-40.5 -71.5t-14 -81q0 -42 11.5 -84.5t32.5 -78.5t50.5 -64t66.5 -41v-102h-307v102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "estimated",
    unicode: "\u212E",
    horizAdvX: 616,
    d: "M305 36q72 0 119.5 21.5t76.5 50.5l31 -35q-37 -35 -92.5 -59t-134.5 -24q-62 0 -112.5 22t-86.5 59t-55.5 86t-19.5 103q0 55 20 105t56 87t86.5 59t111.5 22t112 -22.5t87.5 -61t56.5 -91t20 -112.5h-425v-141q27 -32 66 -50.5t83 -18.5zM305 487q-44 0 -83 -19.5 t-66 -55.5v-117h301v116q-29 37 -68 56.5t-84 19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onethird",
    unicode: "\u2153",
    horizAdvX: 863,
    d: "M64 47l337 329l319 342l49 -54l-329 -324l-328 -347zM296 384l-17 -78h-221l17 78h75l55 261q-7 -7 -19.5 -15.5t-26.5 -16.5t-29 -13.5t-26 -5.5l17 80q15 0 32.5 8.5t33 19t26 19.5t10.5 10h80l-74 -347h67zM587 -5q-60 0 -97.5 20t-42.5 59l55 58q1 -6 7 -16t18 -19.5 t30.5 -16t44.5 -6.5q43 0 75 15t32 43q0 26 -34 38t-95 12h-23l15 72h22q62 0 101 14t39 45q0 20 -22.5 30t-46.5 10q-38 0 -66.5 -13.5t-51.5 -35.5l-37 63q28 29 75 44.5t95 15.5q63 0 102 -28.5t39 -71.5q0 -42 -30 -69t-82 -36q39 -6 59.5 -31t20.5 -58q0 -36 -18 -62 t-46.5 -43t-64.5 -25t-73 -8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twothirds",
    unicode: "\u2154",
    horizAdvX: 881,
    d: "M40 305q8 41 20.5 71.5t31.5 53.5t45.5 40.5t62.5 32.5q26 10 51.5 19.5t45.5 21t32.5 27t12.5 38.5q0 21 -17.5 33t-49.5 12q-40 0 -71.5 -16t-51.5 -33l-36 57q9 10 26.5 22t41.5 22.5t53.5 17.5t63.5 7q64 0 97 -28t33 -78q0 -35 -12 -60.5t-32.5 -44.5t-48.5 -32.5 t-59 -23.5q-48 -15 -71 -36.5t-28 -44.5h191l-17 -78h-314zM118 47l337 329l319 342l49 -54l-329 -324l-328 -347zM603 -5q-60 0 -97.5 20t-42.5 59l55 58q1 -6 7 -16t18 -19.5t30.5 -16t44.5 -6.5q43 0 75 15t32 43q0 26 -34 38t-95 12h-23l15 72h22q62 0 101 14t39 45 q0 20 -22.5 30t-46.5 10q-38 0 -66.5 -13.5t-51.5 -35.5l-37 63q28 29 75 44.5t95 15.5q63 0 102 -28.5t39 -71.5q0 -42 -30 -69t-82 -36q39 -6 59.5 -31t20.5 -58q0 -36 -18 -62t-46.5 -43t-64.5 -25t-73 -8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneeighth",
    unicode: "\u215B",
    horizAdvX: 866,
    d: "M75 47l337 329l319 342l49 -54l-329 -324l-328 -347zM295 384l-17 -78h-221l17 78h75l55 261q-7 -7 -19.5 -15.5t-26.5 -16.5t-29 -13.5t-26 -5.5l17 80q15 0 32.5 8.5t33 19t26 19.5t10.5 10h80l-74 -347h67zM595 -5q-32 0 -58.5 8.5t-46 23.5t-30 35.5t-10.5 44.5 t8.5 42.5t23 32.5t33.5 25t39 19q-21 9 -35 25.5t-14 42.5q0 28 17 51.5t43 40t58 26t62 9.5q25 0 49.5 -7t43.5 -20t30.5 -31.5t11.5 -40.5q0 -35 -25 -59t-60 -37q26 -14 43.5 -35t17.5 -51q0 -31 -17 -57.5t-45 -46t-64.5 -30.5t-74.5 -11zM613 74q18 0 36.5 4.5t33.5 13 t24 20.5t9 27q0 23 -24 37t-56 14q-19 0 -37.5 -5t-33.5 -13.5t-24 -20.5t-9 -26q0 -24 25 -37.5t56 -13.5zM650 255q15 0 30 3.5t28 10t21 15.5t8 21q0 18 -20 29t-48 11q-16 0 -31.5 -3.5t-27.5 -10.5t-19.5 -16t-7.5 -21q0 -18 21 -28.5t46 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeeighths",
    unicode: "\u215C",
    horizAdvX: 876,
    d: "M193 298q-60 0 -97 20.5t-43 58.5l55 59q1 -7 7 -16.5t18 -18.5t30.5 -15.5t44.5 -6.5q21 0 40.5 3.5t34.5 11t24 18t9 24.5q0 26 -34.5 38t-95.5 12h-23l15 73h22q63 0 101.5 13.5t38.5 44.5q0 20 -22 30t-47 10q-38 0 -66.5 -13.5t-51.5 -35.5l-37 64q28 29 75 44 t95 15q63 0 102 -28.5t39 -71.5q0 -42 -30 -68.5t-82 -36.5q38 -6 59 -31t21 -58q0 -35 -18 -61.5t-46.5 -43.5t-64.5 -25.5t-73 -8.5zM103 47l337 329l319 342l49 -54l-329 -324l-328 -347zM603 -5q-32 0 -58.5 8.5t-46 23.5t-30 35.5t-10.5 44.5t8.5 42.5t23 32.5t33.5 25 t39 19q-21 9 -35 25.5t-14 42.5q0 28 17 51.5t43 40t58 26t62 9.5q25 0 49.5 -7t43.5 -20t30.5 -31.5t11.5 -40.5q0 -35 -25 -59t-60 -37q26 -14 43.5 -35t17.5 -51q0 -31 -17 -57.5t-45 -46t-64.5 -30.5t-74.5 -11zM621 74q18 0 36.5 4.5t33.5 13t24 20.5t9 27q0 23 -24 37 t-56 14q-19 0 -37.5 -5t-33.5 -13.5t-24 -20.5t-9 -26q0 -24 25 -37.5t56 -13.5zM658 255q15 0 30 3.5t28 10t21 15.5t8 21q0 18 -20 29t-48 11q-16 0 -31.5 -3.5t-27.5 -10.5t-19.5 -16t-7.5 -21q0 -18 21 -28.5t46 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveeighths",
    unicode: "\u215D",
    horizAdvX: 886,
    d: "M265 582q60 0 95.5 -31.5t35.5 -81.5q0 -36 -16.5 -66t-45 -52.5t-66.5 -35t-80 -12.5q-50 0 -87 19.5t-52 52.5l59 53q14 -23 40 -35.5t61 -12.5q42 0 73.5 20.5t31.5 61.5q0 31 -21.5 45.5t-45.5 14.5q-25 0 -52 -12.5t-43 -32.5h-69q11 27 25.5 61t30 68.5t29.5 67 t23 56.5h232l-17 -79h-174l-41 -87q12 8 30.5 13t43.5 5zM102 47l337 329l319 342l49 -54l-329 -324l-328 -347zM612 -5q-32 0 -58.5 8.5t-46 23.5t-30 35.5t-10.5 44.5t8.5 42.5t23 32.5t33.5 25t39 19q-21 9 -35 25.5t-14 42.5q0 28 17 51.5t43 40t58 26t62 9.5 q25 0 49.5 -7t43.5 -20t30.5 -31.5t11.5 -40.5q0 -35 -25 -59t-60 -37q26 -14 43.5 -35t17.5 -51q0 -31 -17 -57.5t-45 -46t-64.5 -30.5t-74.5 -11zM630 74q18 0 36.5 4.5t33.5 13t24 20.5t9 27q0 23 -24 37t-56 14q-19 0 -37.5 -5t-33.5 -13.5t-24 -20.5t-9 -26 q0 -24 25 -37.5t56 -13.5zM667 255q15 0 30 3.5t28 10t21 15.5t8 21q0 18 -20 29t-48 11q-16 0 -31.5 -3.5t-27.5 -10.5t-19.5 -16t-7.5 -21q0 -18 21 -28.5t46 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveneighths",
    unicode: "\u215E",
    horizAdvX: 855,
    d: "M32 47l337 329l319 342l49 -54l-329 -324l-328 -347zM584 -5q-32 0 -58.5 8.5t-46 23.5t-30 35.5t-10.5 44.5t8.5 42.5t23 32.5t33.5 25t39 19q-21 9 -35 25.5t-14 42.5q0 28 17 51.5t43 40t58 26t62 9.5q25 0 49.5 -7t43.5 -20t30.5 -31.5t11.5 -40.5q0 -35 -25 -59 t-60 -37q26 -14 43.5 -35t17.5 -51q0 -31 -17 -57.5t-45 -46t-64.5 -30.5t-74.5 -11zM602 74q18 0 36.5 4.5t33.5 13t24 20.5t9 27q0 23 -24 37t-56 14q-19 0 -37.5 -5t-33.5 -13.5t-24 -20.5t-9 -26q0 -24 25 -37.5t56 -13.5zM639 255q15 0 30 3.5t28 10t21 15.5t8 21 q0 18 -20 29t-48 11q-16 0 -31.5 -3.5t-27.5 -10.5t-19.5 -16t-7.5 -21q0 -18 21 -28.5t46 -10.5zM340 651h-226l17 79h349l-326 -420h-89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "partialdiff",
    unicode: "\u2202",
    horizAdvX: 570,
    d: "M254 -10q-51 0 -93.5 16t-73 44.5t-48 66.5t-17.5 83q0 49 21 92.5t56.5 75.5t82 51t96.5 19q47 0 81 -17.5t51 -49.5q0 11 0.5 21t0.5 19q0 104 -33 148.5t-91 44.5q-32 0 -64.5 -11t-51.5 -30l-74 78q38 35 90 54.5t111 19.5q115 0 176 -79.5t61 -245.5 q0 -96 -20 -170.5t-57 -125.5t-89 -77.5t-115 -26.5zM261 94q26 0 49.5 11t41.5 29t29 42t11 51q0 47 -32 78t-79 31q-26 0 -49.5 -10t-41.5 -27.5t-28.5 -41t-10.5 -50.5q0 -24 8.5 -44.5t23.5 -35.5t35 -24t43 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Delta",
    unicode: "\u2206",
    horizAdvX: 663,
    d: "M615 104v-104h-615v104l252 606h112zM478 121l-170 436l-168 -436h338z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "product",
    unicode: "\u220F",
    horizAdvX: 767,
    d: "M523 594h-241v-684h-130v684h-80v116h661v-116h-80v-684h-130v684z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "summation",
    unicode: "\u2211",
    d: "M557 607h-318v-4l181 -234l-197 -249v-4h342v-116h-495v91l214 265l-207 267v87h480v-103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    horizAdvX: 550,
    d: "M77 274v107h404v-107h-404z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2215",
    unicode: "\u2215",
    horizAdvX: 599,
    d: "M-62 56l684 662l63 -64l-684 -661z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2219",
    unicode: "\u2219",
    horizAdvX: 224,
    d: "M44 242l32 151h110l-32 -151h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "radical",
    unicode: "\u221A",
    horizAdvX: 490,
    d: "M15 379h198l67 -279l112 690h120l-152 -790h-161l-82 285h-102v94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "infinity",
    unicode: "\u221E",
    horizAdvX: 720,
    d: "M221 535q30 0 52.5 -7t40 -19t31 -27.5t25.5 -33.5q12 18 25.5 33.5t31 27.5t40 19t52.5 7q39 0 70 -14.5t52.5 -40t33.5 -59t12 -70.5q0 -38 -13 -71.5t-35.5 -58t-53.5 -39t-67 -14.5q-57 0 -90 23t-56 55q-11 -16 -24 -30t-31 -24.5t-41.5 -17t-54.5 -6.5 q-32 0 -62.5 14.5t-54 40t-38 58.5t-14.5 71t13 71.5t35.5 58t53.5 39t67 14.5zM230 270q37 0 59 23.5t40 56.5q-18 34 -39.5 58t-59.5 24q-14 0 -27.5 -4.5t-24 -14t-17.5 -24.5t-7 -37t7 -37.5t17.5 -25.5t24 -14.5t27.5 -4.5zM510 270q28 0 52 19t24 63q0 43 -24 61.5 t-52 18.5q-20 0 -34.5 -7t-25.5 -18.5t-19.5 -27t-16.5 -33.5q17 -32 38 -54t58 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "integral",
    unicode: "\u222B",
    horizAdvX: 359,
    d: "M105 616q0 10 -1 25.5t-2 30t-1.5 26t-0.5 13.5q0 51 33 80t94 29q29 0 65 -7.5t64 -19.5l-23 -96q-12 5 -25.5 9t-24.5 4q-24 0 -38 -11.5t-14 -34.5q0 -3 0.5 -11t1 -18.5t1.5 -22t1 -19.5l31 -556q0 -9 0.5 -23t1 -27.5t1 -23.5t0.5 -11q0 -58 -32.5 -88.5 t-92.5 -30.5q-30 0 -65.5 7.5t-63.5 19.5l23 96q13 -5 25.5 -9t23.5 -4q25 0 38.5 15t13.5 41l-0.5 8t-1 18l-1 20t-0.5 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    horizAdvX: 455,
    d: "M393 357q-14 -26 -40 -47t-66 -21q-23 0 -40 7t-32 15.5t-29 15.5t-30 7q-20 0 -30 -7.5t-15 -17.5l-61 44q14 26 38 46t63 20q23 0 39.5 -7.5t31 -16t29 -16t32.5 -7.5q20 0 32 8t18 17zM393 199q-14 -24 -40 -44.5t-66 -20.5q-23 0 -40 7t-32 15t-29 15t-30 7 q-20 0 -30 -7.5t-15 -16.5l-61 44q14 25 38 45.5t63 20.5q23 0 39.5 -7.5t31 -16t29 -16t32.5 -7.5q20 0 32 7.5t18 17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    horizAdvX: 475,
    d: "M75 404h188l63 125l51 -27l-50 -98h61v-87h-105l-42 -82h147v-87h-191l-62 -122l-50 26l48 96h-58v87h102l42 82h-144v87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    horizAdvX: 477,
    d: "M50 28v108h353v-108h-353zM51 436l350 165v-128l-200 -80l200 -74v-130l-350 155v92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    horizAdvX: 503,
    d: "M79 136h353v-108h-353v108zM81 319l200 74l-200 80v128l350 -165v-92l-350 -155v130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lozenge",
    unicode: "\u25CA",
    horizAdvX: 565,
    d: "M370 730l186 -364l-186 -366h-148l-186 366l186 364h148zM437 354l-142 280l-131 -259l140 -283z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "commaaccent",
    unicode: "\uF6C3",
    horizAdvX: 196,
    d: "M25 -213l43 72h-40l21 94h112l-19 -94l-56 -72h-61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s_t",
    unicode: "\uFB06",
    horizAdvX: 830,
    d: "M187 -10q-31 0 -62.5 5.5t-60 14.5t-52.5 21.5t-42 27.5l70 91q79 -64 162 -64q39 0 67 16t28 48q0 14 -6.5 23.5t-18.5 16t-30 12t-42 11.5q-36 10 -64 19.5t-47 23t-29 33.5t-10 50q0 44 20.5 80t53 61.5t73 39.5t81.5 14q24 0 58 -6.5t59 -25.5q-8 29 -8 59 q0 34 11.5 66t37.5 57t67.5 39.5t101.5 14.5q40 0 66.5 -7t42.5 -20.5t22.5 -32.5t6.5 -44q0 -23 -4 -50.5t-11 -59.5h104l-22 -103h-104l-54 -256q-2 -5 -2 -8.5v-6.5q0 -20 10 -28t28 -8q19 0 40.5 7t35.5 12v-106q-30 -12 -71 -24t-80 -12q-47 0 -78 21t-31 71 q0 10 2 22.5t5 26.5l61 289h-65l22 103h65q6 32 9.5 56t3.5 42q0 31 -12.5 43.5t-41.5 12.5q-55 0 -82 -34.5t-27 -83.5q0 -28 7 -53.5t14 -35.5l-70 -84q-35 29 -67 40.5t-61 11.5q-37 0 -65 -16t-28 -51q0 -32 25 -42.5t77 -21.5q37 -8 65 -18t46.5 -24t28 -34.5 t9.5 -49.5q0 -44 -19 -79.5t-51.5 -60.5t-75.5 -38.5t-92 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A.sc",
    horizAdvX: 573,
    d: "M295 559h99l111 -559h-127l-24 131h-201l-79 -131h-129zM348 236l-35 176l-111 -176h146z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B.sc",
    horizAdvX: 576,
    d: "M122 559h316q26 0 46 -10t33.5 -26.5t20 -38t6.5 -43.5q0 -24 -8 -47t-23 -43.5t-36 -37t-47 -26.5q39 -12 60.5 -41t21.5 -72q0 -44 -18.5 -76.5t-50 -54t-72.5 -32.5t-85 -11h-282zM307 102q33 0 59 22.5t26 55.5q0 23 -14 39t-37 16h-167l-28 -133h161zM339 330 q31 0 55 19t24 57q0 23 -13.5 36t-34.5 13h-149l-27 -125h145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C.sc",
    horizAdvX: 570,
    d: "M247 -5q-53 0 -95 20.5t-70.5 54t-43.5 77t-15 89.5q0 57 26 115.5t72.5 105t110.5 76t140 29.5q79 0 130 -33.5t67 -88.5l-106 -65q-5 23 -17.5 38t-28.5 24t-34.5 13t-36.5 4q-46 0 -82.5 -19.5t-62.5 -49.5t-40 -67t-14 -73q0 -29 8.5 -54.5t24.5 -45t39.5 -31 t54.5 -11.5q37 0 79.5 18.5t70.5 62.5l87 -59q-20 -31 -51 -55.5t-66.5 -41t-73.5 -25t-73 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D.sc",
    horizAdvX: 613,
    d: "M122 559h217q61 0 106.5 -17.5t75.5 -47.5t44.5 -70.5t14.5 -86.5q0 -74 -27.5 -135.5t-75.5 -106.5t-113.5 -70t-142.5 -25h-217zM243 106q49 0 88 17t66.5 46t42.5 67.5t15 81.5q0 60 -35 97.5t-103 37.5h-97l-74 -347h97z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E.sc",
    horizAdvX: 516,
    d: "M122 559h405l-22 -106h-285l-25 -119h246l-21 -99h-245l-29 -129h292l-22 -106h-412z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F.sc",
    horizAdvX: 495,
    d: "M122 559h399l-23 -106h-278l-27 -130h231l-21 -99h-231l-48 -224h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G.alt",
    horizAdvX: 692,
    d: "M302 -5q-63 0 -112 24.5t-83 65.5t-51.5 95t-17.5 113q0 78 32 153.5t88 135t131 96.5t162 37q86 0 144 -39.5t82 -109.5l-128 -86q-4 15 -12.5 34.5t-24 37t-39 29.5t-57.5 12q-52 0 -95.5 -27t-75.5 -69.5t-50 -95t-18 -103.5q0 -34 8 -66.5t25 -58t43 -41t62 -15.5 q31 0 61 11.5t55.5 31t46 44t32.5 51.5h-142l25 120h292l-16 -67q-15 -63 -49.5 -120t-83 -100t-108.5 -68t-126 -25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G.sc",
    horizAdvX: 597,
    d: "M403 58q-40 -32 -80.5 -47t-82.5 -15q-49 0 -88.5 19.5t-68 52t-44 75.5t-15.5 91q0 66 28.5 125.5t76.5 105t110 72t130 26.5q78 0 128.5 -33t67.5 -89l-106 -68q-11 39 -43 60.5t-75 21.5q-40 0 -75 -17.5t-61.5 -47t-42 -68t-15.5 -80.5q0 -30 8.5 -55t25 -43.5 t40 -29t52.5 -10.5q38 0 77.5 18t77.5 53l6 27h-117l19 88h217l-62 -290h-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H.sc",
    horizAdvX: 636,
    d: "M122 559h121l-47 -220h259l47 220h121l-119 -559h-121l50 232h-259l-50 -232h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I.sc",
    horizAdvX: 256,
    d: "M122 559h121l-119 -559h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J.sc",
    horizAdvX: 428,
    d: "M80 -8q-77 0 -122 33l49 99q9 -8 34.5 -16.5t60.5 -8.5q34 0 56.5 10.5t37.5 32t25 55t20 78.5l61 284h120l-60 -284q-14 -64 -32 -116.5t-49 -89.5t-79.5 -57t-121.5 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K.sc",
    horizAdvX: 573,
    d: "M122 559h121l-56 -261l304 261h126l-278 -249l174 -310h-128l-133 242l-92 -74l-36 -168h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L.sc",
    horizAdvX: 465,
    d: "M122 559h121l-97 -453h268l-23 -106h-387z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron.alt",
    horizAdvX: 245,
    d: "M39 611l77 119h123l-119 -145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M.sc",
    horizAdvX: 733,
    d: "M122 559h131l105 -302l233 302h130l-119 -559h-121l75 349l-201 -256h-65l-92 256l-74 -349h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N.sc",
    horizAdvX: 649,
    d: "M122 559h94l227 -344l73 344h120l-119 -559h-97l-225 335l-71 -335h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O.sc",
    horizAdvX: 629,
    d: "M249 -4q-54 0 -96 19.5t-71 52.5t-44 75.5t-15 88.5q0 63 28.5 122.5t77 105.5t111.5 74t132 28q54 0 96 -20t70.5 -53t43.5 -75.5t15 -88.5q0 -63 -28.5 -122t-76.5 -105t-111 -74t-132 -28zM273 103q45 0 82 19.5t63 50t40.5 68t14.5 73.5q0 28 -8 53.5t-24 44.5 t-39.5 30.5t-54.5 11.5q-45 0 -81.5 -19t-63 -49t-41 -67.5t-14.5 -74.5q0 -28 8 -53.5t23.5 -45t39 -31t55.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P.sc",
    horizAdvX: 535,
    d: "M122 559h251q36 0 65 -13.5t48.5 -35.5t30 -51t10.5 -59q0 -40 -18 -79t-49 -69.5t-73 -49.5t-89 -19h-135l-39 -183h-120zM313 289q18 0 34 7t28.5 19.5t20 31t7.5 41.5q0 32 -17.5 48.5t-42.5 16.5h-123l-35 -164h128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q.sc",
    horizAdvX: 630,
    d: "M405 36q-36 -19 -75.5 -29.5t-81.5 -10.5q-54 0 -96 19.5t-71 52.5t-44 75.5t-15 88.5q0 63 29 122.5t77 106t111 74.5t132 28q54 0 96 -20t70.5 -53t43.5 -76t15 -89q0 -66 -31 -127.5t-83 -108.5l64 -89h-115zM273 104q40 0 73 15l-69 96h115l28 -39q25 30 39 66.5 t14 72.5q0 28 -8 53t-24 44.5t-39.5 31t-54.5 11.5q-45 0 -82 -19t-63.5 -49.5t-41 -68t-14.5 -74.5q0 -28 8 -53t23.5 -44.5t39.5 -31t56 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R.sc",
    horizAdvX: 575,
    d: "M122 559h263q36 0 65 -13.5t48.5 -35.5t30 -51t10.5 -59t-10.5 -59t-29.5 -54t-45 -45.5t-57 -32.5l94 -209h-137l-84 183h-107l-39 -183h-120zM325 289q17 0 33.5 7.5t29 21t20 31.5t7.5 38q0 29 -17 47.5t-43 18.5h-135l-35 -164h140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S.sc",
    horizAdvX: 516,
    d: "M203 -7q-64 0 -124 19t-103 52l75 105q7 -10 23 -22t39.5 -22t53 -16.5t62.5 -6.5q45 0 69 15t24 43q0 14 -9.5 23.5t-26.5 17t-40.5 14.5t-51.5 16q-65 20 -97.5 48t-32.5 78q0 49 21 87.5t56 64.5t80.5 40t94.5 14q60 0 108.5 -19t80.5 -43l-73 -99q-6 7 -19 16.5 t-32 17.5t-42.5 14t-48.5 6q-48 0 -71.5 -16.5t-23.5 -45.5q0 -25 29 -37t83 -27q34 -10 62 -21.5t48 -27t30.5 -37t10.5 -51.5q0 -54 -22 -92t-57.5 -62t-81.5 -35t-94 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T.sc",
    horizAdvX: 529,
    d: "M237 453h-187l22 106h493l-22 -106h-185l-97 -453h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U.sc",
    horizAdvX: 627,
    d: "M249 -4q-56 0 -95 15t-63.5 41t-35.5 62t-11 77q0 40 9 82l60 286h121l-60 -286q-3 -15 -5 -29.5t-2 -28.5q0 -47 23.5 -79.5t81.5 -32.5q39 0 68 14.5t49.5 38.5t33.5 54.5t20 62.5l60 286h121l-60 -286q-12 -58 -37.5 -108.5t-64.5 -88t-92.5 -59t-120.5 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V.sc",
    horizAdvX: 571,
    d: "M56 559h128l72 -389l234 389h128l-348 -559h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W.alt",
    horizAdvX: 1059,
    d: "M91 710h155l34 -504l256 504h150l45 -503l247 503h156l-362 -710h-143l-66 485l-269 -485h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W.sc",
    horizAdvX: 888,
    d: "M55 559h131l81 -414l96 155l-45 257h112l26 -181l104 181h112l-155 -257l32 -155l256 414h132l-359 -559h-101l-53 225l-147 -225h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X.sc",
    horizAdvX: 554,
    d: "M208 276l-150 283h132l100 -198l184 198h131l-269 -283l144 -276h-131l-95 190l-175 -190h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y.sc",
    horizAdvX: 547,
    d: "M186 194l-134 365h131l85 -261l198 261h132l-291 -366l-42 -193h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z.sc",
    horizAdvX: 538,
    d: "M-12 91l403 362h-316l23 106h457l-20 -91l-392 -362h318l-23 -106h-469z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.alt",
    horizAdvX: 613,
    d: "M201 -10q-44 0 -78.5 16.5t-58.5 45.5t-36.5 68t-12.5 85q0 66 24 125.5t64 104.5t92 71.5t108 26.5q55 0 92.5 -27.5t51.5 -74.5l19 86h134l-110 -517h-134l18 85q-33 -45 -76 -70t-97 -25zM259 104q41 0 75.5 24t61.5 64l27 124q-7 46 -34.5 74.5t-67.5 28.5 q-32 0 -61.5 -17t-52.5 -44.5t-37 -62t-14 -69.5q0 -52 27.5 -87t75.5 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.alt2",
    horizAdvX: 544,
    d: "M130 -10q-32 0 -57.5 10.5t-44 28.5t-28.5 43t-10 54q0 47 21 84t56.5 62.5t81 39t94.5 13.5q38 0 67.5 -7t46.5 -16l7 30q3 18 3 32q0 36 -22 56t-67 20q-40 0 -81 -15t-88 -44l-22 85q54 32 109.5 49.5t114.5 17.5q94 0 142 -41t48 -116q0 -14 -1.5 -28.5t-5.5 -30.5 l-67 -317h-129l15 73q-37 -42 -84 -62.5t-99 -20.5zM189 88q27 0 57.5 11t53.5 33q11 9 18.5 18.5t9.5 19.5l13 60q-21 10 -45 15t-47 5t-45.5 -6t-40.5 -18.5t-29.5 -30.5t-11.5 -42q0 -29 19 -47t48 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c_t",
    horizAdvX: 910,
    d: "M228 -10q-53 0 -92.5 18t-66.5 48t-40.5 70t-13.5 84q0 60 23.5 118t67 103.5t104.5 73.5t136 28q46 0 74.5 -10t54.5 -30q-4 12 -6.5 29t-2.5 32q0 84 55 134t158 50q43 0 71 -8.5t44 -23t22.5 -34.5t6.5 -44q0 -23 -4.5 -49.5t-10.5 -54.5h104l-22 -103h-104l-54 -256 q-2 -5 -2 -8.5v-7.5q0 -19 10.5 -27t27.5 -8q19 0 40.5 6.5t35.5 12.5v-106q-29 -12 -69.5 -24t-81.5 -12q-47 0 -78 21.5t-31 70.5q0 20 4 37l64 301h-64l22 103h64q6 27 9.5 50t3.5 41q0 31 -13 47t-47 16q-30 0 -50.5 -12t-32.5 -31.5t-17.5 -44.5t-5.5 -50 q0 -19 2.5 -40t6 -40t7 -35t5.5 -26l-139 -40q-21 60 -87 60q-32 0 -61.5 -16t-52 -43t-35.5 -62t-13 -72q0 -53 26.5 -87.5t71.5 -34.5q29 0 61.5 16.5t50.5 45.5l122 -40q-41 -62 -109 -99t-149 -37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d.alt",
    horizAdvX: 612,
    d: "M201 -10q-44 0 -78.5 16.5t-58.5 45.5t-36.5 68.5t-12.5 84.5q0 65 23.5 124.5t63 104.5t91.5 72t108 27t92.5 -28t52.5 -73l64 298h134l-155 -730h-134l17 82q-33 -44 -76 -68t-95 -24zM260 104q18 0 37.5 6.5t38 18.5t34 28t26.5 35l26 125q-3 22 -12 41t-23 32.5 t-31.5 21t-36.5 7.5q-32 0 -61.5 -17t-52 -44t-36 -61.5t-13.5 -69.5q0 -53 28 -88t76 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.lnum",
    horizAdvX: 583,
    d: "M522 242q0 -55 -25 -101t-67 -79.5t-95.5 -52t-110.5 -18.5q-44 0 -81.5 13.5t-64.5 38.5t-42 59t-15 75q0 39 13.5 71t34.5 57.5t46.5 44t48.5 30.5q-26 14 -41.5 43.5t-15.5 64.5q0 52 26 93.5t66 70t87.5 43.5t90.5 15q35 0 69 -10.5t61 -31.5t43.5 -51.5t16.5 -70.5 q0 -29 -10 -54.5t-26.5 -47t-37.5 -38t-43 -26.5q29 -18 50.5 -54t21.5 -84zM386 238q0 41 -26.5 63.5t-64.5 22.5q-25 0 -49 -9.5t-43 -26t-30.5 -39.5t-11.5 -50q0 -39 26.5 -63t63.5 -24q24 0 48.5 9.5t43.5 26.5t31 40t12 50zM243 494q0 -34 23 -51.5t51 -17.5 q18 0 37.5 6.5t35.5 19.5t26.5 31t10.5 42q0 31 -21.5 49t-53.5 18q-21 0 -40.5 -7t-34.5 -20t-24.5 -31t-9.5 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.lnum",
    horizAdvX: 547,
    d: "M191 -10q-74 0 -125.5 33t-70.5 91l94 80q18 -39 51.5 -62t75.5 -23q29 0 54.5 11t45 30.5t30.5 45.5t11 57q0 41 -22 66t-60 25q-30 0 -59 -15t-50 -41h-116q9 20 22.5 55t29.5 76.5t33.5 85.5t33.5 84.5t28.5 72t19.5 48.5h334l-27 -122h-236l-59 -159q14 14 36 22 t53 8q41 0 74 -13.5t56.5 -37.5t36.5 -58t13 -74q0 -62 -25 -114t-67 -90.5t-97.5 -60t-117.5 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.numerator",
    horizAdvX: 382,
    d: "M256 582q60 0 95.5 -31.5t35.5 -81.5q0 -36 -16.5 -66t-45 -52.5t-66.5 -35t-80 -12.5q-50 0 -87 19.5t-52 52.5l59 53q14 -23 40 -35.5t61 -12.5q42 0 73.5 20.5t31.5 61.5q0 31 -21.5 45.5t-45.5 14.5q-25 0 -52 -12.5t-43 -32.5h-69q11 27 25.5 61t30 68.5t29.5 67 t23 56.5h232l-17 -79h-174l-41 -87q12 8 30.5 13t43.5 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.denominator",
    horizAdvX: 407,
    d: "M138 -5q-32 0 -58.5 8.5t-46 23.5t-30 35.5t-10.5 44.5t8.5 42.5t23 32.5t33.5 25t39 19q-21 9 -35 25.5t-14 42.5q0 28 17 51.5t43 40t58 26t62 9.5q25 0 49.5 -7t43.5 -20t30.5 -31.5t11.5 -40.5q0 -35 -25 -59t-60 -37q26 -14 43.5 -35t17.5 -51q0 -31 -17 -57.5 t-45 -46t-64.5 -30.5t-74.5 -11zM156 74q18 0 36.5 4.5t33.5 13t24 20.5t9 27q0 23 -24 37t-56 14q-19 0 -37.5 -5t-33.5 -13.5t-24 -20.5t-9 -26q0 -24 25 -37.5t56 -13.5zM193 255q15 0 30 3.5t28 10t21 15.5t8 21q0 18 -20 29t-48 11q-16 0 -31.5 -3.5t-27.5 -10.5 t-19.5 -16t-7.5 -21q0 -18 21 -28.5t46 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.lnum",
    horizAdvX: 563,
    d: "M243 0l34 161h-280l26 120l412 429h92l-91 -428h84l-25 -121h-84l-34 -161h-134zM317 282l49 226l-208 -226h159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j.alt",
    horizAdvX: 253,
    d: "M106 517h134l-155 -730h-134zM150 726h134l-28 -129h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l.alt",
    horizAdvX: 259,
    d: "M153 730h134l-155 -730h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.lnum",
    horizAdvX: 592,
    d: "M72 426q0 58 25.5 110.5t68 92.5t97.5 63t115 23q93 0 143 -62t50 -172q0 -101 -26.5 -190t-74 -156t-113.5 -106t-146 -39q-64 0 -111.5 29.5t-74.5 83.5l95 84q14 -38 45 -59t72 -21q62 0 109.5 53t70.5 150q-28 -36 -68 -57t-86 -21q-43 0 -78.5 15t-60.5 41 t-38.5 61.5t-13.5 76.5zM354 603q-28 0 -55 -13t-48 -35t-34 -50.5t-13 -59.5q0 -45 26 -75.5t68 -30.5q28 0 55 12.5t48 33.5t34 49t13 59q0 22 -7 42t-19.5 35t-29.5 24t-38 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.lnum",
    horizAdvX: 474,
    d: "M26 121h132l98 462q-10 -12 -31 -26.5t-46 -28t-50.5 -22.5t-44.5 -9l26 124q25 0 55.5 14.5t56.5 32t43.5 32.5t18.5 17h137l-126 -596h120l-25 -121h-390z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.numerator",
    horizAdvX: 289,
    d: "M286 384l-17 -78h-221l17 78h75l55 261q-7 -7 -19.5 -15.5t-26.5 -16.5t-29 -13.5t-26 -5.5l17 80q15 0 32.5 8.5t33 19t26 19.5t10.5 10h80l-74 -347h67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.denominator",
    horizAdvX: 407,
    d: "M-33 0q9 41 21.5 71.5t32 53.5t47 40.5t66.5 32.5q26 10 52 19.5t47 21t34 27t13 38.5q0 22 -18 33.5t-51 11.5q-42 0 -74.5 -16.5t-52.5 -33.5l-38 58q10 10 28 22t42.5 22.5t55.5 17.5t67 7q66 0 99.5 -28t33.5 -77q0 -35 -12 -61t-33 -44.5t-49.5 -32t-61.5 -23.5 q-50 -16 -74 -37.5t-29 -44.5h210l-17 -78h-339v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.denominator",
    horizAdvX: 395,
    d: "M187 93h-209l16 77l288 252h54l-54 -251h59l-17 -78h-58l-20 -93h-78zM207 171l32 153l-168 -153h136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.denominator",
    horizAdvX: 392,
    d: "M119 -5q-60 0 -97.5 20t-42.5 59l55 58q1 -6 7 -16t18 -19.5t30.5 -16t44.5 -6.5q43 0 75 15t32 43q0 26 -34 38t-95 12h-23l15 72h22q62 0 101 14t39 45q0 20 -22.5 30t-46.5 10q-38 0 -66.5 -13.5t-51.5 -35.5l-37 63q28 29 75 44.5t95 15.5q63 0 102 -28.5t39 -71.5 q0 -42 -30 -69t-82 -36q39 -6 59.5 -31t20.5 -58q0 -36 -18 -62t-46.5 -43t-64.5 -25t-73 -8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q.alt",
    horizAdvX: 611,
    d: "M373 92q-38 -51 -86.5 -76.5t-103.5 -25.5q-40 0 -71 16.5t-52.5 45t-33 67t-11.5 83.5q0 68 25 128t66.5 105t95.5 71.5t111 26.5t95 -27.5t55 -72.5l19 91h117l-156 -737h-134zM257 104q39 0 73.5 24t63.5 62l27 124q-2 22 -10.5 41t-22 33.5t-31 22.5t-36.5 8 q-32 0 -62 -16.5t-53 -43.5t-37 -62t-14 -72q0 -52 27 -86.5t75 -34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.lnum",
    horizAdvX: 546,
    d: "M394 588h-301l27 122h511l-486 -710h-151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.numerator",
    horizAdvX: 375,
    d: "M323 651h-226l17 79h349l-326 -420h-89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.lnum",
    horizAdvX: 592,
    d: "M236 -10q-93 0 -143 62.5t-50 171.5q0 101 26.5 190.5t74 156t114 105.5t146.5 39q63 0 111 -29t74 -83l-94 -84q-15 38 -46 59t-72 21q-61 0 -109 -53t-71 -150q28 36 68 57t86 21q43 0 78.5 -15t60.5 -41t38.5 -61.5t13.5 -76.5q0 -59 -25.5 -111.5t-68 -92t-97.5 -63 t-115 -23.5zM261 103q27 0 54 13t48.5 35t34.5 50.5t13 59.5q0 45 -26 75.5t-68 30.5q-28 0 -55 -12.5t-48 -33.5t-34 -49t-13 -59q0 -46 26 -78t68 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t.alt",
    horizAdvX: 373,
    d: "M123 403h-75l26 121h74l36 170h138l-36 -170h115l-25 -121h-116l-85 -403h-138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.lnum",
    horizAdvX: 561,
    d: "M194 -9q-83 0 -132.5 36t-59.5 103l90 88q1 -15 7 -33.5t20.5 -34t37.5 -26t57 -10.5q28 0 54 7.5t45.5 22t31.5 34t12 43.5q0 46 -43.5 67.5t-128.5 21.5h-31l23 112h32q41 0 77 6.5t62.5 20t41.5 34t15 47.5q0 38 -24 54.5t-56 16.5q-27 0 -51 -7.5t-44.5 -19.5 t-36 -26.5t-24.5 -27.5l-66 97q22 24 51.5 43t62.5 32t67.5 20t67.5 7q45 0 82 -12.5t63.5 -34.5t40.5 -53t14 -67q0 -66 -44 -114t-119 -65q51 -10 79 -50.5t28 -97.5q0 -58 -27.5 -102t-71 -73t-97.5 -44t-106 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.numerator",
    horizAdvX: 392,
    d: "M183 298q-60 0 -97 20.5t-43 58.5l55 59q1 -7 7 -16.5t18 -18.5t30.5 -15.5t44.5 -6.5q21 0 40.5 3.5t34.5 11t24 18t9 24.5q0 26 -34.5 38t-95.5 12h-23l15 73h22q63 0 101.5 13.5t38.5 44.5q0 20 -22 30t-47 10q-38 0 -66.5 -13.5t-51.5 -35.5l-37 64q28 29 75 44 t95 15q63 0 102 -28.5t39 -71.5q0 -42 -30 -68.5t-82 -36.5q38 -6 59 -31t21 -58q0 -35 -18 -61.5t-46.5 -43.5t-64.5 -25.5t-73 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.lnum",
    horizAdvX: 587,
    d: "M-21 0q15 69 34 120.5t47.5 90.5t67.5 68t94 54q38 18 75 34t66.5 37t47.5 49t18 69q0 35 -19.5 55.5t-57.5 20.5q-26 0 -51 -8t-48 -20.5t-43.5 -27.5t-35.5 -29l-65 88q17 16 45 36.5t65 38.5t81.5 30.5t94.5 12.5q94 0 141.5 -47.5t47.5 -123.5q0 -56 -15.5 -96 t-44 -71t-68 -55t-86.5 -46q-75 -36 -119 -71.5t-55 -87.5h302l-25 -121h-494v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.numerator",
    horizAdvX: 403,
    d: "M32 305q9 41 21.5 71.5t32 53.5t47 40.5t65.5 32.5q27 10 53 19.5t47 21t34 27t13 38.5q0 21 -18 33t-51 12q-42 0 -74.5 -16t-53.5 -33l-37 57q10 10 27.5 22t42.5 22.5t55.5 17.5t66.5 7q66 0 100 -28t34 -78q0 -35 -12.5 -60.5t-33.5 -44.5t-49.5 -32.5t-61.5 -23.5 q-49 -15 -73.5 -36.5t-29.5 -44.5h198l-17 -78h-326z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u.alt",
    horizAdvX: 584,
    d: "M153 -10q-69 0 -100 34t-31 94q0 18 2.5 37.5t7.5 40.5l70 328h133l-63 -299q-6 -29 -6 -51q0 -32 14.5 -51t48.5 -19q35 0 72 25t68 70l69 325h134l-111 -524h-129l19 90q-38 -51 -91 -75.5t-107 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w.alt",
    horizAdvX: 833,
    d: "M54 524h138l34 -364l172 364h127l17 -364l188 364h138l-282 -524h-150l-19 316l-159 -316h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y.alt",
    horizAdvX: 520,
    d: "M7 -213q8 13 21 35t29.5 50t35.5 61t40 67l-84 524h143l39 -408l201 408h125l-395 -737h-155v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.lnum",
    horizAdvX: 676,
    d: "M272 -10q-60 0 -103 26t-71 67t-41 92.5t-13 102.5q0 74 30 150.5t82 139t121 102.5t147 40q60 0 103.5 -26.5t71 -68t40.5 -93.5t13 -103q0 -74 -30 -150t-81.5 -138t-121 -101.5t-147.5 -39.5zM297 112q49 0 89 30.5t68 75.5t43 97.5t15 96.5q0 33 -6.5 64.5 t-20.5 56.5t-35 40t-51 15q-51 0 -90.5 -32.5t-67.5 -80.5t-42.5 -102.5t-14.5 -99.5q0 -32 6.5 -61t20 -51.5t35 -35.5t51.5 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotbelow",
    horizAdvX: 216,
    d: "M6 -196l27 126h120l-27 -126h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.denominator",
    horizAdvX: 470,
    d: "M171 -5q-43 0 -74 16t-51 41t-29.5 56.5t-9.5 62.5q0 43 20 87.5t54.5 80.5t81 59t99.5 23q42 0 72.5 -16t50 -41.5t29 -57.5t9.5 -63q0 -43 -19.5 -87t-53.5 -80t-80 -58.5t-99 -22.5zM187 74q36 0 65 16t48.5 39.5t30 51.5t10.5 52q0 20 -5.5 39.5t-17.5 35t-30.5 25 t-43.5 9.5q-36 0 -65 -16t-48.5 -40t-30 -52t-10.5 -52q0 -20 5.5 -39.5t17.5 -34.5t30 -24.5t44 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.denominator",
    horizAdvX: 322,
    d: "M0 78h92l56 262q-8 -7 -22 -16t-31.5 -16.5t-35 -13t-30.5 -5.5l17 79q18 0 38.5 8.5t38.5 19t30.5 19.5t12.5 10h80l-74 -347h85l-16 -78h-258z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.denominator",
    horizAdvX: 382,
    d: "M114 -5q-51 0 -88 19t-51 52l58 53q14 -23 40 -36t61 -13q42 0 74 21.5t32 62.5q0 30 -21.5 44.5t-46.5 14.5t-52 -12.5t-43 -32.5h-69q11 27 26 61t30 68.5t29.5 67.5t23.5 57h231l-17 -80h-174l-41 -87q12 8 31 13t43 5q60 0 95.5 -31t35.5 -82q0 -36 -16.5 -66 t-45 -52t-66 -34.5t-79.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.denominator",
    horizAdvX: 412,
    d: "M145 -5q-66 0 -102 38.5t-36 108.5q0 60 17.5 112t49.5 90t76 59.5t98 21.5q44 0 78 -16.5t51 -48.5l-58 -55q-11 21 -35 32.5t-56 11.5q-48 0 -83 -28t-47 -80q19 20 51.5 30t61.5 10q66 0 103.5 -33.5t37.5 -84.5q0 -34 -17 -64.5t-45.5 -53.5t-66 -36.5t-78.5 -13.5z M162 67q22 0 42 7t36 18t25.5 26t9.5 32q0 26 -23 44t-59 18q-22 0 -42.5 -6.5t-36.5 -17.5t-25.5 -25.5t-9.5 -30.5q0 -27 24 -46t59 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.denominator",
    horizAdvX: 376,
    d: "M258 342h-226l17 80h350l-327 -422h-89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.denominator",
    horizAdvX: 413,
    d: "M127 -5q-45 0 -79 16t-52 48l59 55q11 -21 35 -32.5t56 -11.5q48 0 83 28t47 80q-19 -19 -51 -30t-62 -11q-66 0 -104 34t-38 85q0 34 17 65t45.5 54t66.5 36.5t79 13.5q66 0 102 -39.5t36 -108.5q0 -60 -17.5 -112t-49 -89.5t-75.5 -59t-98 -21.5zM182 207 q21 0 41.5 6.5t36 17.5t25 25.5t9.5 30.5q0 26 -23.5 45.5t-58.5 19.5q-22 0 -42.5 -7t-36 -18.5t-25 -26.5t-9.5 -31q0 -26 23.5 -44t59.5 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.numerator",
    horizAdvX: 471,
    d: "M237 303q-43 0 -74 16t-51 41t-29.5 56.5t-9.5 63.5q0 43 19.5 87.5t54 80.5t81 59t99.5 23q43 0 73.5 -16.5t50 -42t29 -57t9.5 -62.5q0 -43 -19.5 -87t-53.5 -80t-80 -59t-99 -23zM156 490q0 -20 5.5 -39t17.5 -34t30 -24.5t44 -9.5q36 0 65 16t48.5 39.5t30 51.5 t10.5 52q0 20 -5.5 39.5t-17.5 35t-30.5 25t-43.5 9.5q-36 0 -65 -16t-48.5 -40t-30 -52.5t-10.5 -52.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.numerator",
    horizAdvX: 396,
    d: "M234 310l19 91h-209l16 78l287 251h55l-54 -251h59l-17 -78h-58l-20 -91h-78zM137 479h136l32 154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.numerator",
    horizAdvX: 413,
    d: "M418 468q0 -35 -17 -65.5t-45.5 -53.5t-66.5 -36.5t-79 -13.5q-66 0 -102 39t-36 109q0 60 17.5 112t49 90t76 59.5t97.5 21.5q44 0 78.5 -16.5t51.5 -47.5l-58 -56q-11 21 -35 33t-56 12q-48 0 -83 -28.5t-47 -80.5q19 20 51 30t61 10q33 0 59.5 -9t45 -25t28.5 -37.5 t10 -46.5zM227 372q22 0 42.5 7t36.5 18t25.5 26t9.5 32q0 26 -23.5 44t-59.5 18q-22 0 -42.5 -6.5t-36.5 -17.5t-25.5 -25.5t-9.5 -30.5q0 -27 24 -46t59 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.numerator",
    horizAdvX: 407,
    d: "M404 449q0 -31 -17 -58t-45 -46.5t-64 -30.5t-74 -11q-32 0 -59 8.5t-46 24t-29.5 36t-10.5 44.5t8.5 42t23 32.5t33.5 25t39 18.5q-21 9 -35 26t-14 43q0 28 17 51.5t43 40t58 26t62 9.5q25 0 49.5 -7t43 -20t30 -31.5t11.5 -40.5q0 -35 -25 -59t-60 -38 q27 -13 44 -34.5t17 -50.5zM325 447q0 24 -24.5 38t-55.5 14q-20 0 -38.5 -5t-33 -13.5t-23.5 -20.5t-9 -26q0 -24 25 -37.5t56 -13.5q19 0 37.5 4.5t33 13t23.5 20.5t9 26zM192 604q0 -20 21 -30t46 -10q14 0 29.5 3.5t28 9.5t21 15.5t8.5 21.5q0 19 -20 29.5t-48 10.5 q-33 0 -59.5 -13.5t-26.5 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.numerator",
    horizAdvX: 413,
    d: "M86 561q0 34 17 65t45.5 54t66 36.5t79.5 13.5q65 0 101.5 -39.5t36.5 -108.5q0 -60 -17.5 -112t-49 -90t-76 -59.5t-97.5 -21.5q-45 0 -79 17t-51 48l58 55q11 -21 35 -33t56 -12q48 0 83 29t47 80q-19 -19 -51 -29.5t-63 -10.5q-65 0 -103 33.5t-38 84.5zM277 657 q-22 0 -42.5 -7t-36.5 -18.5t-25.5 -26.5t-9.5 -31q0 -26 24 -44t59 -18q22 0 42.5 6.5t36.5 17.5t25.5 25.5t9.5 30.5q0 26 -24 45.5t-59 19.5z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "y.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "w.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "Y.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "W.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "W.alt",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "V.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "T.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "J.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "A.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0142",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "v",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "X",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u012B",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0129",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "$",
    u2: "7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "T.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0166",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "V",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u012B",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0129",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "zero.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "six.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "four.lnum",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "U.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u018F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u012B",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0129",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xF0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "(",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ")",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "J.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "A.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0259",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u012B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0129",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xF0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "two.lnum",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "seven.lnum",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "one.lnum",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "4",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "3",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "1",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0166",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0166",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "zero.lnum",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "six.lnum",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "four.lnum",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "five.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "S.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "J.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "A.sc",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u018F",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u012B",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0129",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "5",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "4",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "2",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "0",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "/",
    k: 256
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    g2: "W.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\xB0",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\\\\\\\\",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "V",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "7",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    g2: "W.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xD7",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xB0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\\\\\\\\",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "X",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "+",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    g2: "W.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\xB0",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\\\\\\\\",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    g2: "W.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\xB0",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\\\\\\\\",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    g2: "W.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u2212",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\xB0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\\\\\\\\",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "+",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u2212",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\xF7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\xD7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\xB7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "V",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "=",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "+",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u2212",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xF7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xB7",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xA2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "=",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "5",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "4",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "/",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "+",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "V",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    g2: "W.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\xB0",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\\\\\\\\",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "7",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ":",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    g2: "seven.lnum",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    u2: "7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    u2: "3",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "y.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "Y.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "W.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "W.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "V.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "T.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "v",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "V",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0142",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "W.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "J.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u02BC",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0166",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "V",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u0131",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u012B",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u0129",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "w.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "t.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "Z.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "Y.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "X.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "W.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "V.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "U.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "T.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "S.sc",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "J.sc",
    k: 118
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "A.sc",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u02BC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0259",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u018F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0142",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0131",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u012B",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0129",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF0",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "x",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "@",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "7",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "5",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "4",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "1",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "/",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: " ",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u012B",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0129",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "J.sc",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "A.sc",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u02BC",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "X",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "4",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "/",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: " ",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f_l",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f_i",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_i",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0159",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0131",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u012B",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0129",
    k: -48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xDF",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "w.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "U.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "S.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "J.sc",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "A.sc",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u02BC",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0259",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u018F",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0159",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0131",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u012B",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0129",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF0",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xAE",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xA9",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "x",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "@",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "9",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "8",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "6",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "5",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "4",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "3",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "2",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "1",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "0",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "/",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "&",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: " ",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0159",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0131",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u012B",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0129",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "y.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "w.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "U.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u2122",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u02BC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0259",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u018F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u012B",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0129",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF0",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "v",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\\\\\\\\",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: " ",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u1EF9",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0177",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0159",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0131",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u012B",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0129",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u012B",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u0129",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u012B",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "zero.lnum",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "y.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "w.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "six.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "Y.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "W.sc",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "W.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "V.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "U.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "T.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u018F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0166",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "v",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "V",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\xD0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "d",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\xD0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u012D",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u012B",
    k: -101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0129",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEF",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEC",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "W",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u0135",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "j",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\xD0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\xD0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "j",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "W",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "\xD0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "u",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "W.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u02BC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0259",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xD0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "X",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ")",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: " ",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\xD0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u02BC",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0259",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF0",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\xD0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "z",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u012B",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "y.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "w.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "Y.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "W.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "W.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "V.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "U.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "T.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0166",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0142",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0141",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0135",
    k: -120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0110",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\xD0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "v",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "j",
    k: -112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA1",
    u2: "V",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA3",
    g2: "four.lnum",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "y.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "w.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "Y.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "W.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "W.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "V.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "T.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\u0141",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\u0135",
    k: -123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\u0110",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\xD0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "j",
    k: -115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "V",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\u0166",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    g2: "four.lnum",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "9",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "5",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "4",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "3",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    g2: "seven.lnum",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "7",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "4",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "3",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u0166",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u0141",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u0110",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\xD0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "y.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "w.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "t.alt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "l.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "Z.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "Y.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "X.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "W.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "W.alt",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "V.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "U.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "T.sc",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "S.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "J.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "A.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0259",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u018F",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0166",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0142",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0141",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0135",
    k: -90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u012F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0126",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0110",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\xF0",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\xD0",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "x",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "v",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "j",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "X",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "V",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC6",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC8",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC9",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCA",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCB",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    g2: "seven.lnum",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    u2: "7",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    u2: "3",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    u2: "1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0166",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "W.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "A.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u2122",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\\\\\\\\",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "X",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "V",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "?",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "*",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: ")",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "w.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "t.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "W.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\u2122",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\xD0",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\xA6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "|",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "x",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "v",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "X",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "V",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\xD0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: " ",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "W.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "\xD0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "|",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "x",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "v",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "X",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "?",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "*",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    g2: "seven.lnum",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "7",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "4",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "3",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\xD0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "j",
    k: -80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "j",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2122",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u201D",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2019",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u0133",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xFE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xDF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xA6",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "}",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "|",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "k",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "i",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "h",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "b",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "]",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\\\\\\\\",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "*",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: ")",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0112",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0114",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0116",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0118",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011A",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011C",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011D",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011E",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011F",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0120",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0121",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0122",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0123",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "q.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "d.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "a.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0121",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "q",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "g",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "d",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "a",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u2122",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\xA6",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "}",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "|",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "]",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\\\\\\\\",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: ")",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\xA6",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "|",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\\\\\\\\",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "*",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: ")",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012F",
    u2: "j",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0133",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0133",
    u2: "j",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "j",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "\u012B",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013C",
    u2: "j",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "w.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "q.alt",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "d.alt",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "a.alt",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xE1",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xA6",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "}",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "|",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "y",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "w",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "q",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "g",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "d",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "a",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "]",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\\\\\\\\",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "/",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: ")",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    g2: "y.alt",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "y",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "x",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014A",
    u2: "j",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014B",
    u2: "j",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0152",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\xD0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: " ",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015C",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f_l",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f_i",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_i",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\xDF",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0163",
    u2: "j",
    k: -121
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f_l",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f_i",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_i",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\xDF",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "y.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "w.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "u.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "q.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "d.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "a.alt2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "a.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Z.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Y.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "X.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "W.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "V.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "U.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "S.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "R.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Q.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "P.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "O.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "N.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "M.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "L.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "K.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "I.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "H.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "G.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "G.alt",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "F.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "E.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "D.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "C.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "B.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "A.sc",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\uFB06",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "f_l",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "f_i",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u203A",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2039",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2014",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2013",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u1ECC",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01FE",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01F4",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u018F",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0153",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0152",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0150",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u014E",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u014C",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0122",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0120",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u011E",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u011C",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u010C",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u010A",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0108",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0106",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xF0",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xE6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD8",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD6",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD5",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD4",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD3",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD2",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC7",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xBB",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAD",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAB",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xA9",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "z",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "y",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "x",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "w",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "u",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "s",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "r",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "q",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "p",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "o",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "n",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "m",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "g",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "e",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "d",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "c",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "a",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "Q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "O",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "G",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "C",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ";",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ":",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "/",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "-",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0168",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0168",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0168",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016A",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016A",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016A",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016C",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016C",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016C",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016E",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016E",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016E",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0170",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0170",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0170",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0172",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0172",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0172",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0173",
    u2: "j",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\u012B",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F4",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F5",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FC",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FD",
    u2: " ",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0166",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0218",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f_l",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f_i",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_i",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    u2: "\xDF",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021B",
    u2: "j",
    k: -48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "y.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "w.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "t.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "l.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "Z.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "Y.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "X.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "W.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "V.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "U.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "T.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "S.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "J.sc",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "A.sc",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "x",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "v",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E62",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\xDF",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6D",
    u2: "j",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB8",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBC",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECA",
    u2: "j",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECB",
    u2: "j",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE4",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE4",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE4",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u012B",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u012B",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0129",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0166",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u012B",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u012B",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u0129",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0166",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0166",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u0166",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u0141",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u0110",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\xD0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u20AC",
    g2: "seven.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u20AC",
    g2: "four.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    g2: "J.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    g2: "A.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    u2: "\u012B",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    u2: "\u0129",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    g2: "seven.lnum",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    g2: "one.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "7",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "4",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "3",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u0149",
    k: -125
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u012D",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u012B",
    k: -89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u0129",
    k: -65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\xEF",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\xEC",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_i",
    u2: "\u0149",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_i",
    u2: "\u012B",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_l",
    u2: "\u0149",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f_i",
    u2: "\u0149",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f_i",
    u2: "\u012B",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f_l",
    u2: "\u0149",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "Y.sc",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "W.sc",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "V.sc",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "U.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "T.sc",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "S.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u2122",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u2120",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u02BC",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xBA",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xAE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xAA",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xA9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xA6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "|",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\\\\\\\\",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "V",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "?",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "*",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: " ",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "Y.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "X.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "W.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "V.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "T.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "A.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\u2122",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\u02BC",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\xA6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "|",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\\\\\\\\",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "?",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "*",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "Y.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "W.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "V.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "T.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "A.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\u2122",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\u02BC",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\xA6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "|",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\\\\\\\\",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "V",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "*",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Z.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Y.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "X.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "W.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "V.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "T.sc",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "J.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "A.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\u2122",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\u2120",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\u02BC",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\xA6",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "|",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\\\\\\\\",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "X",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "*",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "S.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    u2: "\u02BC",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "S.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "J.sc",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "A.sc",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "\u02BC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "X",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "/",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: " ",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "y.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "J.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "A.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u2122",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u02BC",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u0166",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "v",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "X",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "/",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "*",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "Y.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "W.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "V.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "T.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\u2122",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\u02BC",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\xA6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "|",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\\\\\\\\",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "V",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "?",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "*",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "J.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "A.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "\\\\\\\\",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "V",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    u2: "\u02BC",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    u2: " ",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "Y.sc",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "W.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "V.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "U.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "T.sc",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "S.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u2122",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u2120",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u02BC",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xBA",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xB7",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xAE",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xAA",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xA9",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xA6",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "|",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\\\\\\\\",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "V",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "?",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "*",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: " ",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Z.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Y.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "X.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "W.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "V.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "T.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "J.sc",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "A.sc",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "\u02BC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "\\\\\\\\",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "*",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: ")",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: " ",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.sc",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "Y.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "W.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "V.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "T.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "A.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\u2122",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\u02BC",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\xA6",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "|",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\\\\\\\\",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "?",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "*",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "Y.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "W.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "V.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "T.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "A.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\u2122",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\u02BC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\xA6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "|",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\\\\\\\\",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "V",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "?",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "*",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "J.sc",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "A.sc",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "\u02BC",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "@",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "/",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: " ",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "J.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "A.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "X",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "S.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "J.sc",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "A.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "@",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "/",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: " ",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "S.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "J.sc",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "A.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u02BC",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0259",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u018F",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0159",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0131",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u012B",
    k: -48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0129",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xF0",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xDF",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xAE",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xA9",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "@",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "9",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "8",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "6",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "5",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "4",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "3",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "2",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "/",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "&",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: " ",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "S.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "J.sc",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "A.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "@",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "/",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: " ",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    u2: "\u02BC",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "S.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "J.sc",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "A.sc",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "@",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "/",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: ")",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "&",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: " ",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    u2: "\u02BC",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "w.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\u2122",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\u02BC",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\xA6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "|",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\\\\\\\\",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "V",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "?",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "*",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    u2: "\u02BC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j.alt",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j.alt",
    u2: "j",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    u2: "\u02BC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    g2: "seven.lnum",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    u2: "/",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "zero.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "four.lnum",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "\u2212",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "\xD7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "+",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "q.alt",
    u2: "j",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "zero.lnum",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "six.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "seven.lnum",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "four.lnum",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "five.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\u2212",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xF7",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xD7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xB7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xA2",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\\\\\\\\",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "/",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "+",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "#",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.numerator",
    u2: "\u2044",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\u02BC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\u0259",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\xF0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "V",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "/",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: " ",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lnum",
    g2: "four.lnum",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\u02BC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\u0259",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\xF0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "X",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "/",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: " ",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\u02BC",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\u0259",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\xF0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "X",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "V",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "/",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: " ",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    g2: "seven.lnum",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    g2: "one.lnum",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: "\xB0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: "\\\\\\\\",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: "/",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "ae,aeacute,a.alt2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ae,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "T.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "U.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "V",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "V.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Y.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ampersand",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "apostrophe",
    k: 121
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "asterisk",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "at",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "backslash",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "bar",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "brokenbar",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "copyright",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "eight",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "eth",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "guillemotleft,guilsinglleft",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ordfeminine",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ordmasculine",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "question",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quoteleft,quotedblleft",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quoteright,quotedblright",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quotedbl,quotesingle",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "registered",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "schwa",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "seven",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "six",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "space",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "t.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "trademark",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "w.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "y.alt",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "zero",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "servicemark",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Schwa",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "J,Jcircumflex",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "apostrophe",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "V",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "W.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "apostrophe",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "asterisk",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "backslash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "quoteleft,quotedblleft",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "quoteright,quotedblright",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "quotedbl,quotesingle",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "trademark",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "J,Jcircumflex",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "A.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "AE,AEacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "J.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "slash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "X",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "parenright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "x",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "ae,aeacute,a.alt2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "T.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "U.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "V.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "W.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "Y.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "apostrophe",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "eth",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "guillemotleft,guilsinglleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "schwa",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "seven",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "w.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "y.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "Schwa",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "ae,aeacute,a.alt2",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "guillemotleft,guilsinglleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "J,Jcircumflex",
    k: 156
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "AE,AEacute",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "colon,semicolon",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "guillemotright,guilsinglright",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "apostrophe",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "v",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "y.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "quoteleft,quotedblleft",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "quoteright,quotedblright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "quotedbl,quotesingle",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "J,Jcircumflex",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "AE,AEacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "apostrophe",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "eth",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "t.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "apostrophe",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "eth",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "J,Jcircumflex",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "A.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "J.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "slash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "U.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "V.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "W.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "Y.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "apostrophe",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "copyright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "eth",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "registered",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "space",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "w.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "y.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "zero",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "Schwa",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "ae,aeacute,a.alt2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "T.sc",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "U.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "V",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "V.sc",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W.alt",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W.sc",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Y.sc",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "apostrophe",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "asterisk",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "backslash",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "bar",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "brokenbar",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "copyright",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "eth",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "guillemotleft,guilsinglleft",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "ordfeminine",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "ordmasculine",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "question",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quoteleft,quotedblleft",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quoteright,quotedblright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quotedbl,quotesingle",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "registered",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "schwa",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "seven",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "six",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "space",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "trademark",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "v",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "w.alt",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "y.alt",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "zero",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "servicemark",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Schwa",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "AE,AEacute",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "guillemotright,guilsinglright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "periodcentered",
    k: 156
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "W.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "apostrophe",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "asterisk",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "backslash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "quoteleft,quotedblleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "quoteright,quotedblright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "quotedbl,quotesingle",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "trademark",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "J,Jcircumflex",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "A.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "AE,AEacute",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "J.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "slash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "X",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "parenright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "x",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "ae,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "J,Jcircumflex",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "AE,AEacute",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "ae,aeacute,a.alt2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "V",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "apostrophe",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "eth",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "l.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "T.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "V.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "W.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "Y.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "apostrophe",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "ordfeminine",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "seven",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "v",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "ae,aeacute,a.alt2",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "T.sc",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "U.sc",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "V.sc",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "W.sc",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Y.sc",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "apostrophe",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "at",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "copyright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "eth",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "registered",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "schwa",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "seven",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "six",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "space",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "v",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "w.alt",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "y.alt",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "zero",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Schwa",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "J,Jcircumflex",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "A.sc",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "AE,AEacute",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "J.sc",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "slash",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "x",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "colon,semicolon",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "guillemotright,guilsinglright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "S.sc",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "X.sc",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Z.sc",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "five",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "four",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "nine",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "one",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "three",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "two",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quoteleft,quotedblleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quoteright,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quotedbl,quotesingle",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "J,Jcircumflex",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "ae,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "apostrophe",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "eth",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "J,Jcircumflex",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "A.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "AE,AEacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "J.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "slash",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "l.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "four",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "ae,aeacute,a.alt2",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "guillemotleft,guilsinglleft",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "J,Jcircumflex",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "AE,AEacute",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "colon,semicolon",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "guillemotright,guilsinglright",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "ae,aeacute,a.alt2",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "U.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "ampersand",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "apostrophe",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "at",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "copyright",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "eight",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "eth",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotleft,guilsinglleft",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "registered",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "schwa",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "six",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "space",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "w.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "zero",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "Schwa",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "J,Jcircumflex",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A.sc",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "AE,AEacute",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "J.sc",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "slash",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "x",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "colon,semicolon",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotright,guilsinglright",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "five",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "four",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "nine",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "one",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "three",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "two",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "ae,aeacute,a.alt2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "J,Jcircumflex",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "AE,AEacute",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "guillemotright,guilsinglright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "ae,aeacute,a.alt2",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "U.sc",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "V.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "W.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "Y.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "ampersand",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "apostrophe",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "at",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "copyright",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "eight",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "eth",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "guillemotleft,guilsinglleft",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "registered",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "schwa",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "six",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "space",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "v",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "w.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "y.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "zero",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "Schwa",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "J,Jcircumflex",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "A.sc",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "AE,AEacute",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "J.sc",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "slash",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "x",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "colon,semicolon",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "guillemotright,guilsinglright",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "S.sc",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "X.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "Z.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "five",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "four",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "nine",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "one",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "three",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "two",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "apostrophe",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "eth",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "zero",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "Schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "apostrophe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "backslash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "bar",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "question",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "V",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "W.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "apostrophe",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "backslash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "bar",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "question",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quoteleft,quotedblleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quoteright,quotedblright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quotedbl,quotesingle",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "V",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "W.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "apostrophe",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "asterisk",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "backslash",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "bar",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "brokenbar",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "ordmasculine",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "question",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quoteleft,quotedblleft",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quoteright,quotedblright",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quotedbl,quotesingle",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "t.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "trademark",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "w.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "y.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "servicemark",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "J,Jcircumflex",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "X",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "parenright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "V",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "W.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "apostrophe",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "asterisk",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "backslash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "bar",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "brokenbar",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "eth",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "guillemotleft,guilsinglleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "question",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quoteleft,quotedblleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quotedbl,quotesingle",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "trademark",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "v",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "w.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "y.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "apostrophe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "V",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "W.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "apostrophe",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "asterisk",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "backslash",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "bar",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "brokenbar",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "question",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quoteleft,quotedblleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quotedbl,quotesingle",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "t.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "trademark",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "w.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "y.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "x",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "J,Jcircumflex",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "ae,aeacute,a.alt2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "V",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "W.alt",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "apostrophe",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "backslash",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "bar",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "brokenbar",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "eth",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "guillemotleft,guilsinglleft",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "schwa",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "space",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "trademark",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "J,Jcircumflex",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "AE,AEacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "slash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "X",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "parenright",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "guillemotright,guilsinglright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "V",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "W.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "apostrophe",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "asterisk",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "backslash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "bar",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "brokenbar",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "question",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quoteleft,quotedblleft",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quoteright,quotedblright",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quotedbl,quotesingle",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "trademark",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "w.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "y.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "servicemark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,f_i,f_f_i,j.alt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,f_i,f_f_i,j.alt",
    g2: "apostrophe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "ae,aeacute,a.alt2",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "W.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "apostrophe",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "asterisk",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "backslash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "question",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "quoteleft,quotedblleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "quoteright,quotedblright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "v",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "w.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "V",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "apostrophe",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "asterisk",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "bar",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "brokenbar",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "copyright",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "eth",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "guillemotleft,guilsinglleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "ordfeminine",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "ordmasculine",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "question",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quoteleft,quotedblleft",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quoteright,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quotedbl,quotesingle",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "registered",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "space",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "trademark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "w.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "y.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "servicemark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "AE,AEacute",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "guillemotright,guilsinglright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "periodcentered",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "V",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "W.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "apostrophe",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "asterisk",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "backslash",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "bar",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "brokenbar",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "question",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quoteleft,quotedblleft",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quoteright,quotedblright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quotedbl,quotesingle",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "t.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "trademark",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "y.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "V",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "W.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "apostrophe",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "asterisk",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "backslash",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "bar",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "brokenbar",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "ordmasculine",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "question",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quoteleft,quotedblleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quoteright,quotedblright",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quotedbl,quotesingle",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "trademark",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "v",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "w.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "y.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "servicemark",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "J,Jcircumflex",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "X",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "x",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "ae,aeacute,a.alt2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "apostrophe",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "eth",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "schwa",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "space",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "J,Jcircumflex",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "AE,AEacute",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "slash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "guillemotright,guilsinglright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "W.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "apostrophe",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "asterisk",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "backslash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "bar",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "brokenbar",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "question",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "quoteleft,quotedblleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "quoteright,quotedblright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "quotedbl,quotesingle",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "trademark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "w.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "y.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "V",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "apostrophe",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "eth",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "ae,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "J,Jcircumflex",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "AE,AEacute",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "guillemotright,guilsinglright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "apostrophe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "backslash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "bar",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "question",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "ae,aeacute,a.alt2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "guillemotleft,guilsinglleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "J,Jcircumflex",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "AE,AEacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "ae,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "apostrophe",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "eth",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "schwa",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "space",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "J,Jcircumflex",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "AE,AEacute",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "slash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "X",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "parenright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "ae,aeacute,a.alt2",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "J,Jcircumflex",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "AE,AEacute",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "ae,aeacute,a.alt2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "guillemotleft,guilsinglleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "ae,aeacute,a.alt2",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "apostrophe",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "eth",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "space",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "J,Jcircumflex",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "AE,AEacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "slash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "X",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "parenright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "ae,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "J,Jcircumflex",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "AE,AEacute",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "apostrophe",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "eth",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quoteleft,quotedblleft",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quoteright,quotedblright",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quotedbl,quotesingle",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "quoteright,quotedblright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "quotedbl,quotesingle",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "quoteleft,quotedblleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quoteleft,quotedblleft",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quoteright,quotedblright",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quotedbl,quotesingle",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "J,Jcircumflex",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "J,Jcircumflex",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "AE,AEacute",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "guillemotright,guilsinglright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quoteleft,quotedblleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quoteright,quotedblright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quotedbl,quotesingle",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "V",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "apostrophe",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "backslash",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "question",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quoteleft,quotedblleft",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quoteright,quotedblright",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quotedbl,quotesingle",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "guillemotright,guilsinglright",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "T.sc",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "V",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "V.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "W.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Y.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "apostrophe",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "asterisk",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "backslash",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "bar",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "brokenbar",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "question",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quoteleft,quotedblleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quoteright,quotedblright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quotedbl,quotesingle",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "trademark",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "servicemark",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "J,Jcircumflex",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "A.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "J.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "X",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "parenright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "X.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Z.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "quoteleft,quotedblleft",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "quoteright,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "quotedbl,quotesingle",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "J,Jcircumflex",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "AE,AEacute",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "quoteright,quotedblright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "quotedbl,quotesingle",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "quoteleft,quotedblleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "quoteright,quotedblright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "quotedbl,quotesingle",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "J,Jcircumflex",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "AE,AEacute",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "guillemotright,guilsinglright",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "J,Jcircumflex",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "J,Jcircumflex",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "AE,AEacute",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "J,Jcircumflex",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "AE,AEacute",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "J,Jcircumflex",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "AE,AEacute",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "guillemotright,guilsinglright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "periodcentered",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "ae,aeacute,a.alt2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "J,Jcircumflex",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "AE,AEacute",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "quoteright,quotedblright",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "quotedbl,quotesingle",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "ae,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "J,Jcircumflex",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "AE,AEacute",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "quoteright,quotedblright",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "quotedbl,quotesingle",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "quoteright,quotedblright",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "quotedbl,quotesingle",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "AE,AEacute",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "quoteright,quotedblright",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "quotedbl,quotesingle",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "AE,AEacute",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "quoteright,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "quotedbl,quotesingle",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "AE,AEacute",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "exclamdown",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "exclamdown",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "quotedbl,quotesingle",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "T.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "V",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "V.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "Y.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "quoteright,quotedblright",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "quotedbl,quotesingle",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "T.sc",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "V",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "V.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W.alt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Y.sc",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "quoteright,quotedblright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "quotedbl,quotesingle",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "t.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "w.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "y.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "J,Jcircumflex",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "A.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "J.sc",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "x",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "X.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Z.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "T.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "V.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Y.sc",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "quoteright,quotedblright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "quotedbl,quotesingle",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "seven",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "w.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "y.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "J,Jcircumflex",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "A.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "J.sc",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "X",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "x",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "X.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Z.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "four",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "one",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "three",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "one.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "seven.lnum",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "quotedbl,quotesingle",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "quotedbl,quotesingle",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "AE,AEacute",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "T.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "U.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "V",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "V.sc",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W.alt",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W.sc",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Y.sc",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quoteleft,quotedblleft",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quoteright,quotedblright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quotedbl,quotesingle",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "seven",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "six",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "w.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "y.alt",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Schwa",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "four.lnum",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "nine.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "six.lnum",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "zero.lnum",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "ae,aeacute,a.alt2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "J,Jcircumflex",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "AE,AEacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "ae,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "eth",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "J,Jcircumflex",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "AE,AEacute",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "J.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "ae,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "at",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "eth",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "guillemotleft,guilsinglleft",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "space",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "J,Jcircumflex",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "A.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "AE,AEacute",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "J.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "slash",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "guillemotright,guilsinglright",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "ae,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "at",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "eth",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "guillemotleft,guilsinglleft",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "space",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "J,Jcircumflex",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "A.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "AE,AEacute",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "J.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "slash",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "guillemotright,guilsinglright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "five",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "four",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "nine",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "three",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "four.lnum",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "J,Jcircumflex",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "AE,AEacute",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "quoteright,quotedblright",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "quotedbl,quotesingle",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "J,Jcircumflex",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "AE,AEacute",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "quotedbl,quotesingle",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "AE,AEacute",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "AE,AEacute",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "quotedbl,quotesingle",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "J,Jcircumflex",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "AE,AEacute",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "AE,AEacute",
    k: -12
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRalewayBoldItalic);
export default __webpack_public_path__ + "static/media/Raleway-BoldItalic.6a2d9bf0dcc76ec8fb62ec97ada08159.svg";
export { ForwardRef as ReactComponent };